import { emit, on, BUS_EVENTS } from './bus.js';
import { effortConfig, calcJobHcUnits, blockHours } from './config.js';
import { architectureState, upgradeScope, expandedComponentRows, sites, hypervisorMigrationScopes, vb365RepoMigrationScopes, vbrRepoMigrationScopes,
         workloadPickerUiState, siteScopePickerUiState, defaultStep2CollapseState,
         existingEnvironmentFieldSchema, existingEnvironmentFieldSchemaByKey,
         existingEnvironmentCountFieldOrder,
         existingEnvironmentFieldLabels,
         AppState, defaultToggleState, defaultProtectionState } from './state.js';
import { unstructuredDataWorkloadId, repoMigrationWorkloadId, kastenK10WorkloadId,
         veeamBackupForMicrosoft365WorkloadId, legacyWorkloadValueAliases,
         hypervisorLabels, cloudLabels, saasLabels, containerLabels, pluginLabels,
         pluginFullLabels, unstructuredDataLabels, sourceWorkloadLabels, agentLabels,
         agentVersionOptions, getAgentVersionOptions, getDefaultAgentVersion,
         veeamOneOptionLabels, implementationModeLabels, getImplementationModeLabel,
         architectureOptionLabels, tapeConnectivityTypeLabels,
         workloadOptionGroups, jobTypeOptions, sureBackupAllowedWorkloads,
         replicationAllowedWorkloads, cdpAllowedWorkloads, backupCopyExcludedWorkloads,
         getJobTypeDef, getJobWorkloadDef, stripWorkloadUnitSuffix,
         inDevelopmentWorkloadStatusLabel, inDevelopmentWorkloadValues,
         vb365RepoTypeOptions } from './workload-defs.js';
import { buildFormulaDebugPanelMarkup, buildBlockTablesMarkup, buildLiveCalculatorMarkup } from './formula-debug.js';
import { escapeHtml, isUnstructuredDataWorkload, isRepoMigrationWorkload,
         isProtectedTbWorkload, isNamespaceScopedWorkload, isUserScopedWorkload,
         isVb365ManagedWorkload, isVbfCloudManagedWorkload, getVbfCloudProvider,
         CLOUD_PROVIDER_CONFIGS, normalizeWorkloadValue, getWorkloadQuantityLabel,
         getWorkloadQuantityPlaceholder, getWorkloadQuantitySummary,
         normalizeProtectedTb, calculateUnstructuredDataInstances,
         formatProtectedTbValue, formatProtectedTbWholeNumber,
         normalizeEnvironmentCount, normalizeToggleMigratedCount } from './utils.js';
import { downloadJsonFile, buildExportFilename, generateSowMarkup } from './sow.js';
import {
         updateSavePdfVisibility, getAppBuildInfo, getExistingEnvironmentFieldDefinition, getExistingEnvironmentPrimaryParentField,
         resetUpgradeScope, createJobId, createUnprotectedWorkloadId,
         normalizeWorkloadIdentifier, hasSelectedWorkloadValue, isInDevelopmentWorkloadValue,
         getSiteWorkloadPickerTriggerSelector, parseWorkloadPickerKey, isActiveElementWithinWorkloadPicker,
         getSiteScopePickerTriggerSelector, getRepoMigrationPickerOptionLabel, isExistingEnvironmentFieldAvailableForEngagement,
         normalizeSiteName, getDefaultSiteName, normalizeWorkloadCustomLabel,
         getRoundedProtectedTbSummary,
         getRepoMigrationWorkloads, getRepoMigrationWorkloadProtectedTb, describeRepoMigrationSelectionGaps, updateDerivedInstancePreview,
         getExistingEnvironmentIconMarkup, getSiteNamePlaceholder, renderEmptyOutput, renderOutputMessage,
         clearStepValidationMessage, showStepValidationMessage, getPersistentStorage, getRestorableCurrentStep, normalizeLocalScenarioName,
         setLocalScenarioStatus, updateThemeToggleLabel, toggleValue, hasExplicitVeeamOneChoice,
         getCanvasEngagementFlags, deriveEngagementType, inferSiteTopology,
         setSectionVisibility, resetStep2CollapseState, setCollapsibleSectionState, syncMigrationGroupVisibility,
         bindGroupToggleEvents, renderArchitectureChoiceGroup,
         syncSureReplicaControl, syncProtectionTileVisuals, getImplementationMode,
         getSiteById, getSiteIndexById, hasVbrAcrossAllSites, hasUnprotectedWorkloadsNeedingVbr,
         hasCloudWorkloads, updateWizardProgress, dismissStep3WarningDialog, updateAssumptionsRiskNotice,
         updateToggleLabel, triggerCloneSheepAnimation, syncCloneSheepAnimations,
         buildGfAddSiteCardMarkup, destroyGreenfieldSortables,
         buildSiteListContentMarkup, applyStaggeredReveal,
         handleCategoryAdjustInput, handlePhaseStepperClick,
         syncImplementationModeLabels, buildWorkloadEntry,
         buildDefaultSourceWorkloadEntry, buildDefaultRepositoryEntry,
         } from './helpers.js';
import {
    GF_SVG_ICONS,
    VEEAM_SERVER_TYPES,
    normalizeExistingEnvironmentToggle,
    hasExistingEnvironmentFieldValue,
    clearExistingEnvironmentDependentFields,
    enforceExistingEnvironmentDependencies,
    getAvailableExistingEnvironmentFields,
    createExistingEnvironmentSelectionState,
    normalizeExistingEnvironmentCustomLabel,
    normalizeExistingEnvironmentCustomLabels,
    normalizeExistingEnvironment,
    hasExistingEnvironment,
    pruneExistingEnvironmentCustomLabels,
    getWorkloadScopeCount,
    hasMeaningfulWorkloadScope,
    getSiteDisplayName,
    buildGfSiteCardMarkup,
    getRepoMigrationTotalProtectedTb,
    normalizeArchitectureState,
    buildArchitectureStateSnapshot,
    getSelectedVeeamOneOptions,
    getCanvasCompItems,
    buildAggregatedWorkloadData,
    needsNewVbrDeployment,
    scheduleRenderEstimate,
    renderEstimate,
    normalizeSiteForEngagement,
    GF_SVG_PLUS
} from './recalc.js';
import { STATE_SCHEMA_VERSION, sanitizeImportedState } from './state-io.js';
import { renderScopeMatrix, syncMatrixToHiddenInputs, step2MatrixState, isMatrixCellNA } from './scope-matrix.js';
import { renderStep2Canvas, resetStep2Canvas, autoAddLinkedVbrLanes, autoAddLinkedVb365Lanes, getS2UnassignedWorkloads, getS2AllUnprotectedWorkloads, getS2CloudUnassignedWorkloads, getS2CloudAllWorkloads, getS2Vb365UnassignedWorkloads, getS2Vb365Workloads, getS2Vb365BlocksNavigation, applyStep2CanvasState, step2VbrLanes as s2VbrLanes, step2CloudLanes, step2Vb365Lanes, workloadAssignments, s2NextLaneId } from './step2-canvas.js';
import { syncHypervisorMigrationSectionVisibility } from './hypervisor-migration.js';
import { syncVsaMigrationSectionVisibility } from './vsa-migration.js';
import { syncVb365RepoMigrationSectionVisibility } from './vb365-repo-migration.js';
import { syncVbrRepoMigrationSectionVisibility } from './vbr-repo-migration.js';
import { initGreenfieldSortables, initVaultSortables } from './greenfield-sortables.js';
import { syncExistingEnvironmentFromServers, addVeeamServerToSite, removeVeeamServerFromSite, updateVeeamServerField } from './veeam-server-architecture.js';
import { initSourceWorkloadPane, openSourceWorkloadPane, closeSourceWorkloadPane, isSourceWorkloadPaneOpen, getSourceWorkloadPaneState } from './source-workload-pane.js';
import {
    greenfieldPaletteGroups, vaultPaletteGroups,
    addPaletteWorkloadToSite, updatePaletteWorkloadLabel, updateVaultWorkloadCustomLabel,
    removePaletteWorkloadFromSite, updatePaletteWorkloadQty,
    wirePaletteTileEvents,
    getWorkloadRowId, getSiteWorkloadByRowId, getSiteWorkloadByIdentifier,
    siteHasOnlyInDevelopmentWorkloads, hasOnlyInDevelopmentWorkloads, hasPendingWorkloadSelection,
} from './palette.js';
import {
    buildSiteWorkloadPickerMarkup, syncWorkloadPickerPanelState, positionWorkloadPickerPortalPanel,
    syncAllWorkloadPickerStates, scheduleOpenWorkloadPickerPanelPosition,
    openWorkloadPicker, closeWorkloadPicker, toggleWorkloadPickerCategoryExpansion,
    resetWorkloadPickerState, pruneWorkloadPickerUiState, workloadPickerPlaceholderLabel,
    isWorkloadPickerOpen, setWorkloadPickerSearchQuery,
} from './workload-picker.js';
import {
    getExistingEnvironmentSiteScopePickerKey, getRepoMigrationSourceStoragePickerKey,
    getRepoMigrationRepositoryPickerKey, getRepoMigrationTargetPickerKey,
    repoMigrationSourceStorageOptions, repoMigrationRepositoryOptions, repoMigrationTargetOptions,
    pendingExistingEnvironmentSelectionKey,
    openSiteScopePicker, closeSiteScopePicker, syncAllSiteScopePickerStates,
    syncSiteScopePickerPanelState, scheduleOpenSiteScopePickerPanelPosition,
    pruneSiteScopePickerUiState, handleSiteScopePickerClick, handleSiteScopePickerKeydown,
    handleSiteScopePickerInput, handleSiteScopePickerFocusOut,
} from './site-scope-picker.js';
// job-canvas.js and unprotected-canvas.js imports removed in Phase 6.
// These modules are deprecated — source workloads replace jobs + unprotected workloads.
// Modules retained on disk until all downstream references are confirmed removed (Phase 6 cleanup).
import {
    closeJobServerPicker,
    getJobServerPickerState,
} from './job-canvas.js';
import {
    removeProtectedWorkloadFromSite, removeUncategorisedWorkloadFromSite,
} from './unprotected-canvas.js';
import { openGfDrawer, closeGfDrawer, openVaultStepDrawer, closeVaultStepDrawer,
         openVb365RepoStepDrawer, closeVb365RepoStepDrawer } from './gf-drawer.js';

// --- Save to PDF button logic ---
const savePdfBtn = document.getElementById('save-pdf-btn');
const savePdfRow = document.getElementById('save-pdf-row');
window.savePdfRow = savePdfRow;


if (savePdfBtn) {
    savePdfBtn.addEventListener('click', () => {
        window.print();
    });
}

// Statement of Work is now a view mode tab — no separate toggle button needed.



function applyBuildInfo() {
    const buildInfo = getAppBuildInfo();

    if (appVersion) {
        const commitSuffix = buildInfo.commit ? ` (${buildInfo.commit})` : '';
        appVersion.textContent = buildInfo.version + commitSuffix;
    }

}


const form = document.getElementById('estimator-form');
const output = document.getElementById('output');
window.output = output;
const appLayout = document.querySelector('.app-layout');
// workloadPickerPortalHost and siteScopePickerPortalHost created and window-bridged
// in workload-picker.js and site-scope-picker.js respectively.
const stepValidationMessage = document.getElementById('step-validation-message');
window.stepValidationMessage = stepValidationMessage;
const projectNameInput = document.getElementById('project-name');
const siteList = document.getElementById('site-list');
window.siteList = siteList;
const CLONE_SHEEP_ANIMATION_DURATION_MS = 2000;
window.CLONE_SHEEP_ANIMATION_DURATION_MS = CLONE_SHEEP_ANIMATION_DURATION_MS;
const activeCloneSheepAnimations = new Map();
window.activeCloneSheepAnimations = activeCloneSheepAnimations;

let sortableInstances = [];

// --- Formula Debug developer mode (triple-click version string to toggle) ---
function destroySortables() {
    sortableInstances.forEach((instance) => {
        try { instance.destroy(); } catch (_) { /* already destroyed */ }
    });
    sortableInstances = [];
    document.body.classList.remove('tile-dragging');
    // Also clean up greenfield sortables if they exist
    destroyGreenfieldSortables();
}

// §TABLE-DRAG
// ── Table Row Drag Helpers ────────────────────────────────────────────────────

function initSortable() {
    if (document.getElementById('vault-sites')) {
        // Vault migration canvas — use the vault sortable system.
        initVaultSortables();
    } else {
        // Unified canvas: always greenfield — use the greenfield sortable system.
        initGreenfieldSortables();
    }
}
const themeToggle = document.getElementById('theme-toggle');
window.themeToggle = themeToggle;
const veeamOneRequiredToggle = document.getElementById('veeam-one-required');
window.veeamOneRequiredToggle = veeamOneRequiredToggle;
const designOptionFields = document.getElementById('design-option-fields');
const architectureCardHost = document.getElementById('architecture-card-host');
const step3ViewModeInputs = Array.from(document.querySelectorAll('input[name="step3-view-mode"]'));
let step3ViewMode = 'phases'; // 'phases' | 'expanded' | 'sow'
window.step3ViewMode = step3ViewMode;
const designMigrationGroup = document.getElementById('design-migration-group');
window.designMigrationGroup = designMigrationGroup;
const designProtectionSection = document.getElementById('design-protection-section');
const designPostDeploySection = document.getElementById('design-post-deploy-section');
const assumptionsRiskNotice = document.getElementById('assumptions-risk-notice');
window.assumptionsRiskNotice = assumptionsRiskNotice;
const assumptionsRiskNoticeText = document.getElementById('assumptions-risk-notice-text');
window.assumptionsRiskNoticeText = assumptionsRiskNoticeText;
const assumptionsRiskNoticeCount = document.getElementById('assumptions-risk-notice-count');
window.assumptionsRiskNoticeCount = assumptionsRiskNoticeCount;
const implementationModeGroup = document.querySelector('.implementation-mode-group');
const implementationModeInputs = Array.from(document.querySelectorAll('input[name="implementation-mode"]'));
const upgradeHealthCheckReviewRequiredToggle = document.getElementById('upgrade-health-check-review-required');
const backupVerificationRequiredInput = document.getElementById('backup-verification-required');
window.backupVerificationRequiredInput = backupVerificationRequiredInput;
const backupVerificationDisplayInputs = Array.from(document.querySelectorAll('input[name="backup-verification-display"]'));
const sureBackupRequiredInput = document.getElementById('sure-backup-required');
window.sureBackupRequiredInput = sureBackupRequiredInput;
const sureBackupDisplayInputs = Array.from(document.querySelectorAll('input[name="sure-backup-display"]'));
const sureBackupContainer = document.getElementById('sure-backup-container');

const replicationRequiredToggle = document.getElementById('replication-required');
window.replicationRequiredToggle = replicationRequiredToggle;
const cdpReplicationRequiredToggle = document.getElementById('cdp-replication-required');
const cdpReplicationContainer = document.getElementById('cdp-replication-container');
const sureReplicaRequiredInput = document.getElementById('sure-replica-required');
window.sureReplicaRequiredInput = sureReplicaRequiredInput;
const sureReplicaDisplayInputs = Array.from(document.querySelectorAll('input[name="sure-replica-display"]'));
window.sureReplicaDisplayInputs = sureReplicaDisplayInputs;
const sureReplicaContainer = document.getElementById('sure-replica-container');
const tapeIntegrationRequiredToggle = document.getElementById('tape-integration-required');
window.tapeIntegrationRequiredToggle = tapeIntegrationRequiredToggle;
const tapeConnectivityContainer = document.getElementById('tape-connectivity-container');
const tapeConnectivityTypeSelect = document.getElementById('tape-connectivity-type');
const siemForwardingContainer = document.getElementById('siem-forwarding-container');
const resetBtn = document.getElementById('reset-btn');
const exportJsonBtn = document.getElementById('export-json-btn');
const importJsonBtn = document.getElementById('import-json-btn');
const importJsonFile = document.getElementById('import-json-file');
const localScenarioNameInput = document.getElementById('local-scenario-name');
const localScenarioSelect = document.getElementById('local-scenario-select');
const saveLocalScenarioBtn = document.getElementById('save-local-scenario-btn');
const loadLocalScenarioBtn = document.getElementById('load-local-scenario-btn');
const clearLocalScenarioBtn = document.getElementById('clear-local-scenario-btn');
const localScenarioStatus = document.getElementById('local-scenario-status');
window.localScenarioStatus = localScenarioStatus;
const prevStepBtn = document.getElementById('prev-step-btn');
const nextStepBtn = document.getElementById('next-step-btn');
const step3WarningDialog = document.getElementById('step3-warning-dialog');
window.step3WarningDialog = step3WarningDialog;
const step3WarningCancelBtn = document.getElementById('step3-warning-cancel-btn');
const step3WarningContinueBtn = document.getElementById('step3-warning-continue-btn');
const step3WarningCloseBtn = document.getElementById('step3-warning-close-btn');
const appVersion = document.getElementById('app-version');
// Additional cached element references used in getEstimatorState and event handlers.
const backupCopyRequiredToggle = document.getElementById('backup-copy-required');
const siemForwardingRequiredToggle = document.getElementById('siem-forwarding-required');
const enablementRequiredToggle = document.getElementById('enablement-required');
const uatRequiredToggle = document.getElementById('uat-required');
const wizardSteps = Array.from(document.querySelectorAll('.wizard-step'));
const wizardProgressItems = Array.from(document.querySelectorAll('[data-step-indicator]'));
window.wizardProgressItems = wizardProgressItems;
const wizardProgressButtons = Array.from(document.querySelectorAll('[data-step-target]'));
const binaryToggleIds = [
    'upgrade-health-check-review-required',
    'veeam-one-required',
    'veeam-one-reporting',
    'veeam-one-dashboards',
    'veeam-one-alarms',
    'backup-copy-required',
    'replication-required',
    'cdp-replication-required',
    'tape-integration-required',
    'advisory-support-required',
    'enablement-required',
    'uat-required',
    'sop-required',
    'as-built-required',
    'dr-runbook-required',
    'assumption-bandwidth-adequate',
    'assumption-customer-resource-available',
    'assumption-remote-delivery-accepted',
    'assumption-admin-access-provided',
    'assumption-licence-in-place',
    'assumption-change-control',
];



/** Whether the hypervisor migration section is active.
 *  Always true — effort is driven by whether scopes are actually configured. */


// step2VbrLanes, step2CloudLanes, s2NextLaneId, s2ActivePicker, workloadAssignments
// are declared and owned by step2-canvas.js (imported above). They are set on
// window by that module so bare-name access in this file still resolves correctly.




const emptyOutputMarkup = '<div class="output-card"><p class="results-empty">Run an estimate to see the calculated effort, duration, and selected delivery options.</p></div>';
window.emptyOutputMarkup = emptyOutputMarkup;
const localScenarioCatalogStorageKey = 'ps-estimator-local-scenarios';
const themeStorageKey = 'ps-estimator-theme';
// §UPGRADE-DATA-MODELS
// ── Upgrade Scope State ───────────────────────────────────────────────────────
// Per-VBR settings (osPlatform, vbrHa) keyed by instanceId or legacy slot key,
// plus global engagement-level toggles for Advanced RBAC and VBEM.
// Stored separately from architectureState so Platform and Upgrade sections
// remain independent; only advancedRbac and vbem are synced back for the
// effort-calculation summary output.


// Tracks which component-group rows are currently expanded to show per-instance sub-rows.

const workloadValidationMessage = 'Add a workload or component to continue.';
const inDevelopmentOnlyWorkloadMessage = 'The workloads added are marked as Coming Soon and cannot be estimated yet. Add VMware or Hyper-V workloads to continue.';
const siteWorkloadValidationMessage = 'Each site must include at least one workload before continuing.';
const repoMigrationValidationMessage = 'Add migration data for at least one site before calculating an estimate.';
const repoMigrationSiteValidationMessage = 'Each site must include migration data before continuing.';
const engagementTypePlaceholderMessage = 'Enter a customer project or opportunity name to begin describing the environment.';
window.engagementTypePlaceholderMessage = engagementTypePlaceholderMessage;
const projectValidationMessage = 'Add a customer or project name to continue.';
const siteNameValidationMessage = 'Site name is already in use.';
const siteNamePlaceholder = 'Optional location name';
window.siteNamePlaceholder = siteNamePlaceholder;
const stepButtonLabels = {
    1: 'Next: Future State',
    2: 'Next: Indicative Effort'
};
const totalSteps = 3;
window.totalSteps = totalSteps;

/** True when the user is on Step 3 and the engagement scope is complete enough to render the estimate. */
function isStep3Ready() {
    return AppState.currentStep === totalSteps && hasSelectedWorkloads() && hasCompleteSiteWorkloads();
}

// ── Job-centric data model ────────────────────────────────────────────────────


function buildDefaultJobEntry(jobType = 'backup', workloadType = 'vmware', count = 50) {
    const typeDef = getJobTypeDef(jobType);
    const wlType  = typeDef?.hasCount !== false ? workloadType : '';
    return {
        id: createJobId(),
        jobType,
        workloadType: wlType,
        count: typeDef?.hasCount !== false ? count : 0,
        agentVersion: getDefaultAgentVersion(wlType),
        customLabel: '',
        /** instanceId of the Veeam server managing this job, or null if unlinked. */
        managedByInstanceId: null
    };
}
window.buildDefaultJobEntry = buildDefaultJobEntry;
// ── Unprotected workload data model ──────────────────────────────────────────
// Workloads that exist in the customer's environment but are NOT yet protected
// by Veeam — these represent the greenfield scope in Step 1.


function buildDefaultUnprotectedWorkloadEntry(workloadType = 'vmware', count = 50) {
    return {
        id: createUnprotectedWorkloadId(),
        workloadType,
        count,
        customLabel: ''
    };
}
window.buildDefaultUnprotectedWorkloadEntry = buildDefaultUnprotectedWorkloadEntry;
// ── End unprotected workload data model ───────────────────────────────────────

// ── End job-centric data model ────────────────────────────────────────────────

// workloadPickerRepositionFrame, siteScopePickerRepositionFrame — managed by picker modules.
// workloadPickerPlaceholderLabel, existingEnvironmentPickerPlaceholderLabel,
// pendingExistingEnvironmentSelectionKey — imported from picker modules.

// §PALETTE — extracted to palette.js







// §WORKLOAD-PICKER — extracted to workload-picker.js

// (workload-picker.js body removed)

// §SITE-SCOPE-PICKER — extracted to site-scope-picker.js

// ID counters and devModeEnabled live in AppState (state.js) — imported above.
// §HVM-SCOPE
// ── Hypervisor migration scope state ─────────────────────────────────────────
// Lives in step 2 — not in sites. Each entry links a step-1 backup job (the
// source platform being decommissioned) to a target hypervisor platform.
// Engagement type as a UI concept is retired — canvas composition drives all visibility logic.







function isExistingEnvironmentFieldAvailable(existingEnvironment = {}, definition) {
    if (!isExistingEnvironmentFieldAvailableForEngagement(definition)) {
        return false;
    }

    const parentField = getExistingEnvironmentPrimaryParentField(definition);

    if (!parentField) {
        return true;
    }

    return hasExistingEnvironmentFieldValue(existingEnvironment, parentField);
}

function applyDefaultVbrChildRows(existingEnvironment = {}) {
    if (normalizeToggleMigratedCount(existingEnvironment?.vbrServers) === 0) {
        return existingEnvironment;
    }

    // Previously this list contained child fields (e.g. 'proxyServers', 'repositoryServers')
    // that were defaulted to 1 when a VBR server was first added. The list was cleared
    // intentionally to remove auto-defaulting behaviour. Leave empty unless auto-defaults
    // are reintroduced. The call-sites and early-return guard above are kept in place
    // so the function can be easily re-populated without touching call-sites.
    const childFieldsToDefault = [];
    childFieldsToDefault.forEach((field) => {
        const definition = getExistingEnvironmentFieldDefinition(field);

        if (!isExistingEnvironmentFieldAvailable(existingEnvironment, definition)) {
            return;
        }

        if (normalizeEnvironmentCount(existingEnvironment[field]) > 0) {
            return;
        }

        existingEnvironment[field] = 1;
    });

    return existingEnvironment;
}
window.applyDefaultVbrChildRows = applyDefaultVbrChildRows;

function pruneExistingEnvironmentState(existingEnvironment = {}) {
    const normalizedExistingEnvironment = enforceExistingEnvironmentDependencies(
        normalizeExistingEnvironment(existingEnvironment)
    );
    const prunedExistingEnvironment = {};

    existingEnvironmentFieldSchema.forEach((definition) => {
        if (!isExistingEnvironmentFieldAvailableForEngagement(definition)) {
            return;
        }

        const parentField = getExistingEnvironmentPrimaryParentField(definition);
        if (parentField && !hasExistingEnvironmentFieldValue(normalizedExistingEnvironment, parentField)) {
            return;
        }

        if (definition.kind === 'toggle') {
            if (normalizeExistingEnvironmentToggle(normalizedExistingEnvironment[definition.key]) === 'yes') {
                prunedExistingEnvironment[definition.key] = 'yes';
            }
            return;
        }

        const count = normalizeEnvironmentCount(normalizedExistingEnvironment[definition.key]);
        if (count > 0) {
            prunedExistingEnvironment[definition.key] = count;
        }
    });

    return prunedExistingEnvironment;
}
window.pruneExistingEnvironmentState = pruneExistingEnvironmentState;






function getStoredSiteName(value, index) {
    const normalizedName = normalizeSiteName(value);
    return normalizedName === getDefaultSiteName(index) ? '' : normalizedName;
}

function isDuplicateSiteName(name, excludedSiteId = null) {
    const normalizedName = normalizeSiteName(name).toLocaleLowerCase();
    if (!normalizedName) {
        return false;
    }

    return sites.some((site, index) => (
        site.id !== excludedSiteId
        && normalizeSiteName(getSiteDisplayName(site, index)).toLocaleLowerCase() === normalizedName
    ));
}

function validateSiteNameControl(input, excludedSiteId = null) {
    if (!(input instanceof HTMLInputElement)) {
        return true;
    }

    const message = isDuplicateSiteName(input.value, excludedSiteId) ? siteNameValidationMessage : '';
    input.setCustomValidity(message);
    return !message;
}








function getNextAvailableExistingEnvironmentField(site) {
    return getAvailableExistingEnvironmentFields(site?.existingEnvironment)[0] || '';
}









function getTotalWorkloadOptionCount() {
    return workloadOptionGroups.reduce(
        (sum, group) => sum + group.options.filter((option) => !isInDevelopmentWorkloadValue(option.value)).length,
        0
    );
}

function canAddWorkloadRow(site) {
    return Array.isArray(site?.workloads) && site.workloads.length < getTotalWorkloadOptionCount();
}


function buildDefaultSelectedWorkloadEntry(workloadValue, customLabel = '', rowId = null) {
    const normalizedWorkloadValue = normalizeWorkloadValue(workloadValue);

    if (!hasSelectedWorkloadValue(normalizedWorkloadValue)) {
        return buildWorkloadEntry('', 0, null, '', rowId);
    }

    if (isProtectedTbWorkload(normalizedWorkloadValue)) {
        return buildWorkloadEntry(normalizedWorkloadValue, 0, 1, customLabel, rowId);
    }

    return buildWorkloadEntry(normalizedWorkloadValue, 50, null, customLabel, rowId);
}
window.buildDefaultSelectedWorkloadEntry = buildDefaultSelectedWorkloadEntry;




function cloneSiteState(site) {
    return {
        id: site.id,
        name: site.name,
        renameDraft: site.renameDraft,
        isRenaming: site.isRenaming,
        vdcVaultSourceStorageType: typeof site.vdcVaultSourceStorageType === 'string' ? site.vdcVaultSourceStorageType : '',
        vdcVaultRepositoryType: typeof site.vdcVaultRepositoryType === 'string' ? site.vdcVaultRepositoryType : '',
        vdcVaultTargetVault: typeof site.vdcVaultTargetVault === 'string' ? site.vdcVaultTargetVault : '',
        existingEnvironment: { ...pruneExistingEnvironmentState(site.existingEnvironment) },
        existingEnvironmentCustomLabels: {
            ...pruneExistingEnvironmentCustomLabels(site.existingEnvironmentCustomLabels, site.existingEnvironment)
        },
        existingEnvironmentRepoPlatform:       site.existingEnvironmentRepoPlatform       === 'linux' ? 'linux' : 'windows',
        existingEnvironmentVb365ProxyPlatform: site.existingEnvironmentVb365ProxyPlatform === 'linux' ? 'linux' : 'windows',
        existingEnvironmentVb365RepoTypes: (site.existingEnvironmentVb365RepoTypes && typeof site.existingEnvironmentVb365RepoTypes === 'object') ? { ...site.existingEnvironmentVb365RepoTypes } : {},
        existingEnvironmentVb365RepoConsumedTbs: (site.existingEnvironmentVb365RepoConsumedTbs && typeof site.existingEnvironmentVb365RepoConsumedTbs === 'object') ? { ...site.existingEnvironmentVb365RepoConsumedTbs } : {},
        workloads: Array.isArray(site.workloads)
            ? site.workloads.map((workload) => ({ ...workload }))
            : [],
        paletteWorkloads: Array.isArray(site.paletteWorkloads)
            ? site.paletteWorkloads.map((wl) => ({ ...wl }))
            : [],
    };
}


/** True when at least one repository component (added via + Add Component → Repository) is on the canvas. */

function shouldRenderExistingEnvironmentTable() {
    return getCanvasEngagementFlags().hC;
}
window.shouldRenderExistingEnvironmentTable = shouldRenderExistingEnvironmentTable;

function shouldRenderRepoMigrationTable() {
    return getCanvasEngagementFlags().hV;
}
window.shouldRenderRepoMigrationTable = shouldRenderRepoMigrationTable;








function buildRepoMigrationEntry(protectedTb = 50, rowId = null, rawState = {}) {
    return buildWorkloadEntry(repoMigrationWorkloadId, 0, protectedTb, '', rowId, rawState);
}
window.buildRepoMigrationEntry = buildRepoMigrationEntry;

function hasConfiguredSiteScope(site) {
    const hasSourceWorkloads = Array.isArray(site.sourceWorkloads) && site.sourceWorkloads.length > 0;
    const hasPaletteWorkloads = Array.isArray(site.paletteWorkloads) && site.paletteWorkloads.length > 0;
    const hasLegacyWorkloads  = site.workloads.some((workload) => hasMeaningfulWorkloadScope(workload));
    const hasVaultWorkloads   = getRepoMigrationWorkloads(site).some((workload) => getRepoMigrationWorkloadProtectedTb(workload) > 0);
    const hasComponentScope   = hasExistingEnvironment(site);
    const hasUncategorisedWl  = Array.isArray(site.uncategorisedWorkloads) && site.uncategorisedWorkloads.some((w) => w.value);
    const hasVeeamServers     = Array.isArray(site.veeamServers) && site.veeamServers.length > 0;
    return hasSourceWorkloads || hasPaletteWorkloads || hasLegacyWorkloads || hasVaultWorkloads || hasComponentScope || hasUncategorisedWl || hasVeeamServers;
}

function getSitesWithIncompleteRepoMigrationSelections() {
    if (!getCanvasEngagementFlags().hV) {
        return [];
    }

    return sites
        .map((site, index) => {
            const incompleteWorkload = getRepoMigrationWorkloads(site).find((workload) => {
                const hasScopedData = getRepoMigrationWorkloadProtectedTb(workload) > 0;

                return hasScopedData && (
                    !workload.vdcVaultSourceStorageType
                    || !workload.vdcVaultRepositoryType
                );
            });

            const missingSourceStorage = incompleteWorkload ? !incompleteWorkload.vdcVaultSourceStorageType : false;
            const missingRepository = incompleteWorkload ? !incompleteWorkload.vdcVaultRepositoryType : false;

            return {
                id: site.id,
                rowId: incompleteWorkload?.rowId || null,
                label: getSiteDisplayName(site, index),
                missingSourceStorage,
                missingRepository,
                hasIncompleteSelections: Boolean(incompleteWorkload)
            };
        })
        .filter((site) => site.hasIncompleteSelections);
}


function getEmptyScopeValidationMessage() {
    if (getCanvasEngagementFlags().hV) return repoMigrationValidationMessage;
    if (hasOnlyInDevelopmentWorkloads()) return inDevelopmentOnlyWorkloadMessage;
    return workloadValidationMessage;
}

function getIncompleteSiteScopeValidationMessage() {
    return getCanvasEngagementFlags().hV
        ? repoMigrationSiteValidationMessage
        : siteWorkloadValidationMessage;
}




function updateUnstructuredProtectedTbPreview(siteId, workloadIdentifier, protectedTb) {
    const summary = siteList.querySelector(
        `[data-site-workload-derived-tb="${workloadIdentifier}"][data-site-id="${siteId}"]`
    );

    if (summary) {
        summary.textContent = getRoundedProtectedTbSummary(protectedTb);
    }
}








function getSiteRenameDraft(site, index) {
    return typeof site?.renameDraft === 'string' && site.renameDraft !== ''
        ? site.renameDraft
        : getSiteDisplayName(site, index);
}


function syncSiteNamePlaceholders() {
    if (!siteList) {
        return;
    }

    siteList.querySelectorAll('[data-site-name]').forEach((input) => {
        if (!(input instanceof HTMLInputElement) || document.activeElement === input) {
            return;
        }

        const siteId = parseInt(input.dataset.siteName, 10);
        const siteIndex = sites.findIndex((site) => site.id === siteId);
        if (siteIndex === -1) {
            return;
        }

        input.placeholder = getSiteNamePlaceholder();
    });
}


function buildCopySiteName(site, siteIndex = sites.findIndex((candidate) => candidate.id === site?.id)) {
    const sourceName = normalizeSiteName(site?.name) || getSiteDisplayName(site, Math.max(siteIndex, 0));
    const preferredName = `${sourceName} (copy)`;
    if (!isDuplicateSiteName(preferredName)) {
        return preferredName;
    }

    let copyNumber = 2;
    let candidateName = `${sourceName} (copy ${copyNumber})`;
    while (isDuplicateSiteName(candidateName) && copyNumber < 200) {
        copyNumber += 1;
        candidateName = `${sourceName} (copy ${copyNumber})`;
    }

    // Fallback: if all numbered copies are taken, append a timestamp to guarantee uniqueness.
    if (isDuplicateSiteName(candidateName)) {
        candidateName = `${sourceName} (copy ${Date.now()})`;
    }

    return candidateName;
}







function canRestoreAdvancedStep() {
    return Boolean(projectNameInput.value.trim()) && hasSelectedWorkloads() && hasCompleteSiteWorkloads();
}

function buildLocalScenarioState() {
    return {
        ...getEstimatorState(),
        currentStep: AppState.currentStep
    };
}


function normalizeLocalScenarioKey(value) {
    return normalizeLocalScenarioName(value).toLocaleLowerCase();
}

function getSuggestedLocalScenarioName() {
    return normalizeLocalScenarioName(localScenarioNameInput?.value)
        || normalizeLocalScenarioName(projectNameInput?.value)
        || '';
}


function readLocalScenarioCatalog() {
    const storage = getPersistentStorage();
    if (!storage) {
        return [];
    }

    const rawCatalog = storage.getItem(localScenarioCatalogStorageKey);
    if (!rawCatalog) {
        return [];
    }

    try {
        const parsedCatalog = JSON.parse(rawCatalog);
        const rawScenarios = Array.isArray(parsedCatalog?.scenarios)
            ? parsedCatalog.scenarios
            : Array.isArray(parsedCatalog)
                ? parsedCatalog
                : [];

        return rawScenarios
            .map((scenario) => {
                const name = normalizeLocalScenarioName(scenario?.name);
                if (!name || !scenario || typeof scenario !== 'object' || !scenario.state || typeof scenario.state !== 'object') {
                    return null;
                }

                return {
                    name,
                    savedAt: typeof scenario.savedAt === 'string' ? scenario.savedAt : '',
                    state: scenario.state
                };
            })
            .filter((scenario) => scenario !== null)
            .sort((left, right) => left.name.localeCompare(right.name, undefined, { sensitivity: 'base' }));
    } catch {
        storage.removeItem(localScenarioCatalogStorageKey);
        return [];
    }
}

function writeLocalScenarioCatalog(scenarios) {
    const storage = getPersistentStorage();
    if (!storage) {
        return false;
    }

    try {
        storage.setItem(localScenarioCatalogStorageKey, JSON.stringify({
            version: 1,
            scenarios
        }));
        return true;
    } catch {
        return false;
    }
}

function updateLocalScenarioControls(selectedName = '') {
    if (!localScenarioSelect || !loadLocalScenarioBtn || !clearLocalScenarioBtn) {
        return;
    }

    const scenarios = readLocalScenarioCatalog();
    const normalizedSelectedName = normalizeLocalScenarioName(selectedName);
    const normalizedSelectedKey = normalizeLocalScenarioKey(selectedName);
    const hasSelectedScenario = scenarios.some((scenario) => normalizeLocalScenarioKey(scenario.name) === normalizedSelectedKey);
    const effectiveSelectedName = hasSelectedScenario
        ? scenarios.find((scenario) => normalizeLocalScenarioKey(scenario.name) === normalizedSelectedKey)?.name || normalizedSelectedName
        : (scenarios[0]?.name || '');

    localScenarioSelect.innerHTML = scenarios.length
        ? scenarios.map((scenario) => `
            <option value="${escapeHtml(scenario.name)}" ${scenario.name === effectiveSelectedName ? 'selected' : ''}>${escapeHtml(scenario.name)}</option>
        `).join('')
        : '<option value="">No local scenarios saved</option>';

    loadLocalScenarioBtn.disabled = !scenarios.length;
    clearLocalScenarioBtn.disabled = !scenarios.length;
    loadLocalScenarioBtn.setAttribute('aria-disabled', String(!scenarios.length));
    clearLocalScenarioBtn.setAttribute('aria-disabled', String(!scenarios.length));
}

function saveLocalScenario() {
    const scenarioName = getSuggestedLocalScenarioName();
    if (!scenarioName) {
        setLocalScenarioStatus('Enter a scenario name before saving locally.');
        localScenarioNameInput?.focus();
        return;
    }

    const scenarioKey = normalizeLocalScenarioKey(scenarioName);
    const scenarios = readLocalScenarioCatalog().filter((scenario) => normalizeLocalScenarioKey(scenario.name) !== scenarioKey);
    scenarios.push({
        name: scenarioName,
        savedAt: new Date().toISOString(),
        state: buildLocalScenarioState()
    });

    if (!writeLocalScenarioCatalog(scenarios)) {
        setLocalScenarioStatus('Unable to save the local scenario in this browser.');
        return;
    }

    if (localScenarioNameInput) {
        localScenarioNameInput.value = scenarioName;
    }
    updateLocalScenarioControls(scenarioName);
    setLocalScenarioStatus(`Saved local scenario "${scenarioName}".`);
}

function loadLocalScenario() {
    const scenarioName = normalizeLocalScenarioName(localScenarioSelect?.value);
    if (!scenarioName) {
        setLocalScenarioStatus('Choose a local scenario to load.');
        return;
    }

    const scenarioKey = normalizeLocalScenarioKey(scenarioName);
    const scenario = readLocalScenarioCatalog().find((item) => normalizeLocalScenarioKey(item.name) === scenarioKey);
    if (!scenario) {
        updateLocalScenarioControls();
        setLocalScenarioStatus('The selected local scenario is no longer available.');
        return;
    }

    applyEstimatorState(scenario.state);

    const restoredStep = canRestoreAdvancedStep()
        ? getRestorableCurrentStep(scenario.state.currentStep)
        : 1;

    if (restoredStep !== AppState.currentStep) {
        setCurrentStep(restoredStep);
    }

    if (localScenarioNameInput) {
        localScenarioNameInput.value = scenarioName;
    }
    updateLocalScenarioControls(scenarioName);
    setLocalScenarioStatus(`Loaded local scenario "${scenarioName}".`);
}

function clearLocalScenario() {
    const scenarioName = normalizeLocalScenarioName(localScenarioSelect?.value);
    if (!scenarioName) {
        setLocalScenarioStatus('Choose a local scenario to clear.');
        return;
    }

    const scenarioKey = normalizeLocalScenarioKey(scenarioName);
    const scenarios = readLocalScenarioCatalog().filter((scenario) => normalizeLocalScenarioKey(scenario.name) !== scenarioKey);
    if (!writeLocalScenarioCatalog(scenarios)) {
        setLocalScenarioStatus('Unable to clear the selected local scenario.');
        return;
    }

    if (localScenarioNameInput && normalizeLocalScenarioKey(localScenarioNameInput.value) === scenarioKey) {
        localScenarioNameInput.value = '';
    }

    updateLocalScenarioControls();
    setLocalScenarioStatus(`Cleared local scenario "${scenarioName}".`);
}


function applyTheme(theme) {
    document.body.setAttribute('data-theme', theme);
    const storage = getPersistentStorage();

    if (storage) {
        try {
            storage.setItem(themeStorageKey, theme);
        } catch {
            // Ignore storage failures and continue with the in-memory theme.
        }
    }

    updateThemeToggleLabel(theme);
}

function initializeTheme() {
    const storage = getPersistentStorage();
    let savedTheme = '';

    if (storage) {
        try {
            savedTheme = storage.getItem(themeStorageKey) || '';
        } catch {
            savedTheme = '';
        }
    }

    const preferredDark = typeof window.matchMedia === 'function'
        && window.matchMedia('(prefers-color-scheme: dark)').matches;
    const initialTheme = savedTheme || (preferredDark ? 'dark' : 'light');
    applyTheme(initialTheme);
}



function setVeeamOneRequiredValue(value, { explicitChoice = false } = {}) {
    setToggleState('veeam-one-required', value);

    if (veeamOneRequiredToggle) {
        veeamOneRequiredToggle.dataset.explicitChoice = explicitChoice ? 'true' : 'false';
    }

}

function syncVeeamOneDefaultForEdition() {
    if (!veeamOneRequiredToggle) {
        return;
    }

    if (hasExplicitVeeamOneChoice()) {
        return;
    }

    setToggleState('veeam-one-required', 'yes');
}




/** Derives the engagement type from canvas flags and Step 2 matrix state, then sets data-engagement-type on <body> for CSS hooks. */
function syncEngagementTypeBodyAttribute() {
    document.body.setAttribute('data-engagement-type', deriveEngagementType());
}




function upgradeHealthCheckReviewRequiredValue() {
    return toggleValue(upgradeHealthCheckReviewRequiredToggle);
}


function syncCanvasStateDefaults() {
    syncEngagementTypeBodyAttribute();
    renderSiteList();
    syncDesignOptionFields();
    syncImplementationModeLabels();
    syncNextStepAvailability();
}


/**
 * Infers site topology automatically from Step 1 and Step 2 data.
 * Returns 'distributed' when VBR servers span multiple sites, 'centralized' otherwise,
 * or '' when there is only one site (not applicable).
 */





function applyArchitectureState(nextState = {}, siteCount = sites.length) {
    Object.assign(architectureState, normalizeArchitectureState(nextState, siteCount));
}
window.applyArchitectureState = applyArchitectureState;





function initializeStep3ViewModeControl() {
    step3ViewModeInputs.forEach((input) => {
        if (input.dataset.step3ViewModeBound === 'true') {
            return;
        }
        input.addEventListener('change', () => {
            if (!input.checked) {
                return;
            }
            step3ViewMode = input.value;
            window.step3ViewMode = step3ViewMode;
            scheduleRenderEstimate();
        });
        input.dataset.step3ViewModeBound = 'true';
    });
}


function applyStep2CollapseState(root = document) {
    root.querySelectorAll('[data-collapsible-section]').forEach((section) => {
        const sectionId = section.dataset.collapsibleSection;
        const isCollapsed = Object.hasOwn(AppState.step2CollapseState, sectionId)
            ? AppState.step2CollapseState[sectionId]
            : true;

        setCollapsibleSectionState(sectionId, isCollapsed);
    });
}

function bindStep2CollapseEvents(root = document) {
    root.querySelectorAll('[data-collapsible-section]').forEach((section) => {
        if (section.dataset.collapseBound === 'true') {
            return;
        }

        const triggers = Array.from(section.querySelectorAll('[data-collapsible-trigger]'));
        if (!triggers.length) {
            return;
        }

        const sectionId = section.dataset.collapsibleSection;
        triggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
                setCollapsibleSectionState(sectionId, !AppState.step2CollapseState[sectionId]);
            });
        });

        section.dataset.collapseBound = 'true';
    });
}

/** Show/hide the migration group wrapper based on whether any child section is visible. */

/** Bind toggle events for [data-group-trigger] buttons (migration group header). */

function syncEditionSectionVisibility() {
    const { hW, hV, hC, hP } = getCanvasEngagementFlags();
    // Standard sections when any canvas content is present, or on first load before tiles are added.
    // Vault-only canvas suppresses standard sections in favour of the migration section.
    const showStandardSections = hW || hP || hC || !hV;

    const showPostDeploySection = showStandardSections || hV;
    setSectionVisibility(architectureCardHost, showStandardSections && needsNewVbrDeployment() && hasCloudWorkloads());

    setSectionVisibility(designProtectionSection, showStandardSections);
    setSectionVisibility(designPostDeploySection, showPostDeploySection);

    syncVeeamOneDefaultForEdition();
    syncMigrationGroupVisibility();

}

// §UPGRADE-SCOPE
// ── Upgrade Scope Section ─────────────────────────────────────────────────────

function renderArchitectureCard() {
    // Unified canvas: Veeam Version row only shown for upgrade/health-check — both removed, so never shown.
    // Site Topology is inferred automatically from Step 1/Step 2 VBR placement — no UI control needed.
    // Deployment (virtual/physical), VBR OS (windows/linux), and VSA HA are owned by the new VBR server
    // mapping in the Step 2 placement canvas — they are not shown here.

    return `
        <section id="design-architecture-section" class="design-section design-section--collapsible architecture-section" data-collapsible-section="architecture" aria-labelledby="design-architecture-title">
            <div class="design-section__header-bar">
                <button type="button" class="design-section__toggle" data-collapsible-trigger aria-expanded="false" aria-controls="design-architecture-content">
                    <div class="design-section__header">
                        <span class="design-section__eyebrow">Platform</span>
                        <div>
                            <h4 id="design-architecture-title">New VBR — version and architecture.</h4>
                        </div>
                    </div>
                </button>
                <button type="button" class="design-section__chevron-button" data-collapsible-trigger aria-expanded="false" aria-controls="design-architecture-content">
                    <span class="design-section__chevron" aria-hidden="true">
                        <svg viewBox="0 0 20 20" focusable="false">
                            <path d="M5 7.5 10 12.5 15 7.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </span>
                </button>
            </div>
            <div id="design-architecture-content" class="design-section__content" data-collapsible-content hidden>
                <div class="design-section__grid">
                    <div class="field-group field-group--stacked-card field-span-2 architecture-card architecture-card--condensed">
                        <div class="architecture-card__expert-group">
                            ${hasCloudWorkloads() ? `
                            <div class="property-row">
                                <span class="property-row__label">Private Networking</span>
                                ${renderArchitectureChoiceGroup('private-networking', architectureState.privateNetworking, [
                                    { value: 'no', label: 'No' },
                                    { value: 'yes', label: 'Yes' }
                                ], 'Private Networking')}
                            </div>
                            ` : ''}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    `;
}

function syncArchitectureStateFromDom() {
    if (!architectureCardHost) {
        return buildArchitectureStateSnapshot();
    }

    const veeamVersionInput = architectureCardHost.querySelector('input[name="architecture-veeam-version"]:checked');
    // osPlatform, deploymentType, and vbrHa are owned by the server mapping — not read from this card.
    const privateNetworkingInput = architectureCardHost.querySelector('input[name="architecture-private-networking"]:checked');

    // VBEM and Advanced RBAC live in the Scope | Workload scope section (engagement settings card)
    const scopeMatrixHost = document.getElementById('scope-matrix-host');
    const vbemInput = scopeMatrixHost?.querySelector('input[name="engagement-vbem"]:checked');
    const advancedRbacInput = scopeMatrixHost?.querySelector('input[name="engagement-advanced-rbac"]:checked');

    applyArchitectureState({
        veeamVersion: veeamVersionInput?.value,
        isDistributed: false,
        networkConstraints: 'no',
        vbem: vbemInput?.value || architectureState.vbem,
        advancedRbac: advancedRbacInput?.value || architectureState.advancedRbac,
        siteTopology: inferSiteTopology(),
        privateNetworking: privateNetworkingInput?.value || architectureState.privateNetworking
    }, sites.length);

    return buildArchitectureStateSnapshot();
}

function bindArchitectureCardEvents() {
    if (!architectureCardHost || architectureCardHost.dataset.boundArchitectureCard === 'true') {
        return;
    }

    architectureCardHost.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement) || !target.matches('[data-architecture-field]')) {
            return;
        }

        syncArchitectureStateFromDom();
        syncEditionSectionVisibility();

        if (isStep3Ready()) {
            scheduleRenderEstimate();
        }
    });

    architectureCardHost.dataset.boundArchitectureCard = 'true';
}

function renderArchitectureCardSection() {
    if (!architectureCardHost) {
        return;
    }

    const { hV, hW, hC } = getCanvasEngagementFlags();
    if (hV && !hW && !hC) {
        // Pure vault canvas — architecture card not applicable.
        architectureCardHost.innerHTML = '';
        syncEditionSectionVisibility();
        return;
    }

    applyArchitectureState(architectureState, sites.length);
    architectureCardHost.innerHTML = renderArchitectureCard();
    bindArchitectureCardEvents();
    bindStep2CollapseEvents(architectureCardHost);
    applyStep2CollapseState(architectureCardHost);
    syncEditionSectionVisibility();
}

function syncDesignOptionFields() {
    // Unified canvas: design is always required — derive visibility from canvas state, not engagement type radios.
    if (designOptionFields) {
        designOptionFields.hidden = false;
        designOptionFields.style.display = '';
        designOptionFields.setAttribute('aria-hidden', 'false');
    }

    renderArchitectureCardSection();
    bindStep2CollapseEvents();
    applyStep2CollapseState();

    syncBackupVerificationControl();
    syncReplicationFields();
    syncTapeConnectivityField();
    syncHypervisorMigrationSectionVisibility();
    syncVsaMigrationSectionVisibility();
    syncVb365RepoMigrationSectionVisibility();
    syncVbrRepoMigrationSectionVisibility();
    syncVbrPlacementSectionVisibility();
}

// ── Hypervisor Migration Section — moved to hypervisor-migration.js ──────────
// syncHypervisorMigrationSectionVisibility and syncVsaMigrationSectionVisibility
// are imported from ./hypervisor-migration.js at the top of this file.

// §VBR-PLACEMENT
// ── VBR Server Placement Section ─────────────────────────────────────────────

const vbrPlacementSection = document.getElementById('design-platform-section');

/**
 * Returns true if workloads are configured across more than one site,
 * meaning VBR server placement decisions may be required.
 */
function isMultiSiteEngagement() {
    return sites.filter((site) => hasConfiguredSiteScope(site)).length > 1;
}
window.syncDesignOptionFields = syncDesignOptionFields;

/**
 * Show/hide the VBR placement section.
 *
 * Visible when:
 *   (a) workloads span 2+ sites — placement decision needed
 *   (b) VBR-eligible unprotected workloads exist with no existing VBR
 *
 * The section expands automatically when it first becomes relevant and
 * collapses when it is no longer needed. The chevron controls manual collapse.
 * VBR lanes are never auto-created — the user always adds them explicitly.
 */
function syncVbrPlacementSectionVisibility() {
    const multiSite          = isMultiSiteEngagement();
    const greenfieldNeedsVbr = hasUnprotectedWorkloadsNeedingVbr() && !hasVbrAcrossAllSites();
    const shouldShow         = multiSite || greenfieldNeedsVbr;

    if (vbrPlacementSection) {
        if (!shouldShow && vbrPlacementSection.contains(document.activeElement)) { document.activeElement.blur(); }
        vbrPlacementSection.hidden = !shouldShow;
        vbrPlacementSection.setAttribute('aria-hidden', String(!shouldShow));
    }

    if (!greenfieldNeedsVbr && !multiSite) {
        setCollapsibleSectionState('platform', true);
    }
}

// ── End VBR Server Placement Section ─────────────────────────────────────────

function syncReplicationFields() {
    const showReplicationFields = replicationRequiredToggle.checked;
    // Show CDP container when replication is on, OR when CDP is independently active
    // (e.g. from an unmanaged workload matrix selection or a managed CDP job)
    const showCdpReplicationField = showReplicationFields || !!(cdpReplicationRequiredToggle?.checked);

    if (cdpReplicationContainer) {
        cdpReplicationContainer.style.display = showCdpReplicationField ? '' : 'none';
    }

    if (!showCdpReplicationField) {
        setToggleState('cdp-replication-required', 'no');
    }

    sureReplicaContainer.style.display = showReplicationFields ? '' : 'none';

    // Sync replication tile sub-zone visibility
    const replicationSubZone = document.getElementById('replication-sub-zone');
    if (replicationSubZone) {
        replicationSubZone.style.display = showReplicationFields ? '' : 'none';
    }

    syncProtectionTileVisuals();
}
window.syncReplicationFields = syncReplicationFields;

function syncTapeConnectivityField() {
    const showTape = tapeIntegrationRequiredToggle.checked;
    tapeConnectivityContainer.style.display = showTape ? '' : 'none';

    // Sync tape tile sub-zone visibility
    const tapeSubZone = document.getElementById('tape-sub-zone');
    if (tapeSubZone) {
        tapeSubZone.style.display = showTape ? '' : 'none';
    }

    syncProtectionTileVisuals();
}

function syncBackupVerificationControl() {
    if (!backupVerificationRequiredInput || backupVerificationDisplayInputs.length === 0) {
        return;
    }

    const normalizedValue = backupVerificationRequiredInput.value === 'no' ? 'no' : 'yes_limited';
    backupVerificationRequiredInput.value = normalizedValue;
    const displayValue = normalizedValue === 'yes_limited' ? 'yes' : 'no';
    const showBackupDependentFields = normalizedValue !== 'no';

    backupVerificationDisplayInputs.forEach((input) => {
        input.checked = input.value === displayValue;
    });

    sureBackupContainer.style.display = showBackupDependentFields ? '' : 'none';

    // Sync backup tile sub-zone visibility
    const backupSubZone = document.getElementById('backup-sub-zone');
    if (backupSubZone) {
        backupSubZone.style.display = showBackupDependentFields ? '' : 'none';
    }

    syncSureBackupControl();
    syncProtectionTileVisuals();
}



function setBackupVerificationValue(value) {
    if (!backupVerificationRequiredInput) {
        return;
    }

    backupVerificationRequiredInput.value = value === 'no' ? 'no' : 'yes_limited';
    syncBackupVerificationControl();
}

/**
 * Shared initialiser for radio-style toggle controls (SureBackup, SureReplica,
 * BackupVerification). Syncs the control, then attaches a change listener to each
 * display input that calls setValueFn and conditionally triggers a re-render.
 * Uses dataset[boundAttrName] to prevent double-binding on re-renders.
 */
function initializeRadioToggleControl(hiddenInput, displayInputs, syncFn, setValueFn, boundAttrName) {
    if (!hiddenInput || displayInputs.length === 0) {
        return;
    }

    syncFn();

    displayInputs.forEach((input) => {
        if (input.dataset[boundAttrName] === 'true') {
            return;
        }

        input.addEventListener('change', () => {
            if (!input.checked) {
                return;
            }

            setValueFn(input.value);

            if (isStep3Ready()) {
                scheduleRenderEstimate();
            }
        });

        input.dataset[boundAttrName] = 'true';
    });
}

function initializeBackupVerificationControl() {
    initializeRadioToggleControl(
        backupVerificationRequiredInput,
        backupVerificationDisplayInputs,
        syncBackupVerificationControl,
        setBackupVerificationValue,
        'backupVerificationBound'
    );
}

function syncSureBackupControl() {
    if (!sureBackupRequiredInput || sureBackupDisplayInputs.length === 0) {
        return;
    }

    const normalizedValue = sureBackupRequiredInput.value === 'yes' ? 'yes' : 'no';
    sureBackupRequiredInput.value = normalizedValue;

    sureBackupDisplayInputs.forEach((input) => {
        input.checked = input.value === normalizedValue;
    });

    syncProtectionTileVisuals();
}

function setSureBackupValue(value) {
    if (!sureBackupRequiredInput) {
        return;
    }

    sureBackupRequiredInput.value = value === 'yes' ? 'yes' : 'no';
    syncSureBackupControl();
}

function initializeSureBackupControl() {
    initializeRadioToggleControl(
        sureBackupRequiredInput,
        sureBackupDisplayInputs,
        syncSureBackupControl,
        setSureBackupValue,
        'sureBackupBound'
    );
}


function setSureReplicaValue(value) {
    if (!sureReplicaRequiredInput) {
        return;
    }

    sureReplicaRequiredInput.value = value === 'yes' ? 'yes' : 'no';
    syncSureReplicaControl();
}

function initializeSureReplicaControl() {
    initializeRadioToggleControl(
        sureReplicaRequiredInput,
        sureReplicaDisplayInputs,
        syncSureReplicaControl,
        setSureReplicaValue,
        'sureReplicaBound'
    );
}

// §PROTECTION-CONTROLS
// ── Protection Tile System ──────────────────────────────────────────────────

/**
 * Bind click handlers on all protection tiles and sub-chips.
 */
function initializeProtectionTiles() {
    // Helper: fire scheduleRenderEstimate if on step 3
    function maybeRerender() {
        if (isStep3Ready()) {
            scheduleRenderEstimate();
        }
    }

    // ── Main tile click handlers ──────────────────────────────────────────

    // Backups tile
    const backupTile = document.querySelector('[data-prot-tile="backup"]');
    if (backupTile) {
        backupTile.addEventListener('click', () => {
            const isActive = backupVerificationRequiredInput?.value !== 'no';
            setBackupVerificationValue(isActive ? 'no' : 'yes_limited');
            maybeRerender();
        });
    }

    // Backup Copy tile
    const backupCopyTile = document.querySelector('[data-prot-tile="backup-copy"]');
    if (backupCopyTile) {
        backupCopyTile.addEventListener('click', () => {
            const toggle = document.getElementById('backup-copy-required');
            if (!toggle) return;
            toggle.checked = !toggle.checked;
            syncProtectionTileVisuals();
            maybeRerender();
        });
    }

    // Replication tile
    const replicationTile = document.querySelector('[data-prot-tile="replication"]');
    if (replicationTile) {
        replicationTile.addEventListener('click', () => {
            if (!replicationRequiredToggle) return;
            replicationRequiredToggle.checked = !replicationRequiredToggle.checked;
            syncReplicationFields();
            maybeRerender();
        });
    }

    // Tape tile
    const tapeTile = document.querySelector('[data-prot-tile="tape"]');
    if (tapeTile) {
        tapeTile.addEventListener('click', () => {
            if (!tapeIntegrationRequiredToggle) return;
            tapeIntegrationRequiredToggle.checked = !tapeIntegrationRequiredToggle.checked;
            syncTapeConnectivityField();
            maybeRerender();
        });
    }

    // SIEM tile
    const siemTile = document.querySelector('[data-prot-tile="siem"]');
    if (siemTile) {
        siemTile.addEventListener('click', () => {
            const toggle = document.getElementById('siem-forwarding-required');
            if (!toggle) return;
            toggle.checked = !toggle.checked;
            syncProtectionTileVisuals();
            maybeRerender();
        });
    }

    // ── Sub-chip click handlers ───────────────────────────────────────────

    // SureBackup sub-chip
    const sureBackupChip = document.querySelector('[data-prot-sub-chip="sure-backup"]');
    if (sureBackupChip) {
        sureBackupChip.addEventListener('click', () => {
            const isActive = sureBackupRequiredInput?.value === 'yes';
            setSureBackupValue(isActive ? 'no' : 'yes');
            maybeRerender();
        });
    }

    // CDP sub-chip
    const cdpChip = document.querySelector('[data-prot-sub-chip="cdp"]');
    if (cdpChip) {
        cdpChip.addEventListener('click', () => {
            const cdpToggle = document.getElementById('cdp-replication-required');
            if (!cdpToggle) return;
            cdpToggle.checked = !cdpToggle.checked;
            syncProtectionTileVisuals();
            maybeRerender();
        });
    }

    // SureReplica sub-chip
    const sureReplicaChip = document.querySelector('[data-prot-sub-chip="sure-replica"]');
    if (sureReplicaChip) {
        sureReplicaChip.addEventListener('click', () => {
            const isActive = sureReplicaRequiredInput?.value === 'yes';
            setSureReplicaValue(isActive ? 'no' : 'yes');
            maybeRerender();
        });
    }

    // Run initial visual sync
    syncProtectionTileVisuals();
}

// ── End Protection Tile System ──────────────────────────────────────────────



// syncTemplateJobsToggles removed — template design is now derived entirely from impl-delivery-style:
// skeleton → always applies 20% design reduction; white-glove/REA → full design effort.
// No DOM toggle needed.

function syncAdvisorySupportRowVisibility() {
    // advisory-support row is REA-only; impl-style radio group is Standard PS only
    const isRea = getImplementationMode() === 'none';
    const advisoryRow = document.getElementById('advisory-support-row');
    if (advisoryRow) advisoryRow.style.display = isRea ? '' : 'none';
    const templateJobsRow = document.getElementById('template-jobs-row');
    if (templateJobsRow) templateJobsRow.style.display = isRea ? 'none' : '';
    if (!isRea) {
        // Reset REA advisory toggle when switching away from REA
        const advisoryToggle = document.getElementById('advisory-support-required');
        if (advisoryToggle) { advisoryToggle.checked = false; updateToggleLabel(advisoryToggle); }
    } else {
        // Reset impl-delivery-style to skeleton when switching to REA
        const skeletonRadio = document.getElementById('impl-delivery-style-skeleton');
        if (skeletonRadio) { skeletonRadio.checked = true; }
    }
}

function syncImplementationModeControl() {
    const selectedMode = getImplementationMode();
    const selectedIndex = implementationModeInputs.findIndex((input) => input.checked);
    const normalizedIndex = selectedIndex >= 0 ? selectedIndex : 0;

    if (implementationModeGroup) {
        implementationModeGroup.style.setProperty('--implementation-selected-index', String(normalizedIndex));
        implementationModeGroup.dataset.selectedMode = selectedMode;
    }
}

function initializeImplementationModeControl() {
    syncImplementationModeControl();
    syncAdvisorySupportRowVisibility();

    implementationModeInputs.forEach((input) => {
        if (input.dataset.implementationModeBound === 'true') {
            return;
        }

        input.addEventListener('change', () => {
            if (!input.checked) {
                return;
            }

            syncImplementationModeControl();
            syncAdvisorySupportRowVisibility();

            if (isStep3Ready()) {
                scheduleRenderEstimate();
            }
        });

        input.dataset.implementationModeBound = 'true';
    });
}

function setImplementationMode(value) {
    const normalizedValue = Object.hasOwn(implementationModeLabels, value) ? value : 'none';
    const option = document.querySelector(`input[name="implementation-mode"][value="${normalizedValue}"]`);
    if (option) {
        option.checked = true;
    }

    syncImplementationModeControl();
}



function createSite(initialState = {}) {
    const siteId = Number.isInteger(initialState.id) && initialState.id > 0 ? initialState.id : AppState.nextSiteId;
    AppState.nextSiteId = Math.max(AppState.nextSiteId, siteId + 1);
    const siteName = typeof initialState.name === 'string' ? initialState.name : '';

    return normalizeSiteForEngagement({
        id: siteId,
        name: siteName,
        renameDraft: typeof initialState.renameDraft === 'string' ? initialState.renameDraft : siteName,
        isRenaming: initialState.isRenaming === true,
        vdcVaultSourceStorageType: typeof initialState.vdcVaultSourceStorageType === 'string' ? initialState.vdcVaultSourceStorageType : '',
        vdcVaultRepositoryType: typeof initialState.vdcVaultRepositoryType === 'string' ? initialState.vdcVaultRepositoryType : '',
        vdcVaultTargetVault: typeof initialState.vdcVaultTargetVault === 'string' ? initialState.vdcVaultTargetVault : '',
        pendingExistingEnvironmentSelection: initialState.pendingExistingEnvironmentSelection === true,
        existingEnvironment: normalizeExistingEnvironment(initialState.existingEnvironment),
        existingEnvironmentCustomLabels: normalizeExistingEnvironmentCustomLabels(
            initialState.existingEnvironmentCustomLabels || initialState.existingEnvironmentLabels || {}
        ),
        existingEnvironmentDisplayOrder: Array.isArray(initialState.existingEnvironmentDisplayOrder) ? [...initialState.existingEnvironmentDisplayOrder] : null,
        existingEnvironmentVbrVersions:  (initialState.existingEnvironmentVbrVersions  && typeof initialState.existingEnvironmentVbrVersions  === 'object') ? { ...initialState.existingEnvironmentVbrVersions  } : undefined,
        existingEnvironmentVbrPlatforms: (initialState.existingEnvironmentVbrPlatforms && typeof initialState.existingEnvironmentVbrPlatforms === 'object') ? { ...initialState.existingEnvironmentVbrPlatforms } : undefined,
        existingEnvironmentVbrHaRoles:   (initialState.existingEnvironmentVbrHaRoles   && typeof initialState.existingEnvironmentVbrHaRoles   === 'object') ? { ...initialState.existingEnvironmentVbrHaRoles   } : undefined,
        existingEnvironmentVbrHaPairIds: (initialState.existingEnvironmentVbrHaPairIds && typeof initialState.existingEnvironmentVbrHaPairIds === 'object') ? { ...initialState.existingEnvironmentVbrHaPairIds } : undefined,
        existingEnvironmentVroVersions:  (initialState.existingEnvironmentVroVersions  && typeof initialState.existingEnvironmentVroVersions  === 'object') ? { ...initialState.existingEnvironmentVroVersions  } : undefined,
        existingEnvironmentVoneVersions: (initialState.existingEnvironmentVoneVersions && typeof initialState.existingEnvironmentVoneVersions === 'object') ? { ...initialState.existingEnvironmentVoneVersions } : undefined,
        existingEnvironmentRepoPlatform:       (initialState.existingEnvironmentRepoPlatform       === 'linux') ? 'linux' : 'windows',
        existingEnvironmentVb365ProxyPlatform: (initialState.existingEnvironmentVb365ProxyPlatform === 'linux') ? 'linux' : 'windows',
        existingEnvironmentVb365RepoTypes: (initialState.existingEnvironmentVb365RepoTypes && typeof initialState.existingEnvironmentVb365RepoTypes === 'object') ? { ...initialState.existingEnvironmentVb365RepoTypes } : {},
        existingEnvironmentVb365RepoConsumedTbs: (initialState.existingEnvironmentVb365RepoConsumedTbs && typeof initialState.existingEnvironmentVb365RepoConsumedTbs === 'object') ? { ...initialState.existingEnvironmentVb365RepoConsumedTbs } : {},
        existingEnvironmentServerVersions: (initialState.existingEnvironmentServerVersions && typeof initialState.existingEnvironmentServerVersions === 'object') ? { ...initialState.existingEnvironmentServerVersions } : undefined,
        workloads: Array.isArray(initialState.workloads) ? initialState.workloads : [],
        uncategorisedWorkloads: Array.isArray(initialState.uncategorisedWorkloads) ? initialState.uncategorisedWorkloads : [],
        protectedWorkloads: Array.isArray(initialState.protectedWorkloads) ? initialState.protectedWorkloads : [],
        veeamServers: Array.isArray(initialState.veeamServers) ? initialState.veeamServers : [],
        paletteWorkloads: Array.isArray(initialState.paletteWorkloads) ? initialState.paletteWorkloads : [],
        jobs: Array.isArray(initialState.jobs) ? initialState.jobs.map((j) => ({ ...j })) : [],
        unprotectedWorkloads: Array.isArray(initialState.unprotectedWorkloads) ? initialState.unprotectedWorkloads.map((w) => ({ ...w })) : [],
        // Source workload refactor — Phase 1 data model
        sourceWorkloads: Array.isArray(initialState.sourceWorkloads) ? initialState.sourceWorkloads.map((w) => ({ ...w, label: w.label || '', jobs: (w.jobs || []).map((j) => ({ ...j })) })) : [],
        repositories:    Array.isArray(initialState.repositories)    ? initialState.repositories.map((r) => ({ ...r }))    : [],
        step2Only: initialState.step2Only === true,
    });
}
window.createSite = createSite;

function resetSites(siteDefinitions = [{}]) {
    sites.length = 0;
    AppState.nextSiteId                = 1;
    AppState.nextWorkloadRowId         = 1;
    AppState.nextJobId                 = 1;
    AppState.nextUnprotectedWorkloadId = 1;
    AppState.nextHypervisorMigrationId  = 1;
    AppState.nextVb365RepoMigrationId   = 1;
    AppState.nextVbrRepoMigrationId     = 1;
    hypervisorMigrationScopes.length    = 0;
    vb365RepoMigrationScopes.length     = 0;
    vbrRepoMigrationScopes.length       = 0;
    AppState.hvmEnabled = true;
    setCollapsibleSectionState('hypervisor-migration', true);
    setCollapsibleSectionState('repo-migration', true);
    setCollapsibleSectionState('platform', true);
    siteDefinitions.forEach((siteDefinition) => {
        sites.push(createSite(siteDefinition));
    });

    if (sites.length === 0) {
        sites.push(createSite());
    }

    // Advance ID counters past any restored IDs to avoid collisions
    const maxRestoredJobId = sites.flatMap((s) => Array.isArray(s.jobs) ? s.jobs.map((j) => j.id) : []).reduce((max, id) => Math.max(max, Number.isInteger(id) ? id : 0), 0);
    if (maxRestoredJobId >= AppState.nextJobId) AppState.nextJobId = maxRestoredJobId + 1;
    const maxRestoredUnprotectedId = sites.flatMap((s) => Array.isArray(s.unprotectedWorkloads) ? s.unprotectedWorkloads.map((w) => w.id) : []).reduce((max, id) => Math.max(max, Number.isInteger(id) ? id : 0), 0);
    if (maxRestoredUnprotectedId >= AppState.nextUnprotectedWorkloadId) AppState.nextUnprotectedWorkloadId = maxRestoredUnprotectedId + 1;
    // Advance veeamServer ID counter past restored instance IDs (instanceId format: 'vs-N')
    const maxRestoredVeeamServerId = sites.flatMap((s) => Array.isArray(s.veeamServers) ? s.veeamServers.map((sv) => {
        const m = typeof sv.instanceId === 'string' ? sv.instanceId.match(/^vs-(\d+)$/) : null;
        return m ? parseInt(m[1], 10) : 0;
    }) : []).reduce((max, id) => Math.max(max, id), 0);
    if (maxRestoredVeeamServerId >= AppState.nextVeeamServerId) AppState.nextVeeamServerId = maxRestoredVeeamServerId + 1;
    // Advance sourceWorkload and repository ID counters past restored IDs
    const maxRestoredSourceWorkloadId = sites.flatMap((s) => Array.isArray(s.sourceWorkloads) ? s.sourceWorkloads.map((sw) => sw.id || 0) : []).reduce((max, id) => Math.max(max, Number.isInteger(id) ? id : 0), 0);
    if (maxRestoredSourceWorkloadId >= AppState.nextSourceWorkloadId) AppState.nextSourceWorkloadId = maxRestoredSourceWorkloadId + 1;
    const maxRestoredRepositoryId = sites.flatMap((s) => Array.isArray(s.repositories) ? s.repositories.map((r) => r.id || 0) : []).reduce((max, id) => Math.max(max, Number.isInteger(id) ? id : 0), 0);
    if (maxRestoredRepositoryId >= AppState.nextRepositoryId) AppState.nextRepositoryId = maxRestoredRepositoryId + 1;
}



// existingEnvironmentGlobalVbr/Vb365DependentKeys — moved to gf-drawer.js.

// §VALIDATION
// ── Workload validation + step navigation ─────────────────────────────────────

window.VEEAM_SERVER_TYPES = VEEAM_SERVER_TYPES; // bridge for helpers.js and scope-matrix.js


/**
 * Sync existingEnvironment counts from the named veeamServers array.
 * VBR is managed exclusively as a count chip (existingEnvironment.vbrServers)
 * via addComponentToSiteFromDrawer, so it is intentionally NOT derived here.
 * Extend this function when VB365, Kasten, etc. gain their own existingEnvironment keys.
 */
function getSelectedWorkloadCount() {
    return sites.reduce((sum, site) => sum + (hasConfiguredSiteScope(site) ? 1 : 0), 0);
}

function hasSelectedWorkloads() {
    return getSelectedWorkloadCount() > 0;
}


function getSitesMissingWorkloads() {
    return sites
        .filter((s) => !s.step2Only)
        .map((site, index) => ({
            id: site.id,
            label: getSiteDisplayName(site, index),
            hasWorkloads: hasConfiguredSiteScope(site)
        }))
        .filter((site) => !site.hasWorkloads);
}

function getSitesWithPendingWorkloadSelections() {
    return sites
        .filter((s) => !s.step2Only)
        .map((site, index) => ({
            id: site.id,
            label: getSiteDisplayName(site, index),
            hasPendingSelection: hasPendingWorkloadSelection(site)
        }))
        .filter((site) => site.hasPendingSelection);
}


function hasCompleteSiteWorkloads() {
    return getSitesMissingWorkloads().length === 0
        && getSitesWithPendingWorkloadSelections().length === 0
        && true
        && getSitesWithIncompleteRepoMigrationSelections().length === 0;
}

function getSiteWorkloadValidationMessage() {
    const pendingSites = getSitesWithPendingWorkloadSelections();
    if (pendingSites.length) {
        const labels = pendingSites.map((site) => site.label);
        return labels.length === 1
            ? `${labels[0]} has an unselected workload row. Select a workload or remove the row before continuing.`
            : `${labels.join(', ')} have unselected workload rows. Select a workload or remove those rows before continuing.`;
    }

    const pendingExistingEnvironmentSites = [];
    if (pendingExistingEnvironmentSites.length) {
        const labels = pendingExistingEnvironmentSites.map((site) => site.label);
        return labels.length === 1
            ? `${labels[0]} has an unselected Veeam component row. Select a Veeam component or remove the row before continuing.`
            : `${labels.join(', ')} have unselected Veeam component rows. Select a Veeam component or remove those rows before continuing.`;
    }

    const incompleteRepoMigrationSites = getSitesWithIncompleteRepoMigrationSelections();
    if (incompleteRepoMigrationSites.length) {
        if (incompleteRepoMigrationSites.length === 1) {
            const [site] = incompleteRepoMigrationSites;
            return `${site.label} needs ${describeRepoMigrationSelectionGaps(site)} before continuing.`;
        }

        const labels = incompleteRepoMigrationSites.map((site) => site.label);
        const gapDescriptions = new Set(incompleteRepoMigrationSites.map((site) => describeRepoMigrationSelectionGaps(site)));
        if (gapDescriptions.size === 1) {
            const [sharedGap] = Array.from(gapDescriptions);
            return `${labels.join(', ')} each need ${sharedGap} before continuing.`;
        }

        return `${labels.join(', ')} need complete source storage and repository selections before continuing.`;
    }

    const missingSites = getSitesMissingWorkloads();
    if (!missingSites.length) {
        return '';
    }

    const labels = missingSites.map((site) => site.label);
    if (getCanvasEngagementFlags().hV) {
        return labels.length === 1
            ? `${labels[0]} needs migration data before continuing.`
            : `${labels.join(', ')} each need migration data before continuing.`;
    }

    // If every incomplete site has only Coming Soon workloads, surface the more specific message
    const devOnlySites = missingSites.filter((s) => siteHasOnlyInDevelopmentWorkloads(getSiteById(s.id)));
    if (devOnlySites.length === missingSites.length) {
        const devLabels = devOnlySites.map((s) => s.label);
        return devLabels.length === 1
            ? `${devLabels[0]} only has Coming Soon workloads and cannot be estimated yet. Add VMware or Hyper-V workloads to continue.`
            : `${devLabels.join(', ')} only have Coming Soon workloads and cannot be estimated yet. Add VMware or Hyper-V workloads to continue.`;
    }

    return labels.length === 1
        ? `${labels[0]} needs at least one workload before continuing.`
        : `${labels.join(', ')} each need at least one workload before continuing.`;
}

function updateWorkloadValidationState() {
    return hasSelectedWorkloads() && hasCompleteSiteWorkloads();
}
window.updateWorkloadValidationState = updateWorkloadValidationState;

function reportMissingWorkloads() {
    updateWorkloadValidationState();
    const message = getEmptyScopeValidationMessage();
    renderOutputMessage(message);
    const showWarningTone = getTotalInstanceCount() === 0;
    showStepValidationMessage(message, showWarningTone ? 'warning' : 'error');
    // Unified canvas: shouldRenderWorkloadInputs() always true; isExistingEnvironmentInScope() always false.
    const { hV, hC } = getCanvasEngagementFlags();
    const firstTarget = hC
        ? siteList.querySelector('[data-site-action="add-inline-existing-environment"]')
        : hV
            ? siteList.querySelector('[data-site-repo-migration-tb]')
            : siteList.querySelector('[data-site-action="add-inline-workload"]');

    if (firstTarget) {
        firstTarget.focus();
    }
}

function reportIncompleteSites() {
    const message = getSiteWorkloadValidationMessage() || getIncompleteSiteScopeValidationMessage();
    updateWorkloadValidationState();
    renderOutputMessage(message);
    showStepValidationMessage(message);

    const firstIncompleteSite = getSitesMissingWorkloads()[0];
    const firstIncompleteRepoMigrationSite = getSitesWithIncompleteRepoMigrationSelections()[0];
    const { hV, hC } = getCanvasEngagementFlags();
    // Unified canvas: shouldRenderWorkloadInputs() always true.
    if (firstIncompleteSite) {
        updateSiteActionStates();
        siteList.querySelector(`[data-site-action="add-inline-workload"][data-site-id="${firstIncompleteSite.id}"]`)?.focus();
        return;
    }

    if (hC) {
        const addButton = firstIncompleteSite
            ? siteList.querySelector(`[data-site-action="add-inline-existing-environment"][data-site-id="${firstIncompleteSite.id}"]`)
            : siteList.querySelector('[data-site-action="add-inline-existing-environment"]');

        if (addButton) {
            addButton.focus();
        }
        return;
    }

    // isExistingEnvironmentInScope() always false; vault canvas possible (hV flag).
    const firstSelect = hV
        ? (firstIncompleteSite
            ? siteList.querySelector(`[data-site-action="add-inline-repo-migration"][data-site-id="${firstIncompleteSite.id}"]`)
            : firstIncompleteRepoMigrationSite
                ? (firstIncompleteRepoMigrationSite.missingSourceStorage
                    ? siteList.querySelector(getSiteScopePickerTriggerSelector(getRepoMigrationSourceStoragePickerKey(firstIncompleteRepoMigrationSite.id, firstIncompleteRepoMigrationSite.rowId)))
                    : firstIncompleteRepoMigrationSite.missingRepository
                        ? siteList.querySelector(getSiteScopePickerTriggerSelector(getRepoMigrationRepositoryPickerKey(firstIncompleteRepoMigrationSite.id, firstIncompleteRepoMigrationSite.rowId)))
                    : siteList.querySelector(getSiteScopePickerTriggerSelector(getRepoMigrationTargetPickerKey(firstIncompleteRepoMigrationSite.id, firstIncompleteRepoMigrationSite.rowId))))
                : siteList.querySelector('[data-site-action="add-inline-repo-migration"]'))
        : (firstIncompleteSite
            ? siteList.querySelector(`[data-site-workload-select="${firstIncompleteSite.id}"]`)
            : siteList.querySelector('[data-site-workload-select]'));

    if (firstSelect) {
        firstSelect.focus();
    }
}

function validateStep(step) {
    if (step === 2) {
        clearStepValidationMessage();
        const allToPlace = getS2AllUnprotectedWorkloads();
        if (allToPlace.length > 0) {
            const unassigned = getS2UnassignedWorkloads();
            if (unassigned.length > 0) {
                const n = unassigned.length;
                showStepValidationMessage(`${n} workload${n !== 1 ? 's' : ''} still need${n === 1 ? 's' : ''} to be assigned to a VBR server before continuing.`);
                return false;
            }
        }
        clearStepValidationMessage();
        return true;
    }

    if (step !== 1) {
        return true;
    }

    clearStepValidationMessage();

    // Read from whichever project-name input is currently visible.
    // The canonical #project-name input is hidden inside .source-card; the
    // gf-summary-name canvas input is the visible one.  Sync whichever has a
    // value so that both are always in agreement before we validate.
    const visibleNameInput = document.querySelector('[data-gf-project-name]');
    if (visibleNameInput && visibleNameInput.value.trim()) {
        projectNameInput.value = visibleNameInput.value.trim();
    } else if (projectNameInput.value.trim() && visibleNameInput) {
        visibleNameInput.value = projectNameInput.value.trim();
    }
    const projectName = projectNameInput.value.trim();
    projectNameInput.value = projectName;

    // Collect both top-level errors upfront so the user sees everything at once.
    const missingName  = !projectName && !AppState.devModeEnabled;
    const missingScope = !hasSelectedWorkloads();

    if (missingName || missingScope) {
        const errors = [];
        if (missingName)  errors.push(projectValidationMessage);
        if (missingScope) errors.push(workloadValidationMessage);

        showStepValidationMessage(errors.length === 1 ? errors[0] : errors);

        // Focus the most relevant field — name takes priority.
        if (missingName) {
            const visibleNameInput = document.querySelector('[data-gf-project-name]') || projectNameInput;
            visibleNameInput.focus();
            // Flash a red border on the input to draw attention.
            visibleNameInput.classList.add('input--validation-error');
            clearTimeout(visibleNameInput._validationErrorTimer);
            visibleNameInput._validationErrorTimer = setTimeout(() => {
                visibleNameInput.classList.remove('input--validation-error');
            }, 2500);
            visibleNameInput.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
        return false;
    }

    projectNameInput.setCustomValidity('');

    if (!hasCompleteSiteWorkloads()) {
        reportIncompleteSites();
        return false;
    }

    // ── Protected workload / job → required Veeam product check ──────────────
    // If any protected workload chip OR job canvas entry references a workload
    // type, the controlling Veeam product must be added as a server before
    // proceeding to Step 2.  Full mapping:
    //
    //   Hypervisor VMs (all platforms)           → VBR
    //   CDP Universal Agent (cdp-universal-agent)→ VBR  (VBR-managed CDP, not a standalone agent)
    //   Enterprise plug-ins (plugin-*)           → VBR
    //   Unstructured data / NAS                  → VBR
    //   Microsoft Entra ID                       → VBR  (VBR-native, not VBfAz)
    //   AWS workloads (aws-*)                    → Veeam Backup for AWS
    //   Azure workloads (azure-*)                → Veeam Backup for Azure
    //   Google Cloud workloads (gcp-*)           → Veeam Backup for Google Cloud
    //   Microsoft 365                            → Veeam Backup for Microsoft 365
    //   Kubernetes clusters (Kasten K10)         → Kasten K10
    {
        // Collect workload types from both scoped workload chips and canvas jobs.
        const allProtectedWorkloads = sites.flatMap((s) =>
            Array.isArray(s.protectedWorkloads) ? s.protectedWorkloads.filter((w) => w.value) : []
        );
        const allJobs = sites.flatMap((s) =>
            Array.isArray(s.jobs) ? s.jobs.filter((j) => j.workloadType) : []
        );

        const allWorkloadTypes = new Set([
            ...allProtectedWorkloads.map((w) => w.value),
            ...allJobs.map((j) => j.workloadType),
        ]);

        if (allWorkloadTypes.size > 0) {
            // Determine which Veeam products are required by the scoped workloads.
            const needsVbr = [...allWorkloadTypes].some((wt) =>
                Object.hasOwn(hypervisorLabels, wt) ||
                Object.hasOwn(pluginLabels, wt)     ||
                wt === unstructuredDataWorkloadId    ||
                wt === 'entra-id'                   ||
                wt === 'cdp-universal-agent'
            );
            const needsVbfAws = [...allWorkloadTypes].some((wt) => String(wt).startsWith('aws-'));
            const needsVbfAz  = [...allWorkloadTypes].some((wt) => String(wt).startsWith('azure-'));
            const needsVbfGc  = [...allWorkloadTypes].some((wt) => String(wt).startsWith('gcp-'));
            const needsVb365  = allWorkloadTypes.has(veeamBackupForMicrosoft365WorkloadId);
            const needsKasten = allWorkloadTypes.has(kastenK10WorkloadId);

            // Check which products are actually present (any site qualifies).
            // hasVbrAcrossAllSites() checks BOTH site.existingEnvironment.vbrServers
            // (comp chip) and site.veeamServers (named server instance).
            const hasVbr    = hasVbrAcrossAllSites();
            const hasVbfAws = sites.some((s) => Array.isArray(s.veeamServers) && s.veeamServers.some((sv) => sv.type === 'vbfaws'));
            const hasVbfAz  = sites.some((s) => Array.isArray(s.veeamServers) && s.veeamServers.some((sv) => sv.type === 'vbfaz'));
            const hasVbfGc  = sites.some((s) => Array.isArray(s.veeamServers) && s.veeamServers.some((sv) => sv.type === 'vbfgc'));
            const hasVb365  = sites.some((s) => Array.isArray(s.veeamServers) && s.veeamServers.some((sv) => sv.type === 'vb365'));
            const hasKasten = sites.some((s) => Array.isArray(s.veeamServers) && s.veeamServers.some((sv) => sv.type === 'kasten'));

            const missingComponents = [];
            if (needsVbr    && !hasVbr)    missingComponents.push('a VBR server is required for hypervisor, CDP, plug-in, and unstructured data workloads');
            if (needsVbfAws && !hasVbfAws) missingComponents.push('Veeam Backup for AWS is required for AWS workloads');
            if (needsVbfAz  && !hasVbfAz)  missingComponents.push('Veeam Backup for Azure is required for Azure workloads');
            if (needsVbfGc  && !hasVbfGc)  missingComponents.push('Veeam Backup for Google Cloud is required for Google Cloud workloads');
            if (needsVb365  && !hasVb365)  missingComponents.push('Veeam Backup for Microsoft 365 is required for Microsoft 365 workloads');
            if (needsKasten && !hasKasten) missingComponents.push('Kasten K10 is required for Kubernetes workloads');

            if (missingComponents.length > 0) {
                const messages = missingComponents.map((m) => `Add the required component — ${m}.`);
                showStepValidationMessage(messages.length === 1 ? messages[0] : messages);
                return false;
            }
        }
    }
    // ─────────────────────────────────────────────────────────────────────────

    // ── Uncategorised workloads must be categorised before proceeding ─────────
    {
        const uncategorisedRemaining = sites.some((s) =>
            Array.isArray(s.uncategorisedWorkloads) && s.uncategorisedWorkloads.some((w) => w.value)
        );
        if (uncategorisedRemaining) {
            showStepValidationMessage('Add at least one Backup Job to scope the engagement before continuing.');
            return false;
        }
    }
    // ─────────────────────────────────────────────────────────────────────────

    clearStepValidationMessage();
    updateWorkloadValidationState();
    return true;
}


function updateWizardButtons(step) {
    prevStepBtn.hidden = step === 1;
    nextStepBtn.hidden = step === totalSteps;

    if (step < totalSteps) {
        nextStepBtn.textContent = stepButtonLabels[step];
    }

    syncNextStepAvailability(step);
}

function syncNextStepAvailability(step = AppState.currentStep) {
    // Step 1: subdued (soft warning) when no workloads selected.
    const shouldSubdueStep1 = step === 1 && !hasSelectedWorkloads();

    // Step 2: hard gate — all workloads must be assigned to a compatible Veeam component.
    // Each product's workloads must be placed in the correct lane type:
    //   VBR workloads       → VBR lane
    //   VBfCloud workloads  → matching VBfCloud appliance lane (per provider)
    //   VB365 workloads     → VB365 lane
    let step2UnassignedMessages = [];
    if (step === 2) {
        const vbrUnassigned = getS2UnassignedWorkloads().length;
        if (vbrUnassigned > 0) {
            step2UnassignedMessages.push(`${vbrUnassigned} VBR workload${vbrUnassigned !== 1 ? 's' : ''} unassigned`);
        }
        for (const [provider, cfg] of Object.entries(CLOUD_PROVIDER_CONFIGS)) {
            const providerUnassigned = getS2CloudAllWorkloads(provider).length > 0
                ? getS2CloudUnassignedWorkloads(provider).length
                : 0;
            if (providerUnassigned > 0) {
                step2UnassignedMessages.push(`${providerUnassigned} ${cfg.shortLabel} workload${providerUnassigned !== 1 ? 's' : ''} unassigned`);
            }
        }
        if (getS2Vb365BlocksNavigation()) {
            const vb365Unassigned = getS2Vb365UnassignedWorkloads().length;
            step2UnassignedMessages.push(`${vb365Unassigned} VB365 workload${vb365Unassigned !== 1 ? 's' : ''} unassigned`);
        }
    }
    const step2Blocked = step2UnassignedMessages.length > 0;

    const shouldGateNextStep = step2Blocked;
    const shouldSubdueNextStep = shouldSubdueStep1;

    nextStepBtn.disabled = shouldGateNextStep;
    nextStepBtn.classList.toggle('primary-button--pending', shouldGateNextStep);
    nextStepBtn.classList.toggle('primary-button--subdued', !shouldGateNextStep && shouldSubdueNextStep);
    nextStepBtn.setAttribute('aria-disabled', String(shouldGateNextStep));

    if (step2Blocked) {
        // Render a structured blocker banner listing each specific issue
        const msgEl = document.getElementById('step-validation-message');
        if (msgEl) {
            const itemsHtml = step2UnassignedMessages
                .map(m => `<span class="step-validation-message__item">
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex-shrink:0;margin-top:2px"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                    ${m}
                </span>`)
                .join('');
            msgEl.innerHTML = `<span class="step-validation-message__heading">Resolve before continuing to step 3</span>${itemsHtml}`;
            msgEl.hidden = false;
            msgEl.classList.remove('step-validation-message--warning');
        }
        // Also pin the hint pill next to the button so the reason is visible
        // without scrolling — consistent with how step 1 surfaces its warning.
        const nextStepHint = document.getElementById('next-step-hint');
        if (nextStepHint) {
            const textEl = nextStepHint.querySelector('.wizard-nav__hint-text');
            const summary = step2UnassignedMessages.length === 1
                ? step2UnassignedMessages[0]
                : `${step2UnassignedMessages.length} workload groups unassigned`;
            if (textEl) textEl.textContent = ' ' + summary;
            nextStepHint.dataset.hintPinned = 'true';
            nextStepHint.hidden = false;
            nextStepHint.classList.add('wizard-nav__hint--flash-error');
        }
        return;
    }

    // Clear the pinned hint whenever the block is lifted.
    const nextStepHint2 = document.getElementById('next-step-hint');
    if (nextStepHint2 && nextStepHint2.dataset.hintPinned && !shouldSubdueNextStep) {
        nextStepHint2.classList.remove('wizard-nav__hint--flash-error', 'wizard-nav__hint--flash-warning');
        delete nextStepHint2.dataset.hintPinned;
        const textEl2 = nextStepHint2.querySelector('.wizard-nav__hint-text');
        if (textEl2) textEl2.textContent = '';
        nextStepHint2.hidden = true;
    }

    const nextStepHint = document.getElementById('next-step-hint');
    if (nextStepHint) {
        if (!nextStepHint.dataset.hintPinned) {
            nextStepHint.hidden = true;
        }
    }
}

function canNavigateToStep(targetStep) {
    if (targetStep <= AppState.currentStep) {
        return true;
    }

    // Validate each intermediate step. Temporarily set AppState.currentStep so
    // validateStep reads the correct state, then restore unconditionally
    // so the active step is never left as a side-effect of this check.
    for (let step = 1; step < targetStep; step += 1) {
        const savedStep = AppState.currentStep;
        AppState.currentStep = step;
        const valid = validateStep(step);
        AppState.currentStep = savedStep;
        if (!valid) {
            return false;
        }
    }

    return true;
}
window.syncNextStepAvailability = syncNextStepAvailability;

function requestStepNavigation(targetStep) {
    const shouldWarnBeforeEstimate = targetStep === totalSteps && AppState.currentStep < totalSteps;

    if (!shouldWarnBeforeEstimate) {
        setCurrentStep(targetStep);
        return;
    }

    if (!(step3WarningDialog instanceof HTMLDialogElement)) {
        setCurrentStep(targetStep);
        return;
    }

    AppState.pendingStepNavigation = targetStep;

    if (!step3WarningDialog.open) {
        step3WarningDialog.showModal();
    }
}

function confirmPendingStepNavigation() {
    const targetStep = AppState.pendingStepNavigation;
    dismissStep3WarningDialog();

    if (Number.isInteger(targetStep)) {
        setCurrentStep(targetStep);
    }
}

function setCurrentStep(step) {
    const previousStep = AppState.currentStep;
    AppState.currentStep = Math.min(Math.max(step, 1), totalSteps);
    appLayout.dataset.currentStep = String(AppState.currentStep);
    appLayout.dataset.stepDirection = AppState.currentStep < previousStep ? 'back' : 'forward';

    if (AppState.currentStep !== previousStep) {
        closeWorkloadPicker();
        closeGfDrawer();
        if (AppState.currentStep !== 1) {
            closeSourceWorkloadPane();
        }
    }

    if (AppState.currentStep !== 1) {
        clearStepValidationMessage();
    }

    wizardSteps.forEach((wizardStep) => {
        const isCurrent = parseInt(wizardStep.dataset.step, 10) === AppState.currentStep;
        wizardStep.hidden = !isCurrent;
        wizardStep.classList.toggle('is-active', isCurrent);
    });

    updateWizardProgress(AppState.currentStep);
    updateWizardButtons(AppState.currentStep);
    updateSavePdfVisibility(AppState.currentStep);

    if (AppState.currentStep === 2) {
        syncDesignOptionFields();
        autoAddLinkedVbrLanes();
        autoAddLinkedVb365Lanes();
        renderStep2Canvas(); // pruneStaleAssignments() runs inside here — re-sync nav after
        syncNextStepAvailability(2);
        renderArchitectureCardSection();
        renderScopeMatrix();
        syncMatrixToHiddenInputs();
    }

    if (AppState.currentStep === totalSteps) {
        if (hasSelectedWorkloads() && hasCompleteSiteWorkloads()) {
            renderEstimate();
        } else {
            renderOutputMessage(
                hasSelectedWorkloads()
                    ? (getSiteWorkloadValidationMessage() || getIncompleteSiteScopeValidationMessage())
                    : getEmptyScopeValidationMessage()
            );
        }
    }
}

const assumptionToggleLabels = {
    'assumption-bandwidth-adequate': 'Network bandwidth is adequate for backup and recovery',
    'assumption-customer-resource-available': 'Customer resource will be available',
    'assumption-remote-delivery-accepted': 'Remote delivery is accepted',
    'assumption-admin-access-provided': 'Admin access provided before start',
    'assumption-licence-in-place': 'Valid Veeam licence in place',
    'assumption-change-control': 'Customer manages change control / CAB process',
};
window.assumptionToggleLabels = assumptionToggleLabels;
window.updateAssumptionsRiskNotice = updateAssumptionsRiskNotice;



function initializeBinaryToggles() {
    binaryToggleIds.forEach((id) => {
        const toggle = document.getElementById(id);
        if (!toggle) return;

        updateToggleLabel(toggle);
        if (toggle.dataset.toggleBound === 'true') return;

        toggle.addEventListener('change', () => {
            updateToggleLabel(toggle);

            if (toggle.id in assumptionToggleLabels) {
                updateAssumptionsRiskNotice();
            }


            if (toggle.id === 'replication-required') {
                syncReplicationFields();
            }

            if (toggle.id === 'tape-integration-required') {
                syncTapeConnectivityField();
            }

            if (toggle.id === 'veeam-one-required') {
                toggle.dataset.explicitChoice = 'true';
            }

        });
        toggle.dataset.toggleBound = 'true';
    });

    syncDesignOptionFields();
}

function updateTotalInstances() {
    // Unified canvas: shouldRenderWorkloadInputs() always true; upgrade/health-check branch removed.
    if (shouldRenderRepoMigrationTable()) {
        updateRepoMigrationHeader(getRepoMigrationTotalProtectedTb());
        updateTotalInstanceHeader(0);
        return;
    }

    updateTotalInstanceHeader(getTotalInstanceCount());
    updateGfSummaryCount();
}
window.updateTotalInstances = updateTotalInstances;

function getTotalInstanceCount() {
    return sites.reduce((sum, site) => {
        const legacyCount = site.workloads.reduce((siteSum, workload) => siteSum + getWorkloadScopeCount(workload), 0);
        const paletteCount = Array.isArray(site.paletteWorkloads)
            ? site.paletteWorkloads.reduce((siteSum, wl) => siteSum + (wl.qty || 1), 0)
            : 0;
        return sum + legacyCount + paletteCount;
    }, 0);
}

function updateTotalInstanceHeader(totalInstances = getTotalInstanceCount()) {
    const headerCount = document.getElementById('total-instance-header-count');

    if (headerCount) {
        headerCount.textContent = `(${totalInstances})`;
    }
}

function getRepoMigrationHeaderCountText(totalProtectedTb = getRepoMigrationTotalProtectedTb()) {
    return `(${formatProtectedTbValue(totalProtectedTb)} TB total)`;
}

function updateRepoMigrationHeader(totalProtectedTb = getRepoMigrationTotalProtectedTb()) {
    const headerCount = document.getElementById('total-vdc-vault-header-count');

    if (headerCount) {
        headerCount.textContent = getRepoMigrationHeaderCountText(totalProtectedTb);
    }
}

function updateSiteActionStates() {
    // Unified canvas: shouldRenderWorkloadInputs() always true.
    siteList.querySelectorAll('[data-site-action="add-inline-workload"]').forEach((button) => {
        const siteId = parseInt(button.dataset.siteId, 10);
        const site = getSiteById(siteId);
        const disabled = !site || !canAddWorkloadRow(site);
        button.disabled = disabled;
        button.setAttribute('aria-disabled', String(disabled));
    });
    if (shouldRenderRepoMigrationTable()) {
        siteList.querySelectorAll('[data-site-action="add-inline-repo-migration"]').forEach((button) => {
            const siteId = parseInt(button.dataset.siteId, 10);
            const disabled = !getSiteById(siteId);
            button.disabled = disabled;
            button.setAttribute('aria-disabled', String(disabled));
        });
    } else if (shouldRenderExistingEnvironmentTable()) {
        siteList.querySelectorAll('[data-site-action="add-inline-existing-environment"]').forEach((button) => {
            const siteId = parseInt(button.dataset.siteId, 10);
            const site = getSiteById(siteId);
            const disabled = !site || !getNextAvailableExistingEnvironmentField(site);
            button.disabled = disabled;
            button.setAttribute('aria-disabled', String(disabled));
        });
    } else {
        siteList.querySelectorAll('[data-site-workload-select]').forEach((select) => {
            const siteId = parseInt(select.dataset.siteWorkloadSelect, 10);
            const addButton = siteList.querySelector(`[data-site-action="add-workload"][data-site-id="${siteId}"]`);
            const hasSelection = Boolean(select.value);

            if (!addButton) {
                return;
            }

            addButton.disabled = !hasSelection;
            addButton.setAttribute('aria-disabled', String(!hasSelection));
        });
    }

    siteList.querySelectorAll('[data-site-action="remove-site"]').forEach((button) => {
        const disabled = sites.length === 1;
        button.disabled = disabled;
        button.setAttribute('aria-disabled', String(disabled));
    });
}



function renderSiteCard(siteId, focusSelector = '') {
    // Unified canvas: shouldRenderWorkloadInputs() always true; always delegates to renderSiteList().
    renderSiteList();
    if (focusSelector) {
        siteList.querySelector(focusSelector)?.focus();
    }
}
window.renderSiteCard = renderSiteCard;

// §GF-CHIP-LAYOUT
// ── Greenfield Canvas (chip layout) ─────────────────────────────────────────

// ── Inline SVG icon constants (no external icon font needed) ─────────────────

const GF_SVG_GRIP_SM = `<svg width="8" height="12" viewBox="0 0 8 12" fill="currentColor" aria-hidden="true"><circle cx="2" cy="2" r="1.2"/><circle cx="6" cy="2" r="1.2"/><circle cx="2" cy="6" r="1.2"/><circle cx="6" cy="6" r="1.2"/><circle cx="2" cy="10" r="1.2"/><circle cx="6" cy="10" r="1.2"/></svg>`;
window.GF_SVG_GRIP_SM = GF_SVG_GRIP_SM;
// GF_SVG_PLUS imported from recalc.js (single source of truth)
window.GF_SVG_PLUS = GF_SVG_PLUS;
const GF_SVG_CLOSE   = `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>`;
window.GF_SVG_CLOSE = GF_SVG_CLOSE;

// ── Category label tooltips ──────────────────────────────────────────────────
const GF_CATEGORY_TOOLTIPS = {
    'Unprotected Workloads': 'Servers, VMs, NAS, cloud instances, and other infrastructure that needs new Veeam backup coverage.',
    'Currently Protected Workloads':        'Workloads already protected by existing Veeam backup or replication jobs in this environment. For accurate scoping — including health checks and upgrades — all protected workloads should be added here. Even upgrade engagements require existing backup jobs to be defined.',
    'Existing Veeam Environment': 'Existing Veeam jobs and infrastructure at this site — including currently protected workloads, deployed Veeam components (VBR servers, proxies, repositories), and backup repositories to be migrated to Veeam Data Cloud Vault.',
    'Veeam Components':          'Existing Veeam infrastructure already deployed at this site — VBR servers, proxies, repositories, and gateways.',
};
window.GF_CATEGORY_TOOLTIPS = GF_CATEGORY_TOOLTIPS;

// ── Category label icons — inline SVG prepended to each section heading ───────
const _SVG_ATTRS = 'width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
const GF_CATEGORY_ICONS = {
    // Shield with exclamation — "these workloads need protection"
    'Unprotected Workloads':
        `<svg ${_SVG_ATTRS}><path d="M12 3L20 7v5c0 5.25-3.6 10.2-8 11.95C7.6 22.2 4 17.25 4 12V7l8-4z"/><path d="M12 10v3M12 16.5h.01"/></svg>`,
    // Two server rows with status dot — "existing infrastructure"
    'Existing Veeam Environment':
        `<svg ${_SVG_ATTRS}><rect x="3" y="5" width="18" height="6" rx="1.5"/><rect x="3" y="13" width="18" height="6" rx="1.5"/><path d="M7 8h.01M7 16h.01"/></svg>`,
};
window.GF_CATEGORY_ICONS = GF_CATEGORY_ICONS;

/**
 * Returns a `<span class="gf-chip-group-label">` with an inline info-icon
 * tooltip for the four main categories.
 */
const GF_SVG_PENCIL  = `<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg>`;
window.GF_SVG_PENCIL = GF_SVG_PENCIL;

// Icons for Veeam server types — used on canvas chips and in the drawer
const VEEAM_SERVER_TYPE_ICONS = {
    vbr:             `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="3" width="20" height="6" rx="1"/><rect x="2" y="15" width="20" height="6" rx="1"/><line x1="6" y1="6" x2="6.01" y2="6"/><line x1="6" y1="18" x2="6.01" y2="18"/></svg>`,
    vb365:           `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.92V21a1 1 0 0 1-1.094.995 15.993 15.993 0 0 1-6.976-2.482A15.75 15.75 0 0 1 9 14.51a15.993 15.993 0 0 1-2.482-7.002A1 1 0 0 1 7.505 6.5H12a1 1 0 0 1 1 .894 9.944 9.944 0 0 0 .544 2.188 1 1 0 0 1-.225 1.058L12 11.96a15.806 15.806 0 0 0 4.044 4.044l1.32-1.319a1 1 0 0 1 1.058-.225 9.944 9.944 0 0 0 2.188.544A1 1 0 0 1 22 16.92z"/></svg>`,
    kasten:          `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>`,
    vbfaws:          `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#FF9900" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="17 21 12 16 7 21"/><polyline points="7 3 12 8 17 3"/><line x1="12" y1="8" x2="12" y2="16"/></svg>`,
    vbfgc:          `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#4285F4" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20A10 10 0 0 0 12 2z"/><path d="M12 8v4l3 3"/></svg>`,
    vbfaz:           `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#0078d4" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>`,
    vbrServers:      `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="3" width="20" height="6" rx="1"/><rect x="2" y="15" width="20" height="6" rx="1"/><line x1="6" y1="6" x2="6.01" y2="6"/><line x1="6" y1="18" x2="6.01" y2="18"/></svg>`,
    vroServers:      `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>`,
    veeamOneServers: `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>`,
    vbemServers:     `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>`,
};
window.VEEAM_SERVER_TYPE_ICONS = VEEAM_SERVER_TYPE_ICONS;

// GF_SVG_ICONS imported from recalc.js


/** Type metadata for workload chips */
const GF_WORKLOAD_TYPE_MAP = (() => {
    const map = {};
    workloadOptionGroups.forEach((group) => {
        group.options.forEach((opt) => {
            map[opt.value] = group.label;
        });
    });
    return map;
})();
window.GF_WORKLOAD_TYPE_MAP = GF_WORKLOAD_TYPE_MAP;





function buildGreenfieldCanvasMarkup() {
    const canvasItems = sites.filter((s) => !s.step2Only).map((site, index) => buildGfSiteCardMarkup(site, index)).join('');
    return `<div class="gf-canvas" id="gf-canvas">
        ${buildGfSummaryBarMarkup()}
        <div id="gf-sites">${canvasItems}</div>
        ${buildGfAddSiteCardMarkup()}
    </div>`;
}

const GF_SVG_DOC = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/><line x1="3" y1="13" x2="21" y2="13"/></svg>`;

function buildGfSummaryBarMarkup() {
    const projectName = projectNameInput?.value?.trim() || '';
    const countHtml = getGfTotalCountHtml();
    return `<div class="gf-summary-bar" id="gf-summary-bar">
        <span class="gf-summary-icon">${GF_SVG_DOC}</span>
        <input class="gf-summary-name"
               id="gf-summary-name"
               type="text"
               value="${escapeHtml(projectName)}"
               placeholder="Customer or project name"
               data-gf-project-name
               aria-label="Project name"
               spellcheck="false">
        <span class="gf-summary-divider" aria-hidden="true"></span>
        <span class="gf-summary-count" id="gf-summary-count">${countHtml}</span>
    </div>`;
}

/**
 * Returns a context-aware count summary for non-greenfield engagement types.
 *  - Upgrade / Health Check → "X components across Y sites"
 *  - Vault Migration → "X.X TB across Y sites"
 */
function getNonGfCountHtml() {
    const totalSites = sites.length;
    const siteText = totalSites === 1 ? 'across 1 site' : `across ${totalSites} sites`;
    const { hV } = getCanvasEngagementFlags();

    if (hV) {
        const tb = getRepoMigrationTotalProtectedTb();
        const tbText = `${formatProtectedTbValue(tb)} TB`;
        const tailHtml = `<span class="gf-summary-tail"><strong>${escapeHtml(tbText)}</strong> ${escapeHtml(siteText)}</span>`;

        // Breakdown: total TB grouped by source storage type
        const bySource = {};
        sites.forEach((site) => {
            getRepoMigrationWorkloads(site).forEach((workload) => {
                const sourceValue = workload.vdcVaultSourceStorageType || '';
                const sourceTb = getRepoMigrationWorkloadProtectedTb(workload);
                const sourceLabel = getRepoMigrationPickerOptionLabel(repoMigrationSourceStorageOptions, sourceValue)
                    || (sourceValue || 'Unknown');
                if (!bySource[sourceValue]) bySource[sourceValue] = { label: sourceLabel, tb: 0 };
                bySource[sourceValue].tb += sourceTb;
            });
        });
        const breakdownParts = Object.values(bySource)
            .filter(({ tb }) => tb > 0)
            .map(({ label, tb }) => `${formatProtectedTbValue(tb)} TB ${label}`);
        const breakdownHtml = breakdownParts.length
            ? `<span class="gf-summary-breakdown">${escapeHtml(breakdownParts.join(', '))}</span>`
            : '';

        return `${tailHtml}${breakdownHtml}`;
    }

    // Upgrade / Health Check — count configured existing-environment components across all sites.
    // site.existingEnvironment is an object keyed by field name (e.g. { vbrServers: 2, ... }),
    // not an array, so we iterate the schema and use hasExistingEnvironmentFieldValue to check each.
    const relevantFields = existingEnvironmentFieldSchema.filter(
        (field) => !field.engagementTypes
    );
    const totalComponents = sites.reduce((sum, site) => {
        if (!site.existingEnvironment || typeof site.existingEnvironment !== 'object') return sum;
        return sum + relevantFields.filter(
            (field) => hasExistingEnvironmentFieldValue(site.existingEnvironment, field.key)
        ).length;
    }, 0);
    const compText = totalComponents === 1 ? '1 component' : `${totalComponents} components`;
    const tailHtml = `<span class="gf-summary-tail"><strong>${escapeHtml(compText)}</strong> ${escapeHtml(siteText)}</span>`;

    // Breakdown: total count per component type across all sites
    const breakdownParts = relevantFields
        .map((field) => {
            const total = sites.reduce((sum, site) => {
                if (!site.existingEnvironment || typeof site.existingEnvironment !== 'object') return sum;
                return sum + normalizeEnvironmentCount(site.existingEnvironment[field.key]);
            }, 0);
            return total > 0 ? `${total} ${field.label}` : null;
        })
        .filter(Boolean);
    const breakdownHtml = breakdownParts.length
        ? `<span class="gf-summary-breakdown">${escapeHtml(breakdownParts.join(', '))}</span>`
        : '';

    return `${tailHtml}${breakdownHtml}`;
}

/** Refresh only the count span in the non-greenfield name bar (preserves input focus). */
function updateNonGfNameBarCount() {
    const el = document.getElementById('ng-summary-count');
    if (el) el.innerHTML = getNonGfCountHtml();
}
window.updateNonGfNameBarCount = updateNonGfNameBarCount;

function getGfTotalCountHtml() {
    const totalSites = sites.length;

    // Count every distinct card type on the canvas
    const totalSourceWorkloads   = sites.reduce((sum, s) => sum + (Array.isArray(s.sourceWorkloads) ? s.sourceWorkloads.length : 0), 0);
    // Legacy fallback counts — retained until phases 3-5 of source workload refactor are complete
    const totalLegacyJobs        = sites.reduce((sum, s) => sum + (Array.isArray(s.jobs) ? s.jobs.length : 0), 0);
    const totalLegacyUnprotected = sites.reduce((sum, s) => sum + (Array.isArray(s.unprotectedWorkloads) ? s.unprotectedWorkloads.length : 0), 0);
    const totalWorkloadCards  = totalSourceWorkloads + totalLegacyJobs + totalLegacyUnprotected;
    const totalVault          = sites.reduce((sum, s) => sum + s.workloads.filter((w) => w.value && isRepoMigrationWorkload(w.value)).length, 0);
    const totalServers        = sites.reduce((sum, s) => sum + (Array.isArray(s.veeamServers) ? s.veeamServers.length : 0), 0);
    const totalComps          = sites.reduce((sum, s) => sum + getCanvasCompItems(s).length, 0);
    const totalCompCards      = totalServers + totalComps;

    // Inline SVG helper — 11×11, stroke style matching the rest of the codebase
    const svg = (path) => `<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${path}</svg>`;
    const pill = (count, singular, plural, svgPath) => {
        if (count === 0) return '';
        const label = count === 1 ? singular : plural;
        return `<span class="gf-summary-pill">${svg(svgPath)}<strong>${count}</strong> ${label}</span>`;
    };

    const pills = [
        pill(totalWorkloadCards, 'workload', 'workloads',
            '<path d="M12 3L20 7v5c0 5.25-3.6 10.2-8 11.95C7.6 22.2 4 17.25 4 12V7l8-4z"/><path d="M12 10v3M12 16.5h.01"/>'),
        pill(totalVault, 'repo', 'repos',
            '<ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M3 5v4c0 1.66 4.03 3 9 3s9-1.34 9-3V5"/><path d="M3 9v6c0 1.66 4.03 3 9 3s9-1.34 9-3V9"/>'),
        pill(totalCompCards, 'component', 'components',
            '<rect x="3" y="5" width="18" height="6" rx="1.5"/><rect x="3" y="13" width="18" height="6" rx="1.5"/><path d="M7 8h.01M7 16h.01"/>'),
    ].filter(Boolean);

    // Sites pill — always shown
    const siteLabel = totalSites === 1 ? 'site' : 'sites';
    const sitesPill = `<span class="gf-summary-pill gf-summary-pill--sites">${svg('<circle cx="12" cy="10" r="3"/><path d="M12 2a8 8 0 0 1 8 8c0 5.25-8 12-8 12S4 15.25 4 10a8 8 0 0 1 8-8z"/>')}<strong>${totalSites}</strong> ${siteLabel}</span>`;

    return pills.join('') + sitesPill;
}

/** Update only the count span — avoids rebuilding the whole bar (preserves input focus) */
function updateGfSummaryCount() {
    const el = document.getElementById('gf-summary-count');
    if (el) el.innerHTML = getGfTotalCountHtml();
}
window.updateGfSummaryCount = updateGfSummaryCount;

/**
 * The keys whose counts are automatically managed by named server instance badges
 * (written by syncExistingEnvironmentFromServers). These must NOT also render as
 * standalone count chips — doing so would show VBR twice.
 */
/** Returns existing-environment comp items for canvas display. */


// §JOB-CANVAS — extracted to job-canvas.js

// §UNPROTECTED-CANVAS — extracted to unprotected-canvas.js

// ── Greenfield Sortables — moved to greenfield-sortables.js ──────────────────
// initGreenfieldSortables and initVaultSortables are imported from that module.

// §GF-EVENT-WIRING
// ── Greenfield Canvas Event Wiring ───────────────────────────────────────────

// lockedQtyFieldKeys — defined and window-bridged in greenfield-sortables.js.
// Drawer state vars, SVG constants, and drawer group config — moved to gf-drawer.js.

function wireGreenfieldCanvasEvents() {
    const canvas = document.getElementById('gf-canvas');
    if (!canvas) return;

    // All canvas click handling via delegation
    canvas.addEventListener('click', (e) => {
        // Add workload button
        const openBtn = e.target.closest('[data-gf-open]');
        if (openBtn) {
            openGfDrawer(parseInt(openBtn.dataset.gfOpen, 10), 'greenfield');
            return;
        }

        // Add Veeam Server button (named instance)
        const openCompBtn = e.target.closest('[data-gf-open-comp]');
        if (openCompBtn) {
            openGfDrawer(parseInt(openCompBtn.dataset.gfOpenComp, 10), 'existing-env');
            return;
        }

        // Add Protected Workload button
        const openProtectedBtn = e.target.closest('[data-gf-open-protected]');
        if (openProtectedBtn) {
            openGfDrawer(parseInt(openProtectedBtn.dataset.gfOpenProtected, 10), 'protected');
            return;
        }

        // Add vault migration button
        const openVaultBtn = e.target.closest('[data-gf-open-vault]');
        if (openVaultBtn) {
            openGfDrawer(parseInt(openVaultBtn.dataset.gfOpenVault, 10), 'vault');
            return;
        }

        // Clone site
        const cloneBtn = e.target.closest('[data-gf-clone]');
        if (cloneBtn) {
            cloneSite(parseInt(cloneBtn.dataset.gfClone, 10));
            return;
        }

        // Remove site
        const removeBtn = e.target.closest('[data-gf-remove]');
        if (removeBtn && !removeBtn.disabled) {
            removeSite(parseInt(removeBtn.dataset.gfRemove, 10));
            return;
        }

        // Remove workload chip
        const chipRemoveBtn = e.target.closest('[data-gf-chip-remove]');
        if (chipRemoveBtn && !chipRemoveBtn.dataset.gfCompChipRemove) {
            const chip = chipRemoveBtn.closest('[data-gf-chip]');
            const zone = chipRemoveBtn.closest('[data-gf-site]');
            if (chip && zone) {
                const siteId = parseInt(zone.dataset.gfSite, 10);
                const workloadValue = chip.dataset.gfChipValue;
                removeWorkloadFromSite(siteId, workloadValue);
            }
            return;
        }

        // Remove component chip (legacy path — keep for any remaining old chips)
        const compChipRemoveBtn = e.target.closest('[data-gf-comp-chip-remove]');
        if (compChipRemoveBtn) {
            const siteId = parseInt(compChipRemoveBtn.dataset.gfCompSite, 10);
            const compKey = compChipRemoveBtn.dataset.gfCompChipRemove;
            removeComponentFromSite(siteId, compKey);
            return;
        }

        // Decrement a locked-qty comp chip (VBR/VRO/VONE/VB365 repos) — removes one slot at a time
        const lockedCompDecrBtn = e.target.closest('[data-gf-locked-comp-decrement]');
        if (lockedCompDecrBtn) {
            const siteId    = parseInt(lockedCompDecrBtn.dataset.gfCompSite, 10);
            const field     = lockedCompDecrBtn.dataset.gfLockedCompDecrement;
            const slotIndex = lockedCompDecrBtn.dataset.gfLockedCompSlotIndex !== ''
                ? parseInt(lockedCompDecrBtn.dataset.gfLockedCompSlotIndex, 10)
                : null;
            const version   = lockedCompDecrBtn.dataset.gfLockedCompVersion  || null;
            const platform  = lockedCompDecrBtn.dataset.gfLockedCompPlatform || null;
            const haRole    = lockedCompDecrBtn.dataset.gfLockedCompHaRole   || null;
            const haPairId  = lockedCompDecrBtn.dataset.gfLockedCompHaPairId || null;
            decrementLockedCompChipOnSite(siteId, field, version, platform, haRole, haPairId, slotIndex);
            return;
        }

        // VB365 repo type badge — open step drawer in 'change' mode for this specific slot
        const vb365RepoTypeBadge = e.target.closest('[data-gf-vb365-repo-type-badge]');
        if (vb365RepoTypeBadge) {
            const siteId    = parseInt(vb365RepoTypeBadge.dataset.gfCompSite, 10);
            const slotIndex = parseInt(vb365RepoTypeBadge.dataset.slotIndex, 10);
            openVb365RepoStepDrawer(siteId, 'change', slotIndex);
            return;
        }

        // VBR repo source badge — open vault step drawer in 'change' mode for this workload entry
        const vbrRepoSourceBadge = e.target.closest('[data-gf-vbr-repo-source-badge]');
        if (vbrRepoSourceBadge) {
            const rowId  = parseInt(vbrRepoSourceBadge.dataset.gfChip, 10);
            const siteId = parseInt(vbrRepoSourceBadge.dataset.gfChipSite, 10);
            openVaultStepDrawer(siteId, 'change', rowId);
            return;
        }

        // Remove all instances of a non-VBR server type (count chip remove)
        const serverTypeRemoveBtn = e.target.closest('[data-gf-server-type-remove]');
        if (serverTypeRemoveBtn) {
            const typeKey = serverTypeRemoveBtn.dataset.gfServerTypeRemove;
            const siteId  = parseInt(serverTypeRemoveBtn.dataset.gfServerTypeSite, 10);
            const site    = getSiteById(siteId);
            if (site && Array.isArray(site.veeamServers)) {
                site.veeamServers = site.veeamServers.filter((s) => s.type !== typeKey);
                syncExistingEnvironmentFromServers(site);
                renderSiteList();
                syncDesignOptionFields();
                updateNonGfNameBarCount();
                updateGfSummaryCount();
            }
            return;
        }

        // (legacy) Remove Veeam Server Instance card by instanceId — kept for backwards compat
        const serverRemoveBtn = e.target.closest('[data-server-remove]');
        if (serverRemoveBtn) {
            const instanceId = serverRemoveBtn.dataset.serverRemove;
            const siteId = parseInt(serverRemoveBtn.dataset.serverRemoveSite, 10);
            removeVeeamServerFromSite(siteId, instanceId);
            return;
        }

        // Remove Protected Workload chip
        const pwRemoveBtn = e.target.closest('[data-gf-pw-remove]');
        if (pwRemoveBtn) {
            const rowId = parseInt(pwRemoveBtn.dataset.gfPwRemove, 10);
            const zone = pwRemoveBtn.closest('[data-gf-site]');
            if (zone) {
                const siteId = parseInt(zone.dataset.gfSite, 10);
                removeProtectedWorkloadFromSite(siteId, rowId);
            }
            return;
        }

        // Remove Uncategorised Workload chip
        const uncRemoveBtn = e.target.closest('[data-gf-unc-remove]');
        if (uncRemoveBtn) {
            const rowId = parseInt(uncRemoveBtn.dataset.gfUncRemove, 10);
            const zone  = uncRemoveBtn.closest('[data-gf-site]');
            if (zone) {
                const siteId = parseInt(zone.dataset.gfSite, 10);
                removeUncategorisedWorkloadFromSite(siteId, rowId);
            }
            return;
        }

        // Add site card
        if (e.target.closest('#gf-add-site-btn')) {
            addSiteFromInlineControl();
            return;
        }

        // [Phase 6] Job remove button removed — jobs replaced by source workloads.
    });

    // Component chip quantity changes (legacy path)
    canvas.addEventListener('change', (e) => {
        const qtyInput = e.target.closest('[data-gf-comp-chip-qty]');
        if (qtyInput) {
            const siteId = parseInt(qtyInput.dataset.gfCompSite, 10);
            const compKey = qtyInput.dataset.gfCompChipQty;
            const newCount = Math.max(0, parseInt(qtyInput.value, 10) || 0);
            const site = getSiteById(siteId);
            if (site) {
                if (!site.existingEnvironment) site.existingEnvironment = {};
                if (newCount === 0) {
                    delete site.existingEnvironment[compKey];
                } else {
                    site.existingEnvironment[compKey] = newCount;
                }
                updateTotalInstances();
                updateWorkloadValidationState();
                syncNextStepAvailability();
            }
            // Resize input to fit the committed value
            qtyInput.style.width = Math.max(1, qtyInput.value.length || 1) + 'ch';
        }
    });

    // Resize component chip qty inputs as the user types
    canvas.addEventListener('input', (e) => {
        const qtyInput = e.target.closest('[data-gf-comp-chip-qty]');
        if (!qtyInput) return;
        qtyInput.style.width = Math.max(1, qtyInput.value.length || 1) + 'ch';
    });

    // Locked-qty comp chip (VBR/VRO/VONE) — resize as the user types
    canvas.addEventListener('input', (e) => {
        const qtyInput = e.target.closest('[data-gf-locked-comp-qty]');
        if (!qtyInput) return;
        qtyInput.style.width = Math.max(1, qtyInput.value.length || 1) + 'ch';
        const val = parseInt(qtyInput.value, 10) || 0;
        qtyInput.classList.toggle('is-empty', val === 0);
    });

    // VB365 repo consumed TB — write per-slot and resize as the user types
    canvas.addEventListener('input', (e) => {
        const tbInput = e.target.closest('[data-gf-vb365-repo-consumed-tb]');
        if (!tbInput) return;
        const siteId    = parseInt(tbInput.dataset.gfCompSite, 10);
        const slotIndex = parseInt(tbInput.dataset.slotIndex, 10);
        const site = getSiteById(siteId);
        if (site) {
            if (!site.existingEnvironmentVb365RepoConsumedTbs || typeof site.existingEnvironmentVb365RepoConsumedTbs !== 'object') {
                site.existingEnvironmentVb365RepoConsumedTbs = {};
            }
            const tbVal = parseFloat(tbInput.value);
            site.existingEnvironmentVb365RepoConsumedTbs[slotIndex] = (isFinite(tbVal) && tbVal > 0) ? tbVal : 0;
            tbInput.style.width = Math.max(2, tbInput.value.length || 2) + 'ch';
            scheduleRenderEstimate();
        }
    });

    // Locked-qty comp chip (VBR/VRO/VONE) — commit quantity change on blur/Enter
    canvas.addEventListener('change', (e) => {
        const qtyInput = e.target.closest('[data-gf-locked-comp-qty]');
        if (!qtyInput) return;
        const siteId   = parseInt(qtyInput.dataset.gfCompSite, 10);
        const field    = qtyInput.dataset.gfLockedCompQty;
        const version  = qtyInput.dataset.gfLockedCompVersion  || null;
        const platform = qtyInput.dataset.gfLockedCompPlatform || null;
        const haRole   = qtyInput.dataset.gfLockedCompHaRole   || null;
        const haPairId = qtyInput.dataset.gfLockedCompHaPairId || null;
        const newQty   = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        const site     = getSiteById(siteId);
        if (!site) return;

        const current = normalizeEnvironmentCount(site.existingEnvironment?.[field]);
        if (newQty > current) {
            for (let i = 0; i < newQty - current; i++) {
                incrementLockedCompSlotOnSite(siteId, field, version || null, platform || null, haRole || null, haPairId || null);
            }
        } else if (newQty < current) {
            for (let i = 0; i < current - newQty; i++) {
                decrementLockedCompChipOnSite(siteId, field, version || null, platform || null, haRole || null, haPairId || null);
            }
        }

        qtyInput.style.width = Math.max(1, newQty.toString().length) + 'ch';
        renderSiteList();
        syncDesignOptionFields();
        updateNonGfNameBarCount();
        updateGfSummaryCount();
    });

    // Non-VBR server type count chip qty changes
    canvas.addEventListener('change', (e) => {
        const qtyInput = e.target.closest('[data-gf-server-type-qty]');
        if (!qtyInput) return;
        const typeKey = qtyInput.dataset.gfServerTypeQty;
        const siteId  = parseInt(qtyInput.dataset.gfServerTypeSite, 10);
        const site    = getSiteById(siteId);
        if (!site || !Array.isArray(site.veeamServers)) return;
        const newCount = Math.max(0, parseInt(qtyInput.value, 10) || 0);
        const current  = site.veeamServers.filter((s) => s.type === typeKey).length;
        if (newCount > current) {
            for (let i = 0; i < newCount - current; i++) addVeeamServerToSite(siteId, typeKey);
        } else if (newCount < current) {
            let toRemove = current - newCount;
            site.veeamServers = site.veeamServers.filter((s) => {
                if (s.type === typeKey && toRemove > 0) { toRemove--; return false; }
                return true;
            });
            syncExistingEnvironmentFromServers(site);
            renderSiteList();
            updateNonGfNameBarCount();
            updateGfSummaryCount();
        }
        qtyInput.style.width = Math.max(1, qtyInput.value.length || 1) + 'ch';
    });

    canvas.addEventListener('input', (e) => {
        const qtyInput = e.target.closest('[data-gf-server-type-qty]');
        if (!qtyInput) return;
        qtyInput.style.width = Math.max(1, qtyInput.value.length || 1) + 'ch';
    });

    // Veeam Server card name edits (contenteditable)
    canvas.addEventListener('focusout', (e) => {
        const nameEl = e.target;
        if (!(nameEl instanceof HTMLElement) || !nameEl.matches('[data-server-name]')) return;
        const instanceId = nameEl.dataset.serverName;
        const siteId     = parseInt(nameEl.dataset.serverNameSite, 10);
        const newName    = nameEl.textContent.trim();
        updateVeeamServerField(siteId, instanceId, 'name', newName);
    }, true);

    // [Phase 6] Job count, agent version, unprotected add/remove/count handlers removed.
    // Jobs and unprotected workloads replaced by source workloads (sourceWorkloadPane).

    // Source workload — Add button (opens drawer in 'source-workload' mode)
    canvas.addEventListener('click', (e) => {
        const addSwBtn = e.target.closest('[data-add-source-workload]');
        if (addSwBtn) {
            openGfDrawer(parseInt(addSwBtn.dataset.addSourceWorkload, 10), 'source-workload');
        }
    });

    // Source workload — chip click (opens config pane)
    canvas.addEventListener('click', (e) => {
        const removeBtn  = e.target.closest('[data-swp-remove]');
        const addJobBtn  = e.target.closest('[data-swp-add-job]');
        const chip       = e.target.closest('[data-swp-chip]');
        if (removeBtn) {
            removeSourceWorkloadFromSite(
                parseInt(removeBtn.dataset.swpSiteId,  10),
                parseInt(removeBtn.dataset.swpRemove,  10)
            );
            closeSourceWorkloadPane();
            return;
        }
        if (addJobBtn) {
            // Open the pane (skip toggle — always open, never close on this button)
            const parentChip = addJobBtn.closest('[data-swp-chip]');
            if (parentChip) {
                const siteId = parseInt(parentChip.dataset.swpSiteId,     10);
                const wlId   = parseInt(parentChip.dataset.swpWorkloadId, 10);
                const state  = getSourceWorkloadPaneState();
                if (state.siteId !== siteId || state.workloadId !== wlId) {
                    openSourceWorkloadPane(siteId, wlId);
                }
                // Scroll the type picker into view once the pane has rendered
                setTimeout(() => {
                    const picker = document.querySelector('.swp-type-picker');
                    if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }, 50);
            }
            return;
        }
        if (chip) {
            openSourceWorkloadPane(
                parseInt(chip.dataset.swpSiteId,     10),
                parseInt(chip.dataset.swpWorkloadId, 10)
            );
        }
    });

    // Source workload chip — keyboard activation (Enter / Space)
    canvas.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        const chip = e.target.closest('[data-swp-chip]');
        if (chip) {
            e.preventDefault();
            openSourceWorkloadPane(
                parseInt(chip.dataset.swpSiteId,     10),
                parseInt(chip.dataset.swpWorkloadId, 10)
            );
        }
    });

    // [Phase 6] Job add/picker/server-tag handlers removed — jobs replaced by source workloads.

    // Uncategorised workload quantity changes
    canvas.addEventListener('input', (e) => {
        const qtyInput = e.target.closest('[data-gf-unc-qty]');
        if (!qtyInput) return;
        const rowId = parseInt(qtyInput.dataset.gfUncQty, 10);
        const zone  = qtyInput.closest('[data-gf-site]');
        if (!zone) return;
        const siteId = parseInt(zone.dataset.gfSite, 10);
        const site   = getSiteById(siteId);
        if (!site || !Array.isArray(site.uncategorisedWorkloads)) return;
        const workload = site.uncategorisedWorkloads.find((w) => w.rowId === rowId);
        if (!workload) return;
        const raw = parseFloat(qtyInput.value);
        const val = Number.isFinite(raw) ? Math.max(0, raw) : 0;
        if (isProtectedTbWorkload(workload.value)) {
            workload.protectedTb = val;
            workload.count = calculateUnstructuredDataInstances(val);
        } else {
            workload.count = Math.round(val);
        }
        qtyInput.classList.toggle('is-empty', val === 0);
        qtyInput.style.width = Math.max(1, qtyInput.value.length || 1) + 'ch';
        updateTotalInstances();
        updateWorkloadValidationState();
    });

    // Project name summary input — keep #project-name in sync
    const summaryNameInput = canvas.querySelector('[data-gf-project-name]');
    if (summaryNameInput) {
        summaryNameInput.addEventListener('input', () => {
            if (projectNameInput) projectNameInput.value = summaryNameInput.value;
        });
    }

    // Quantity inputs — update workload count on change
    canvas.addEventListener('input', (e) => {
        const qtyInput = e.target.closest('[data-gf-chip-qty]');
        if (!qtyInput) return;
        const rowId = parseInt(qtyInput.dataset.gfChipQty, 10);
        const zone = qtyInput.closest('[data-gf-site]');
        if (!zone) return;
        const siteId = parseInt(zone.dataset.gfSite, 10);
        const site = getSiteById(siteId);
        if (!site) return;

        const workload = site.workloads.find((w) => w.rowId === rowId);
        if (!workload) return;

        const raw = parseFloat(qtyInput.value);
        const value = Number.isFinite(raw) ? Math.max(0, raw) : 0;

        if (isProtectedTbWorkload(workload.value)) {
            workload.protectedTb = value;
            workload.count = calculateUnstructuredDataInstances(value);
        } else {
            workload.count = Math.round(value);
        }

        // Toggle empty styling
        qtyInput.classList.toggle('is-empty', value === 0);

        // Resize input to fit the typed value
        qtyInput.style.width = Math.max(1, qtyInput.value.length || 1) + 'ch';

        updateTotalInstances();
        updateWorkloadValidationState();
    });

    // Suffix inputs — save custom notes text and resize the input to content
    canvas.addEventListener('input', (e) => {
        const suffixInput = e.target.closest('[data-gf-chip-suffix]');
        if (!suffixInput) return;
        const rowId = parseInt(suffixInput.dataset.gfChipSuffix, 10);
        const zone = suffixInput.closest('[data-gf-site]');
        if (!zone) return;
        const siteId = parseInt(zone.dataset.gfSite, 10);
        const site = getSiteById(siteId);
        if (!site) return;
        const workload = site.workloads.find((w) => w.rowId === rowId);
        if (!workload) return;
        workload.chipSuffix = suffixInput.value;
        // Mirror value into wrapper's data-value so ::after pseudo-element sizes the chip
        const wrap = suffixInput.closest('.gf-chip-suffix-wrap');
        if (wrap) wrap.dataset.value = suffixInput.value;
    });

    // Prevent sortable grip from activating when clicking inside a qty, suffix, or inline label
    canvas.addEventListener('mousedown', (e) => {
        if (e.target.closest('[data-gf-chip-qty]') || e.target.closest('[data-gf-chip-suffix]') || e.target.closest('[data-gf-chip-inline-label]') || e.target.closest('[data-gf-comp-inline-label]') || e.target.closest('[data-gf-locked-comp-qty]') || e.target.closest('[data-gf-comp-chip-qty]')) {
            e.stopPropagation();
        }
    }, true);

    // Track value before editing so Escape can restore it
    canvas.addEventListener('focusin', (e) => {
        const el = e.target;
        if (el instanceof HTMLElement && (el.matches('[data-gf-chip-inline-label]') || el.matches('[data-gf-comp-inline-label]'))) {
            el.dataset.chipPreEditValue = el.textContent.trim();
        }
    });

    // Commit GF chip inline label on blur (workloads, protected workloads, uncategorised workloads, vault workloads)
    canvas.addEventListener('focusout', (e) => {
        const el = e.target;
        if (!(el instanceof HTMLElement) || !el.matches('[data-gf-chip-inline-label]')) return;
        const rowId = parseInt(el.dataset.gfChipInlineLabel, 10);
        const zone = el.closest('[data-gf-site]');
        if (!zone) return;
        const siteId = parseInt(zone.dataset.gfSite, 10);
        const site = getSiteById(siteId);
        if (!site) return;
        const workload = site.workloads.find((w) => w.rowId === rowId)
            || (site.uncategorisedWorkloads || []).find((w) => w.rowId === rowId);
        if (!workload) return;
        const defaultLabel = el.dataset.chipDefaultLabel || '';
        const trimmed = el.textContent.trim();
        if (!trimmed || trimmed === defaultLabel) {
            delete workload.customLabel;
            if (!trimmed) el.textContent = defaultLabel;
        } else {
            workload.customLabel = trimmed;
        }
    });

    // Enter confirms, Escape cancels GF chip inline label edit
    canvas.addEventListener('keydown', (e) => {
        const el = e.target;
        if (!(el instanceof HTMLElement) || !el.matches('[data-gf-chip-inline-label]')) return;
        if (e.key === 'Enter') { e.preventDefault(); el.blur(); }
        else if (e.key === 'Escape') {
            el.textContent = el.dataset.chipPreEditValue || el.dataset.chipDefaultLabel || '';
            el.blur();
        }
    });

    // [Phase 6] Unprotected workload and job label handlers removed.

    // Commit comp chip inline label on blur (VBR, VB365, Kasten, etc.)
    canvas.addEventListener('focusout', (e) => {
        const el = e.target;
        if (!(el instanceof HTMLElement) || !el.matches('[data-gf-comp-inline-label]')) return;
        const itemKey = el.dataset.gfCompInlineLabel;
        const siteId = parseInt(el.dataset.gfCompSite, 10);
        const site = getSiteById(siteId);
        if (!site) return;
        const defaultLabel = el.dataset.chipDefaultLabel || '';
        const trimmed = el.textContent.trim();
        if (!site.existingEnvironmentCustomLabels) site.existingEnvironmentCustomLabels = {};
        if (!trimmed || trimmed === defaultLabel) {
            delete site.existingEnvironmentCustomLabels[itemKey];
            if (!trimmed) el.textContent = defaultLabel;
        } else {
            site.existingEnvironmentCustomLabels[itemKey] = trimmed;
        }
    });

    // Enter confirms, Escape cancels comp chip inline label edit
    canvas.addEventListener('keydown', (e) => {
        const el = e.target;
        if (!(el instanceof HTMLElement) || !el.matches('[data-gf-comp-inline-label]')) return;
        if (e.key === 'Enter') { e.preventDefault(); el.blur(); }
        else if (e.key === 'Escape') {
            el.textContent = el.dataset.chipPreEditValue || el.dataset.chipDefaultLabel || '';
            el.blur();
        }
    });

    // Site name contenteditable — prevent site-grip drag from stealing click
    canvas.querySelectorAll('[data-gf-site-name]').forEach((el) => {
        el.addEventListener('mousedown', (e) => e.stopPropagation());
        el.addEventListener('blur', () => {
            const siteId = parseInt(el.dataset.gfSiteName, 10);
            const site = getSiteById(siteId);
            if (!site) return;
            const newName = el.textContent.trim();
            if (newName !== site.name) {
                site.name = newName;
                site.renameDraft = newName;
                updateTotalInstances();
                updateWorkloadValidationState();
            }
        });
        el.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') { e.preventDefault(); el.blur(); }
            if (e.key === 'Escape') {
                const siteId = parseInt(el.dataset.gfSiteName, 10);
                const site = getSiteById(siteId);
                if (site) {
                    const index = sites.indexOf(site);
                    el.textContent = getSiteDisplayName(site, index);
                }
                el.blur();
            }
        });
    });
}

// §GF-DRAWER + §VAULT-DRAWER — extracted to gf-drawer.js
// §CORE-SITE-PIPELINE
// ── Chip-canvas builder functions for Upgrade / Health Check ─────────────────

// CHIP_PLATFORM_FIELD — defined in gf-drawer.js, window-bridged as window.CHIP_PLATFORM_FIELD.
// Chip rendering for the greenfield canvas goes through buildGfCompChipMarkup in helpers.js.

// ─────────────────────────────────────────────────────────────────────────────


function renderSiteList(options = {}) {
    const { animate = false } = options;
    const renderExistingEnvCanvas = shouldRenderExistingEnvironmentTable();
    const isVaultMigration = shouldRenderRepoMigrationTable();
    const renderTable = renderExistingEnvCanvas || isVaultMigration;

    // Remove any previously injected non-gf name bar and add-site button (siblings, not inside siteList)
    document.getElementById('ng-name-bar')?.remove();
    document.getElementById('ng-add-site-btn')?.remove();

    destroySortables();
    // Only apply the legacy table-frame when the type is neither an existing-env canvas nor vault migration
    // (vault migration now uses gf-canvas-host so it gets the same muted-bg visual treatment)
    siteList.classList.toggle('site-list--table-frame', renderTable && !renderExistingEnvCanvas && !isVaultMigration);
    // Unified canvas: tile-frame never used; all modes use gf-canvas-host.
    siteList.classList.toggle('site-list--tile-frame', false);
    siteList.classList.toggle('site-list--gf-canvas-host', true);
    siteList.classList.toggle('site-list--gated', false);

    if (!renderTable) {
        siteScopePickerUiState.openKey = '';
    }

    // Unified canvas: always renders the greenfield canvas (handles all workload types including vault tiles).
    const siteMarkup = buildGreenfieldCanvasMarkup();

    siteList.innerHTML = buildSiteListContentMarkup(siteMarkup);

    // Wire palette tile events
    wirePaletteTileEvents({ siteList });

    pruneWorkloadPickerUiState();
    pruneSiteScopePickerUiState();
    syncAllWorkloadPickerStates();
    syncAllSiteScopePickerStates();
    syncCloneSheepAnimations();
    if (animate) {
        applyStaggeredReveal(siteList);
    }

    syncSiteNamePlaceholders();
    updateSiteActionStates();
    updateTotalInstances();
    updateWorkloadValidationState();
    renderArchitectureCardSection();

    // Unified canvas: always wire sortables and greenfield canvas events.
    initSortable();
    wireGreenfieldCanvasEvents();

    syncNextStepAvailability();

    // Keep VSA migration section visibility in sync with step-1 VBR chip state.
    // Called here as a safety net so every site-list re-render (add/remove any
    // chip, workload, or job) keeps the section correctly hidden or shown.
    syncVsaMigrationSectionVisibility();
}
// ── Bus subscriptions ─────────────────────────────────────────────────────────
// Extracted modules emit these events instead of importing functions from script.js.
// Support optional detail payload so animate:true still works via the bus.
on(BUS_EVENTS.SITE_LIST_CHANGED,     (e) => renderSiteList(e.detail || {}));
on(BUS_EVENTS.DESIGN_SYNC_NEEDED,    () => syncDesignOptionFields());
on(BUS_EVENTS.VALIDATION_SYNC_NEEDED,() => { updateWorkloadValidationState(); syncNextStepAvailability(); });
on(BUS_EVENTS.COUNTS_SYNC_NEEDED,    () => { updateTotalInstances(); updateGfSummaryCount(); updateNonGfNameBarCount(); });
on(BUS_EVENTS.STEP2_CANVAS_CHANGED,  () => syncNextStepAvailability());

function insertSite(initialState = {}, insertIndex = sites.length, shouldRender = true) {
    const nextIndex = Math.min(Math.max(insertIndex, 0), sites.length);
    const site = createSite(initialState);
    sites.splice(nextIndex, 0, site);

    if (shouldRender) {
        renderSiteList();
    }

    return site;
}

function addSite(initialState = {}) {
    return insertSite(initialState, sites.length, true);
}
window.addSite = addSite;

function addSiteFromInlineControl() {
    const site = addSite({});
    // In greenfield canvas, focus the contenteditable site name
    const gfNameEl = siteList.querySelector(`[data-gf-site-name="${site.id}"]`);
    if (gfNameEl) {
        gfNameEl.focus();
        // Select all text in the contenteditable
        const range = document.createRange();
        range.selectNodeContents(gfNameEl);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
        return;
    }
    // Fallback for legacy table-based rendering
    const siteNameInput = siteList.querySelector(`[data-site-name="${site.id}"]`);
    siteNameInput?.focus();
    siteNameInput?.select();
}

// ── Source workload mutations ─────────────────────────────────────────────────
// These functions mutate site.sourceWorkloads[]. They live in script.js because
// they need renderSiteList() and renderScopeMatrix() — both unavailable in
// helper modules without creating import cycles.
// Window-bridged so gf-drawer.js can call them without importing script.js.

function addSourceWorkloadToSite(siteId, workloadValue) {
    const site = getSiteById(siteId);
    if (!site) return null;
    if (!Array.isArray(site.sourceWorkloads)) site.sourceWorkloads = [];
    const entry = buildDefaultSourceWorkloadEntry(workloadValue);
    site.sourceWorkloads.push(entry);
    emit(BUS_EVENTS.SITE_LIST_CHANGED);
    emit(BUS_EVENTS.DESIGN_SYNC_NEEDED);
    renderScopeMatrix();
    syncMatrixToHiddenInputs();
    emit(BUS_EVENTS.COUNTS_SYNC_NEEDED);
    emit(BUS_EVENTS.VALIDATION_SYNC_NEEDED);
    scheduleRenderEstimate();
    return entry;
}
window.addSourceWorkloadToSite = addSourceWorkloadToSite;

function removeSourceWorkloadFromSite(siteId, workloadId) {
    const site = getSiteById(siteId);
    if (!site || !Array.isArray(site.sourceWorkloads)) return;
    site.sourceWorkloads = site.sourceWorkloads.filter((w) => w.id !== workloadId);
    emit(BUS_EVENTS.SITE_LIST_CHANGED);
    emit(BUS_EVENTS.DESIGN_SYNC_NEEDED);
    renderScopeMatrix();
    syncMatrixToHiddenInputs();
    emit(BUS_EVENTS.COUNTS_SYNC_NEEDED);
    emit(BUS_EVENTS.VALIDATION_SYNC_NEEDED);
    scheduleRenderEstimate();
}
window.removeSourceWorkloadFromSite = removeSourceWorkloadFromSite;

function cloneSite(siteId) {
    const siteIndex = sites.findIndex((site) => site.id === siteId);
    if (siteIndex === -1) {
        return null;
    }

    const sourceSite = sites[siteIndex];
    const clonedState = cloneSiteState(sourceSite);
    const clonedName = buildCopySiteName(sourceSite, siteIndex);
    delete clonedState.id;
    clonedState.name = clonedName;
    clonedState.renameDraft = clonedName;

    const clonedSite = insertSite(clonedState, siteIndex + 1, true);
    updateSiteActionStates();
    // Focus the cloned site's name field (greenfield canvas uses contenteditable)
    const gfNameEl = siteList.querySelector(`[data-gf-site-name="${clonedSite.id}"]`);
    if (gfNameEl) { gfNameEl.focus(); }
    else { siteList.querySelector(`[data-site-name="${clonedSite.id}"]`)?.focus(); }
    return clonedSite;
}

function addWorkloadToSite(siteId, workloadValue) {
    const site = getSiteById(siteId);
    if (!site || !workloadValue) {
        return false;
    }

    if (site.workloads.some((workload) => workload.value === workloadValue)) {
        const existingWorkload = site.workloads.find((workload) => workload.value === workloadValue);
        renderSiteCard(siteId, getSiteWorkloadPickerTriggerSelector(siteId, getWorkloadRowId(existingWorkload)));
        return false;
    }

    const nextEntry = buildDefaultSelectedWorkloadEntry(workloadValue);
    site.workloads.push(nextEntry);

    renderSiteCard(
        siteId,
        getSiteWorkloadPickerTriggerSelector(siteId, nextEntry.rowId)
    );
    return true;
}

function addInlineWorkloadToSite(siteId) {
    const site = getSiteById(siteId);
    if (!site || !canAddWorkloadRow(site)) {
        return false;
    }

    const pendingEntry = buildWorkloadEntry('', 0, null, '');
    site.workloads.push(pendingEntry);
    renderSiteList();
    openWorkloadPicker(siteId, pendingEntry.rowId);
    return true;
}

function addInlineRepoMigrationToSite(siteId) {
    const site = getSiteById(siteId);
    if (!site) {
        return false;
    }

    const pendingEntry = buildRepoMigrationEntry(50);
    site.workloads.push(pendingEntry);
    renderSiteList();
    siteList.querySelector(getSiteScopePickerTriggerSelector(getRepoMigrationSourceStoragePickerKey(siteId, pendingEntry.rowId)))?.focus();
    return true;
}

function addInlineExistingEnvironmentToSite(siteId) {
    const site = getSiteById(siteId);
    if (!site) {
        return false;
    }

    if (!hasExistingEnvironment(site)) {
        site.pendingExistingEnvironmentSelection = true;
        renderSiteList();
        siteList.querySelector(
            getSiteScopePickerTriggerSelector(getExistingEnvironmentSiteScopePickerKey(siteId, pendingExistingEnvironmentSelectionKey))
        )?.focus();
        return true;
    }

    const field = getNextAvailableExistingEnvironmentField(site);
    if (!field) {
        return false;
    }

    return addExistingEnvironmentFieldToSite(siteId, field);
}

function addExistingEnvironmentFieldToSite(siteId, field) {
    const site = getSiteById(siteId);
    if (!site || !field) {
        return false;
    }

    const availableFields = getAvailableExistingEnvironmentFields(site.existingEnvironment);
    if (!availableFields.includes(field)) {
        return false;
    }

    site.existingEnvironment[field] = Math.max(1, normalizeEnvironmentCount(site.existingEnvironment?.[field]));

    if (field === 'vbrServers') {
        applyDefaultVbrChildRows(site.existingEnvironment);
    }

    site.pendingExistingEnvironmentSelection = false;
    site.existingEnvironment = pruneExistingEnvironmentState(site.existingEnvironment);
    site.existingEnvironmentCustomLabels = pruneExistingEnvironmentCustomLabels(
        site.existingEnvironmentCustomLabels,
        site.existingEnvironment
    );

    renderSiteList();

    const focusSelector = `[data-site-existing-environment="${field}"][data-site-id="${siteId}"]`;
    siteList.querySelector(focusSelector)?.focus();
    return true;
}

function updateSiteExistingEnvironmentValue(siteId, currentField, nextField) {
    const site = getSiteById(siteId);
    const isPendingSelection = currentField === pendingExistingEnvironmentSelectionKey;
    if (!site || (!currentField && !isPendingSelection)) {
        return false;
    }

    if (!nextField) {
        if (isPendingSelection) {
            return true;
        }

        renderSiteCard(siteId, `[data-site-id="${siteId}"] [data-site-existing-environment-picker="${currentField}"]`);
        return false;
    }

    if (!Object.hasOwn(existingEnvironmentFieldLabels, nextField)) {
        return false;
    }

    if (currentField === nextField) {
        return true;
    }

    const selectionState = createExistingEnvironmentSelectionState(site.existingEnvironment, isPendingSelection ? '' : currentField);
    const availableFields = new Set(getAvailableExistingEnvironmentFields(selectionState));
    if (!availableFields.has(nextField)) {
        renderSiteCard(
            siteId,
            getSiteScopePickerTriggerSelector(
                getExistingEnvironmentSiteScopePickerKey(siteId, isPendingSelection ? pendingExistingEnvironmentSelectionKey : currentField)
            )
        );
        return false;
    }

    const currentValue = isPendingSelection
        ? 1
        : Math.max(1, normalizeEnvironmentCount(site.existingEnvironment?.[currentField]));
    const normalizedCustomLabels = normalizeExistingEnvironmentCustomLabels(site.existingEnvironmentCustomLabels);
    const currentCustomLabel = isPendingSelection ? '' : (normalizedCustomLabels[currentField] || '');

    if (!isPendingSelection) {
        delete site.existingEnvironment[currentField];
        clearExistingEnvironmentDependentFields(site.existingEnvironment, currentField);
    }

    site.existingEnvironment[nextField] = currentValue;

    if (!isPendingSelection) {
        delete normalizedCustomLabels[currentField];
    }

    if (currentCustomLabel) {
        normalizedCustomLabels[nextField] = currentCustomLabel;
    }

    if (nextField === 'vbrServers') {
        applyDefaultVbrChildRows(site.existingEnvironment);
    }

    site.pendingExistingEnvironmentSelection = false;
    site.existingEnvironment = pruneExistingEnvironmentState(site.existingEnvironment);
    site.existingEnvironmentCustomLabels = pruneExistingEnvironmentCustomLabels(
        normalizedCustomLabels,
        site.existingEnvironment
    );

    renderSiteCard(siteId, `[data-site-id="${siteId}"] [data-site-existing-environment="${nextField}"]`);
    return true;
}
window.updateSiteExistingEnvironmentValue = updateSiteExistingEnvironmentValue;

function removeExistingEnvironmentFieldFromSite(siteId, field) {
    const site = getSiteById(siteId);
    if (!site || !field) {
        return false;
    }

    if (field === pendingExistingEnvironmentSelectionKey) {
        if (true) {
            return false;
        }

        site.pendingExistingEnvironmentSelection = false;
        renderSiteList();
        siteList.querySelector(`[data-site-action="add-inline-existing-environment"][data-site-id="${siteId}"]`)?.focus();
        return true;
    }

    if (!Object.hasOwn(site.existingEnvironment, field)) {
        return false;
    }

    delete site.existingEnvironment[field];
    clearExistingEnvironmentDependentFields(site.existingEnvironment, field);
    site.pendingExistingEnvironmentSelection = false;
    site.existingEnvironment = pruneExistingEnvironmentState(site.existingEnvironment);
    site.existingEnvironmentCustomLabels = pruneExistingEnvironmentCustomLabels(
        site.existingEnvironmentCustomLabels,
        site.existingEnvironment
    );
    // Remove deleted field (and any cascade-cleared dependents) from display order
    if (Array.isArray(site.existingEnvironmentDisplayOrder)) {
        const activeKeys = new Set(Object.keys(site.existingEnvironment).filter(
            (k) => normalizeEnvironmentCount(site.existingEnvironment[k]) > 0
                || normalizeExistingEnvironmentToggle(site.existingEnvironment[k]) === 'yes'
        ));
        site.existingEnvironmentDisplayOrder = site.existingEnvironmentDisplayOrder.filter((k) => activeKeys.has(k));
    }

    renderSiteList();
    syncVsaMigrationSectionVisibility();
    siteList.querySelector(`[data-site-action="add-inline-existing-environment"][data-site-id="${siteId}"]`)?.focus();
    return true;
}

/** Decrement a locked-qty field (e.g. vbrServers) by 1; fully removes when it reaches 0 */
function decrementExistingEnvironmentFieldOnSite(siteId, field) {
    const site = getSiteById(siteId);
    if (!site || !field) return false;

    const current = normalizeEnvironmentCount(site.existingEnvironment?.[field]);
    if (current <= 1) {
        // Last chip — delegate to full remove (handles dependent field cleanup)
        if (field === 'vbrServers'      && site.existingEnvironmentVbrVersions)  { site.existingEnvironmentVbrVersions  = {}; }
        if (field === 'vbrServers'      && site.existingEnvironmentVbrPlatforms) { site.existingEnvironmentVbrPlatforms = {}; }
        if (field === 'vbrServers'      && site.existingEnvironmentVbrHaRoles)   { site.existingEnvironmentVbrHaRoles   = {}; }
        if (field === 'vbrServers'      && site.existingEnvironmentVbrHaPairIds) { site.existingEnvironmentVbrHaPairIds = {}; }
        if (field === 'vroServers'      && site.existingEnvironmentVroVersions)  { site.existingEnvironmentVroVersions  = {}; }
        if (field === 'veeamOneServers' && site.existingEnvironmentVoneVersions) { site.existingEnvironmentVoneVersions = {}; }
        return removeExistingEnvironmentFieldFromSite(siteId, field);
    }

    site.existingEnvironment[field] = current - 1;
    // Drop the last version/platform/haRole slot (chips are always removed from the end)
    if (field === 'vbrServers'      && site.existingEnvironmentVbrVersions)  { delete site.existingEnvironmentVbrVersions[current - 1];  }
    if (field === 'vbrServers'      && site.existingEnvironmentVbrPlatforms) { delete site.existingEnvironmentVbrPlatforms[current - 1]; }
    if (field === 'vbrServers'      && site.existingEnvironmentVbrHaRoles)   { delete site.existingEnvironmentVbrHaRoles[current - 1];   }
    if (field === 'vbrServers'      && site.existingEnvironmentVbrHaPairIds) { delete site.existingEnvironmentVbrHaPairIds[current - 1]; }
    if (field === 'vroServers'      && site.existingEnvironmentVroVersions)  { delete site.existingEnvironmentVroVersions[current - 1];  }
    if (field === 'veeamOneServers' && site.existingEnvironmentVoneVersions) { delete site.existingEnvironmentVoneVersions[current - 1]; }
    site.existingEnvironment = pruneExistingEnvironmentState(site.existingEnvironment);
    renderSiteList();
    if (field === 'vbrServers') syncVsaMigrationSectionVisibility();
    return true;
}

/**
 * Move exactly one slot of a locked-qty comp field (e.g. vbrServers) from one site to another.
 * For VBR / VRO / VONE, transfers the specific version slot; for other locked fields, moves a generic slot.
 * Does NOT call renderSiteList — caller is responsible for that.
 */
function moveOneLockedCompSlot(fromSite, toSite, field, version, haPairId = null, slotIndex = null) {
    const fromCount = normalizeEnvironmentCount(fromSite.existingEnvironment?.[field]);
    if (fromCount <= 0) return;
    if (!fromSite.existingEnvironment) return;
    if (!toSite.existingEnvironment) toSite.existingEnvironment = normalizeExistingEnvironment({});

    // VB365 repository servers: each chip carries its exact slot index — use it directly.
    if (field === 'vb365RepositoryServers') {
        const slotToMove = (slotIndex !== null && !isNaN(slotIndex) && slotIndex >= 0) ? slotIndex : fromCount - 1;
        const toCount = normalizeEnvironmentCount(toSite.existingEnvironment[field]);
        // Migrate repo type
        if (!toSite.existingEnvironmentVb365RepoTypes) toSite.existingEnvironmentVb365RepoTypes = {};
        const fromTypes = fromSite.existingEnvironmentVb365RepoTypes || {};
        toSite.existingEnvironmentVb365RepoTypes[toCount] = fromTypes[slotToMove] || 'block';
        const newFromTypes = {};
        let newSlot = 0;
        for (let s = 0; s < fromCount; s++) {
            if (s === slotToMove) continue;
            newFromTypes[newSlot++] = fromTypes[s] || 'block';
        }
        fromSite.existingEnvironmentVb365RepoTypes = newFromTypes;
        // Migrate consumed TB
        if (!toSite.existingEnvironmentVb365RepoConsumedTbs) toSite.existingEnvironmentVb365RepoConsumedTbs = {};
        const fromTbs = fromSite.existingEnvironmentVb365RepoConsumedTbs || {};
        toSite.existingEnvironmentVb365RepoConsumedTbs[toCount] = fromTbs[slotToMove] ?? 0;
        const newFromTbs = {};
        let newTbSlot = 0;
        for (let s = 0; s < fromCount; s++) {
            if (s === slotToMove) continue;
            newFromTbs[newTbSlot++] = fromTbs[s] ?? 0;
        }
        fromSite.existingEnvironmentVb365RepoConsumedTbs = newFromTbs;
        // Update counts
        if (fromCount <= 1) {
            delete fromSite.existingEnvironment[field];
            clearExistingEnvironmentDependentFields(fromSite.existingEnvironment, field);
        } else {
            fromSite.existingEnvironment[field] = fromCount - 1;
        }
        toSite.existingEnvironment[field] = toCount + 1;
        return;
    }

    // Map field key → site property name that holds the per-slot versions object
    const versionPropMap = {
        vbrServers:      'existingEnvironmentVbrVersions',
        vroServers:      'existingEnvironmentVroVersions',
        veeamOneServers: 'existingEnvironmentVoneVersions',
    };
    // Map field key → site property name that holds the per-slot platforms object (VBR only)
    const platformPropMap = {
        vbrServers: 'existingEnvironmentVbrPlatforms',
    };
    // Map field key → site property name that holds the per-slot HA roles object (VBR only)
    const haRolePropMap = {
        vbrServers: 'existingEnvironmentVbrHaRoles',
    };
    // Map field key → site property name that holds the per-slot HA pair IDs object (VBR only)
    const pairIdPropMap = {
        vbrServers: 'existingEnvironmentVbrHaPairIds',
    };
    const versionProp  = versionPropMap[field];
    const platformProp = platformPropMap[field];
    const haRoleProp   = haRolePropMap[field];
    const pairIdProp   = pairIdPropMap[field];

    if (versionProp) {
        const fromVersions = fromSite[versionProp] || {};
        const targetVersion = version || null;

        // Find the highest-indexed slot matching this version (+ pairId when provided) in the source
        let slotToRemove = -1;
        const fromPairIds = pairIdProp ? (fromSite[pairIdProp] || {}) : {};
        if (haPairId) {
            // Prefer exact version+pairId match
            for (let slot = fromCount - 1; slot >= 0; slot--) {
                if ((fromVersions[slot] || null) === targetVersion && (fromPairIds[slot] || null) === haPairId) { slotToRemove = slot; break; }
            }
        }
        if (slotToRemove === -1) {
            // Fallback: version-only match
            for (let slot = fromCount - 1; slot >= 0; slot--) {
                if ((fromVersions[slot] || null) === targetVersion) { slotToRemove = slot; break; }
            }
        }
        if (slotToRemove === -1) slotToRemove = fromCount - 1; // final fallback: remove last slot

        // Compact fromSite versions around the removed slot
        const newFromVersions = {};
        let newSlot = 0;
        for (let slot = 0; slot < fromCount; slot++) {
            if (slot === slotToRemove) continue;
            newFromVersions[newSlot++] = fromVersions[slot] || null;
        }
        fromSite[versionProp] = newFromVersions;

        // Append a new slot with this version to toSite
        if (!toSite[versionProp]) toSite[versionProp] = {};
        const toCount = normalizeEnvironmentCount(toSite.existingEnvironment[field]);
        toSite[versionProp][toCount] = targetVersion;

        // Mirror the same slot transfer for platform (VBR only)
        if (platformProp) {
            const fromPlatforms = fromSite[platformProp] || {};
            const movedPlatform = fromPlatforms[slotToRemove] || null;
            const newFromPlatforms = {};
            let newPlatSlot = 0;
            for (let slot = 0; slot < fromCount; slot++) {
                if (slot === slotToRemove) continue;
                newFromPlatforms[newPlatSlot++] = fromPlatforms[slot] || null;
            }
            fromSite[platformProp] = newFromPlatforms;
            if (!toSite[platformProp]) toSite[platformProp] = {};
            toSite[platformProp][toCount] = movedPlatform;
        }

        // Mirror the same slot transfer for HA role (VBR only)
        if (haRoleProp) {
            const fromHaRoles = fromSite[haRoleProp] || {};
            const movedHaRole = fromHaRoles[slotToRemove] || null;
            const newFromHaRoles = {};
            let newHaSlot = 0;
            for (let slot = 0; slot < fromCount; slot++) {
                if (slot === slotToRemove) continue;
                newFromHaRoles[newHaSlot++] = fromHaRoles[slot] || null;
            }
            fromSite[haRoleProp] = newFromHaRoles;
            if (!toSite[haRoleProp]) toSite[haRoleProp] = {};
            toSite[haRoleProp][toCount] = movedHaRole;
        }

        // Mirror the same slot transfer for HA pair ID (VBR only)
        if (pairIdProp) {
            const fromPairIdsAll = fromSite[pairIdProp] || {};
            const movedPairId = fromPairIdsAll[slotToRemove] || null;
            const newFromPairIds = {};
            let newPairIdSlot = 0;
            for (let slot = 0; slot < fromCount; slot++) {
                if (slot === slotToRemove) continue;
                newFromPairIds[newPairIdSlot++] = fromPairIdsAll[slot] || null;
            }
            fromSite[pairIdProp] = newFromPairIds;
            if (!toSite[pairIdProp]) toSite[pairIdProp] = {};
            toSite[pairIdProp][toCount] = movedPairId;
        }
    }

    // Update counts
    if (fromCount <= 1) {
        delete fromSite.existingEnvironment[field];
        clearExistingEnvironmentDependentFields(fromSite.existingEnvironment, field);
    } else {
        fromSite.existingEnvironment[field] = fromCount - 1;
    }
    const toCount = normalizeEnvironmentCount(toSite.existingEnvironment[field]);
    toSite.existingEnvironment[field] = toCount + 1;
}
window.moveOneLockedCompSlot = moveOneLockedCompSlot;

/**
 * Increment a locked-qty comp field (VBR, VRO, VONE) by 1, tagging the new slot with the given version.
 * Does NOT call renderSiteList — caller is responsible for that.
 */
function incrementLockedCompSlotOnSite(siteId, field, version, platform = null, haRole = null, pairId = null) {
    const site = getSiteById(siteId);
    if (!site) return;
    if (!site.existingEnvironment) site.existingEnvironment = {};

    const current = normalizeEnvironmentCount(site.existingEnvironment[field]);
    site.existingEnvironment[field] = current + 1;

    const versionPropMap = {
        vbrServers:      'existingEnvironmentVbrVersions',
        vroServers:      'existingEnvironmentVroVersions',
        veeamOneServers: 'existingEnvironmentVoneVersions',
    };
    const versionProp = versionPropMap[field];
    if (versionProp) {
        if (!site[versionProp] || typeof site[versionProp] !== 'object') site[versionProp] = {};
        site[versionProp][current] = version || null;
    }
    // Store platform slot for VBR
    if (field === 'vbrServers') {
        if (!site.existingEnvironmentVbrPlatforms || typeof site.existingEnvironmentVbrPlatforms !== 'object') {
            site.existingEnvironmentVbrPlatforms = {};
        }
        site.existingEnvironmentVbrPlatforms[current] = platform;
        // Store HA role slot for VBR (null = no role / non-HA)
        if (!site.existingEnvironmentVbrHaRoles || typeof site.existingEnvironmentVbrHaRoles !== 'object') {
            site.existingEnvironmentVbrHaRoles = {};
        }
        site.existingEnvironmentVbrHaRoles[current] = haRole;
        // Store HA pair ID slot for VBR (null = no pair / non-HA)
        if (!site.existingEnvironmentVbrHaPairIds || typeof site.existingEnvironmentVbrHaPairIds !== 'object') {
            site.existingEnvironmentVbrHaPairIds = {};
        }
        site.existingEnvironmentVbrHaPairIds[current] = pairId;
    }

    if (current === 0) {
        if (!Array.isArray(site.existingEnvironmentDisplayOrder)) site.existingEnvironmentDisplayOrder = [];
        if (!site.existingEnvironmentDisplayOrder.includes(field)) site.existingEnvironmentDisplayOrder.push(field);
    }

    site.existingEnvironment = pruneExistingEnvironmentState(site.existingEnvironment, 'upgrade');
}

/**
 * Decrement a locked-qty comp chip by 1.
 * - VBR: slot-index-aware (each instance is its own chip; slotIndex is always provided).
 * - VB365 repos: slot-index-aware (slotIndex carries the exact slot).
 * - VRO/VONE: version-aware (grouped chips; slotIndex is null).
 * Removes one slot and compacts the remaining per-slot dicts so indices stay contiguous.
 */
function decrementLockedCompChipOnSite(siteId, field, version, platform = null, haRole = null, pairId = null, slotIndex = null) {
    const site = getSiteById(siteId);
    if (!site || !field) return;

    const total = normalizeEnvironmentCount(site.existingEnvironment?.[field]);
    if (total <= 0) return;

    // VB365 repository servers: each chip carries its exact slot index — compact by that index.
    if (field === 'vb365RepositoryServers') {
        const slotToRemove = (slotIndex !== null && !isNaN(slotIndex) && slotIndex >= 0) ? slotIndex : total - 1;
        // Compact per-slot repo types
        if (site.existingEnvironmentVb365RepoTypes && typeof site.existingEnvironmentVb365RepoTypes === 'object') {
            const src = site.existingEnvironmentVb365RepoTypes;
            const compacted = {};
            let newSlot = 0;
            for (let s = 0; s < total; s++) {
                if (s === slotToRemove) continue;
                compacted[newSlot++] = src[s] || 'block';
            }
            site.existingEnvironmentVb365RepoTypes = compacted;
        }
        // Compact per-slot consumed TB
        if (site.existingEnvironmentVb365RepoConsumedTbs && typeof site.existingEnvironmentVb365RepoConsumedTbs === 'object') {
            const src = site.existingEnvironmentVb365RepoConsumedTbs;
            const compacted = {};
            let newSlot = 0;
            for (let s = 0; s < total; s++) {
                if (s === slotToRemove) continue;
                compacted[newSlot++] = src[s] ?? 0;
            }
            site.existingEnvironmentVb365RepoConsumedTbs = compacted;
        }
        if (total <= 1) {
            removeExistingEnvironmentFieldFromSite(siteId, field);
        } else {
            site.existingEnvironment[field] = total - 1;
            site.existingEnvironment = pruneExistingEnvironmentState(site.existingEnvironment);
            renderSiteList();
            syncDesignOptionFields();
        }
        return;
    }

    // VBR: if a specific slot index is provided, compact by that index directly (individual chip removal).
    if (field === 'vbrServers' && slotIndex !== null && !isNaN(slotIndex) && slotIndex >= 0) {
        const idx = slotIndex;
        const compact = (src) => {
            const c = {};
            let n = 0;
            for (let s = 0; s < total; s++) {
                if (s === idx) continue;
                c[n++] = (src?.[s] ?? null);
            }
            return c;
        };
        if (site.existingEnvironmentVbrVersions)  site.existingEnvironmentVbrVersions  = compact(site.existingEnvironmentVbrVersions);
        if (site.existingEnvironmentVbrPlatforms) site.existingEnvironmentVbrPlatforms = compact(site.existingEnvironmentVbrPlatforms);
        if (site.existingEnvironmentVbrHaRoles)   site.existingEnvironmentVbrHaRoles   = compact(site.existingEnvironmentVbrHaRoles);
        if (site.existingEnvironmentVbrHaPairIds) site.existingEnvironmentVbrHaPairIds = compact(site.existingEnvironmentVbrHaPairIds);
        if (total <= 1) {
            removeExistingEnvironmentFieldFromSite(siteId, field);
        } else {
            site.existingEnvironment[field] = total - 1;
            site.existingEnvironment = pruneExistingEnvironmentState(site.existingEnvironment);
            renderSiteList();
            syncDesignOptionFields();
        }
        return;
    }

    // Map field key → site property name that holds the per-slot versions object
    const versionPropMap = {
        vbrServers:      'existingEnvironmentVbrVersions',
        vroServers:      'existingEnvironmentVroVersions',
        veeamOneServers: 'existingEnvironmentVoneVersions',
    };
    // Map field key → site property name that holds the per-slot platforms object (VBR only)
    const platformPropMap = {
        vbrServers: 'existingEnvironmentVbrPlatforms',
    };
    // Map field key → site property name that holds the per-slot HA roles object (VBR only)
    const haRolePropMap = {
        vbrServers: 'existingEnvironmentVbrHaRoles',
    };
    // Map field key → site property name that holds the per-slot HA pair IDs object (VBR only)
    const pairIdPropMap = {
        vbrServers: 'existingEnvironmentVbrHaPairIds',
    };
    const versionProp  = versionPropMap[field];
    const platformProp = platformPropMap[field];
    const haRoleProp   = haRolePropMap[field];
    const pairIdProp   = pairIdPropMap[field];

    if (!versionProp) {
        // Non-versioned locked fields — use generic decrement
        decrementExistingEnvironmentFieldOnSite(siteId, field);
        return;
    }

    const fieldVersions  = site[versionProp]  || {};
    const fieldPlatforms = platformProp ? (site[platformProp] || {}) : null;
    const fieldHaRoles   = haRoleProp   ? (site[haRoleProp]   || {}) : null;
    const fieldPairIds   = pairIdProp   ? (site[pairIdProp]   || {}) : null;
    const targetVersion  = version  || null;
    const targetPlatform = platform || null;
    const targetHaRole   = haRole   || null;
    const targetPairId   = pairId   || null;

    // Find the highest-indexed slot matching version+platform+haRole+pairId (remove newest first)
    let slotToRemove = -1;
    // Try exact version+platform+haRole+pairId match first (most specific)
    if (fieldPlatforms && fieldHaRoles && fieldPairIds && targetPairId) {
        for (let slot = total - 1; slot >= 0; slot--) {
            if ((fieldVersions[slot] || null) === targetVersion &&
                (fieldPlatforms[slot] || null) === targetPlatform &&
                (fieldHaRoles[slot]   || null) === targetHaRole &&
                (fieldPairIds[slot]   || null) === targetPairId) {
                slotToRemove = slot; break;
            }
        }
    }
    // Fallback: exact version+platform+haRole match
    if (slotToRemove === -1 && fieldPlatforms && fieldHaRoles) {
        for (let slot = total - 1; slot >= 0; slot--) {
            if ((fieldVersions[slot] || null) === targetVersion &&
                (fieldPlatforms[slot] || null) === targetPlatform &&
                (fieldHaRoles[slot]   || null) === targetHaRole) {
                slotToRemove = slot; break;
            }
        }
    }
    if (slotToRemove === -1 && fieldPlatforms) {
        // Fallback: version+platform match
        for (let slot = total - 1; slot >= 0; slot--) {
            if ((fieldVersions[slot] || null) === targetVersion && (fieldPlatforms[slot] || null) === targetPlatform) {
                slotToRemove = slot; break;
            }
        }
    }
    if (slotToRemove === -1) {
        // Fallback: version-only match
        for (let slot = total - 1; slot >= 0; slot--) {
            if ((fieldVersions[slot] || null) === targetVersion) { slotToRemove = slot; break; }
        }
    }
    if (slotToRemove === -1) slotToRemove = total - 1; // final fallback: remove last slot

    // Compact remaining slots around the removed one
    const newVersions = {};
    let newSlot = 0;
    for (let slot = 0; slot < total; slot++) {
        if (slot === slotToRemove) continue;
        newVersions[newSlot++] = fieldVersions[slot] || null;
    }
    site[versionProp] = newVersions;

    // Mirror compaction for platforms (VBR only)
    if (platformProp && site[platformProp]) {
        const fieldPlatforms = site[platformProp];
        const newPlatforms = {};
        let newPlatSlot = 0;
        for (let slot = 0; slot < total; slot++) {
            if (slot === slotToRemove) continue;
            newPlatforms[newPlatSlot++] = fieldPlatforms[slot] || null;
        }
        site[platformProp] = newPlatforms;
    }

    // Mirror compaction for HA roles (VBR only)
    if (haRoleProp && site[haRoleProp]) {
        const fieldHaRoles = site[haRoleProp];
        const newHaRoles = {};
        let newHaSlot = 0;
        for (let slot = 0; slot < total; slot++) {
            if (slot === slotToRemove) continue;
            newHaRoles[newHaSlot++] = fieldHaRoles[slot] || null;
        }
        site[haRoleProp] = newHaRoles;
    }

    // Mirror compaction for HA pair IDs (VBR only)
    if (pairIdProp && site[pairIdProp]) {
        const fieldPairIdsAll = site[pairIdProp];
        const newPairIds = {};
        let newPairIdSlot = 0;
        for (let slot = 0; slot < total; slot++) {
            if (slot === slotToRemove) continue;
            newPairIds[newPairIdSlot++] = fieldPairIdsAll[slot] || null;
        }
        site[pairIdProp] = newPairIds;
    }

    if (total <= 1) {
        removeExistingEnvironmentFieldFromSite(siteId, field);
    } else {
        site.existingEnvironment[field] = total - 1;
        site.existingEnvironment = pruneExistingEnvironmentState(site.existingEnvironment);
        renderSiteList();
        syncDesignOptionFields();
    }
}

/**
 * Remove the most-recently-added slot of a count-based existing-environment field.
 * Exposed to the Add-Component drawer (via window bridge) so a count chip can be
 * decremented in-place rather than forcing the user back to the canvas.
 *
 * Routing by storage model:
 *  - vbrServers           → if the newest slot belongs to an HA pair, remove BOTH halves
 *                           together (product decision 2026-06-22); otherwise generic decrement.
 *  - vb365RepositoryServers → slot-aware decrement (compacts per-slot repo type + consumed TB maps).
 *  - everything else (incl. repositoryServers, proxyServersWindows/Linux) → generic decrement.
 */
function removeLastComponentSlotFromSite(siteId, field) {
    const site = getSiteById(siteId);
    if (!site || !field) return;

    // VBR Backup Repositories are stored as workloads (isRepositoryComponent), not as an
    // existingEnvironment count, so they're handled before the count guard below. Remove the
    // most-recently-added repository-component workload; fall back to the legacy count field.
    if (field === 'repositoryServers') {
        const repoComps = Array.isArray(site.workloads)
            ? site.workloads.filter((w) => w.isRepositoryComponent)
            : [];
        const last = repoComps[repoComps.length - 1];
        if (last) {
            removeWorkloadFromSite(siteId, getWorkloadRowId(last));
            return;
        }
        if (normalizeEnvironmentCount(site.existingEnvironment?.repositoryServers) > 0) {
            decrementExistingEnvironmentFieldOnSite(siteId, field);
        }
        return;
    }

    const total = normalizeEnvironmentCount(site.existingEnvironment?.[field]);
    if (total <= 0) return;

    // VBR HA pairs: remove the whole pair when the newest slot is paired.
    if (field === 'vbrServers') {
        const pairIds = site.existingEnvironmentVbrHaPairIds || {};
        const lastSlot = total - 1;
        const lastPairId = pairIds[lastSlot] || null;
        if (lastPairId) {
            // Collect every slot sharing this pair id, descending so indices stay valid
            // across successive removals (compaction only shifts slots above the removed one).
            const pairSlots = [];
            for (let s = total - 1; s >= 0; s--) {
                if ((pairIds[s] || null) === lastPairId) pairSlots.push(s);
            }
            pairSlots.forEach((slot) => {
                decrementLockedCompChipOnSite(
                    siteId,
                    field,
                    site.existingEnvironmentVbrVersions?.[slot] || null,
                    site.existingEnvironmentVbrPlatforms?.[slot] || null,
                    site.existingEnvironmentVbrHaRoles?.[slot] || null,
                    lastPairId,
                    slot
                );
            });
            return;
        }
    }

    // VB365 repositories carry per-slot maps — use the slot-aware decrement (defaults to last slot).
    if (field === 'vb365RepositoryServers') {
        decrementLockedCompChipOnSite(siteId, field);
        return;
    }

    // Everything else — generic decrement (handles version/platform cleanup + dependent pruning).
    decrementExistingEnvironmentFieldOnSite(siteId, field);
}
window.removeLastComponentSlotFromSite = removeLastComponentSlotFromSite;

function removeSite(siteId) {
    if (sites.length === 1) {
        return;
    }

    const siteIndex = sites.findIndex((site) => site.id === siteId);
    if (siteIndex === -1) {
        return;
    }

    sites.splice(siteIndex, 1);
    renderSiteList();
}

/** Remove an existing-environment component chip from a site. */
function removeComponentFromSite(siteId, compKey) {
    const site = getSiteById(siteId);
    if (!site || !compKey) return;
    if (site.existingEnvironment) {
        delete site.existingEnvironment[compKey];
    }
    renderSiteList();
    syncDesignOptionFields();
}

/** Update the engagement detection banner based on current canvas state. */

function removeWorkloadFromSite(siteId, workloadIdentifier) {
    const site = getSiteById(siteId);
    if (!site) {
        return;
    }

    const normalizedIdentifier = normalizeWorkloadIdentifier(workloadIdentifier);
    const workload = getSiteWorkloadByIdentifier(site, normalizedIdentifier);
    if (!workload) {
        return;
    }

    const workloadRowId = getWorkloadRowId(workload);

    resetWorkloadPickerState(siteId, workloadRowId);
    site.workloads = site.workloads.filter((item) => getWorkloadRowId(item) !== workloadRowId);
    if (shouldRenderRepoMigrationTable()) {
        renderSiteList();
        updateSiteActionStates();
        siteList.querySelector(`[data-site-action="add-inline-repo-migration"][data-site-id="${siteId}"]`)?.focus();
        return;
    }

    // Unified canvas: shouldRenderWorkloadInputs() always true.
    renderSiteList();
    updateSiteActionStates();
    siteList.querySelector(`[data-site-action="add-inline-workload"][data-site-id="${siteId}"]`)?.focus();
}









function getEstimatorState() {
    const aggregatedWorkloads = buildAggregatedWorkloadData(sites);
    const buildInfo = getAppBuildInfo();

    return {
        schemaVersion: STATE_SCHEMA_VERSION,
        appVersion: buildInfo.version,
        appCommit: buildInfo.commit,
        exportedAt: new Date().toISOString(),
        projectName: document.getElementById('project-name').value.trim(),
        engagementType: deriveEngagementType(),
        sites: aggregatedWorkloads.siteSummaries.map((site) => {
            // Match the live site to include job/workload definitions in the export
            const liveSite = getSiteById(site.id);
            const siteJobs = Array.isArray(liveSite?.jobs) ? liveSite.jobs.map((j) => ({ ...j })) : [];
            const siteUnprotected = Array.isArray(liveSite?.unprotectedWorkloads) ? liveSite.unprotectedWorkloads.map((w) => ({ ...w })) : [];
            return {
            name: site.name,
            ...(siteJobs.length > 0 ? { jobs: siteJobs } : {}),
            ...(siteUnprotected.length > 0 ? { unprotectedWorkloads: siteUnprotected } : {}),
            ...(site.vdcVaultSourceStorageType ? { vdcVaultSourceStorageType: site.vdcVaultSourceStorageType } : {}),
            ...(site.vdcVaultRepositoryType ? { vdcVaultRepositoryType: site.vdcVaultRepositoryType } : {}),
            ...(site.vdcVaultTargetVault ? { vdcVaultTargetVault: site.vdcVaultTargetVault } : {}),
            existingEnvironment: pruneExistingEnvironmentState(liveSite?.existingEnvironment || {}),
            ...((() => {
                const prunedLabels = pruneExistingEnvironmentCustomLabels(liveSite?.existingEnvironmentCustomLabels || {}, liveSite?.existingEnvironment || {});
                return Object.keys(prunedLabels).length ? { existingEnvironmentCustomLabels: prunedLabels } : {};
            })()),
            ...(Array.isArray(liveSite?.existingEnvironmentDisplayOrder) && liveSite.existingEnvironmentDisplayOrder.length
                ? { existingEnvironmentDisplayOrder: [...liveSite.existingEnvironmentDisplayOrder] }
                : {}),
            ...(liveSite?.existingEnvironmentVbrVersions && Object.keys(liveSite.existingEnvironmentVbrVersions).length
                ? { existingEnvironmentVbrVersions: { ...liveSite.existingEnvironmentVbrVersions } }
                : {}),
            ...(liveSite?.existingEnvironmentVbrPlatforms && Object.keys(liveSite.existingEnvironmentVbrPlatforms).length
                ? { existingEnvironmentVbrPlatforms: { ...liveSite.existingEnvironmentVbrPlatforms } }
                : {}),
            ...(liveSite?.existingEnvironmentVbrHaRoles && Object.keys(liveSite.existingEnvironmentVbrHaRoles).length
                ? { existingEnvironmentVbrHaRoles: { ...liveSite.existingEnvironmentVbrHaRoles } }
                : {}),
            ...(liveSite?.existingEnvironmentVbrHaPairIds && Object.keys(liveSite.existingEnvironmentVbrHaPairIds).length
                ? { existingEnvironmentVbrHaPairIds: { ...liveSite.existingEnvironmentVbrHaPairIds } }
                : {}),
            ...(liveSite?.existingEnvironmentVroVersions && Object.keys(liveSite.existingEnvironmentVroVersions).length
                ? { existingEnvironmentVroVersions: { ...liveSite.existingEnvironmentVroVersions } }
                : {}),
            ...(liveSite?.existingEnvironmentVoneVersions && Object.keys(liveSite.existingEnvironmentVoneVersions).length
                ? { existingEnvironmentVoneVersions: { ...liveSite.existingEnvironmentVoneVersions } }
                : {}),
            ...(liveSite?.existingEnvironmentRepoPlatform && liveSite.existingEnvironmentRepoPlatform !== 'windows'
                ? { existingEnvironmentRepoPlatform: liveSite.existingEnvironmentRepoPlatform }
                : {}),
            ...(liveSite?.existingEnvironmentVb365ProxyPlatform && liveSite.existingEnvironmentVb365ProxyPlatform !== 'windows'
                ? { existingEnvironmentVb365ProxyPlatform: liveSite.existingEnvironmentVb365ProxyPlatform }
                : {}),
            ...(liveSite?.existingEnvironmentVb365RepoTypes && Object.keys(liveSite.existingEnvironmentVb365RepoTypes).length
                ? { existingEnvironmentVb365RepoTypes: { ...liveSite.existingEnvironmentVb365RepoTypes } }
                : {}),
            ...(liveSite?.existingEnvironmentVb365RepoConsumedTbs && Object.values(liveSite.existingEnvironmentVb365RepoConsumedTbs).some((v) => v > 0)
                ? { existingEnvironmentVb365RepoConsumedTbs: { ...liveSite.existingEnvironmentVb365RepoConsumedTbs } }
                : {}),
            ...(Array.isArray(liveSite?.veeamServers) && liveSite.veeamServers.length > 0
                ? { veeamServers: liveSite.veeamServers.map((s) => ({ ...s })) }
                : {}),
            ...(liveSite?.existingEnvironmentServerVersions && Object.keys(liveSite.existingEnvironmentServerVersions).length
                ? { existingEnvironmentServerVersions: { ...liveSite.existingEnvironmentServerVersions } }
                : {}),
            ...(Array.isArray(liveSite?.sourceWorkloads) && liveSite.sourceWorkloads.length > 0
                ? { sourceWorkloads: liveSite.sourceWorkloads.map((sw) => ({ ...sw, jobs: (sw.jobs || []).map((j) => ({ ...j })) })) }
                : {}),
            ...(Array.isArray(liveSite?.repositories) && liveSite.repositories.length > 0
                ? { repositories: liveSite.repositories.map((r) => ({ ...r })) }
                : {}),
            totalWorkloadCount: site.totalWorkloadCount,
            workloads: site.workloads.map((workload) => ({
                workload: workload.value,
                label: workload.label,
                ...(typeof workload.customLabel === 'string' && workload.customLabel
                    ? { customLabel: workload.customLabel }
                    : {}),
                type: workload.type,
                count: workload.count,
                ...(typeof workload.protectedTb === 'number' ? { protectedTb: workload.protectedTb } : {}),
                ...(Number.isInteger(workload.rowId) ? { rowId: workload.rowId } : {}),
                ...(workload.vdcVaultSourceStorageType
                    ? { vdcVaultSourceStorageType: workload.vdcVaultSourceStorageType }
                    : {}),
                ...(workload.vdcVaultRepositoryType
                    ? { vdcVaultRepositoryType: workload.vdcVaultRepositoryType }
                    : {}),
                ...(workload.vdcVaultTargetVault
                    ? { vdcVaultTargetVault: workload.vdcVaultTargetVault }
                    : {}),
                ...(workload.isRepositoryComponent
                    ? { isRepositoryComponent: true }
                    : {})
            })),
            sourceHypervisors: site.hypervisors,
            sourceCloudWorkloads: site.cloudWorkloads,
            sourceSaasWorkloads: site.saasWorkloads,
            sourceContainerWorkloads: site.containerWorkloads,
            sourcePlugins: site.plugins,
            sourceUnstructuredData: site.unstructuredData,
            sourceAgents: site.agents
        }; }),
        sourceHypervisors: aggregatedWorkloads.hypervisorCounts,
        sourceCloudWorkloads: aggregatedWorkloads.cloudWorkloadCounts,
        sourceSaasWorkloads: aggregatedWorkloads.saasWorkloadCounts,
        sourceContainerWorkloads: aggregatedWorkloads.containerWorkloadCounts,
        sourcePlugins: aggregatedWorkloads.pluginQuantities,
        sourceUnstructuredData: aggregatedWorkloads.unstructuredDataCounts,
        sourceAgents: aggregatedWorkloads.agentCounts,
        totalCloudWorkloadInstances: aggregatedWorkloads.totalCloudWorkloadInstances,
        totalSaasWorkloadInstances: aggregatedWorkloads.totalSaasWorkloadInstances,
        totalContainerWorkloadInstances: aggregatedWorkloads.totalContainerWorkloadInstances,
        totalAgentInstances: aggregatedWorkloads.totalAgentInstances,
        totalWorkloadCount: aggregatedWorkloads.totalWorkloadCount,
        siteCount: sites.length,
        architectureState: buildArchitectureStateSnapshot(),
        upgradeHealthCheckReviewRequired: upgradeHealthCheckReviewRequiredValue(),
        implementationMode: getImplementationMode(),
        veeamOneRequired: toggleValue(veeamOneRequiredToggle),
        veeamOneOptions: getSelectedVeeamOneOptions(),
        backupVerificationRequired: backupVerificationRequiredInput.value,
        sureBackupRequired: backupVerificationRequiredInput.value !== 'no'
            ? sureBackupRequiredInput.value
            : 'no',
        backupCopyRequired: toggleValue(backupCopyRequiredToggle),
        replicationRequired: toggleValue(replicationRequiredToggle),
        sureReplicaRequired: replicationRequiredToggle.checked
            ? sureReplicaRequiredInput.value
            : 'no',
        cdpReplicationRequired: toggleValue(replicationRequiredToggle) === 'yes'
            ? toggleValue(cdpReplicationRequiredToggle)
            : 'no',
        tapeIntegrationRequired: toggleValue(tapeIntegrationRequiredToggle),
        tapeConnectivityType: tapeConnectivityTypeSelect.value,
        siemForwardingRequired: toggleValue(siemForwardingRequiredToggle),
        implDeliveryStyle: document.querySelector('input[name="impl-delivery-style"]:checked')?.value ?? 'white-glove',
        advisorySupportRequired: toggleValue(document.getElementById('advisory-support-required')),
        enablementRequired: toggleValue(enablementRequiredToggle),
        uatRequired: toggleValue(uatRequiredToggle),
        asBuiltRequired: toggleValue(document.getElementById('as-built-required')),
        drRunbookRequired: toggleValue(document.getElementById('dr-runbook-required')),
        sopRequired: toggleValue(document.getElementById('sop-required')),
        assumptionBandwidthAdequate: toggleValue(document.getElementById('assumption-bandwidth-adequate')),
        assumptionCustomerResourceAvailable: toggleValue(document.getElementById('assumption-customer-resource-available')),
        assumptionRemoteDeliveryAccepted: toggleValue(document.getElementById('assumption-remote-delivery-accepted')),
        assumptionAdminAccessProvided: toggleValue(document.getElementById('assumption-admin-access-provided')),
        assumptionLicenceInPlace: toggleValue(document.getElementById('assumption-licence-in-place')),
        assumptionChangeControl: toggleValue(document.getElementById('assumption-change-control')),
        customRisksNotes: document.getElementById('custom-risks-notes')?.value ?? '',
        vb365RepoMigrationScopes: vb365RepoMigrationScopes.map((s) => ({ ...s })),
        vbrRepoMigrationScopes:   vbrRepoMigrationScopes.map((s) => ({ ...s })),
        hvmEnabled: AppState.hvmEnabled,
        hypervisorMigrationScopes: hypervisorMigrationScopes.map((s) => ({ ...s })),
        step2CanvasState: {
            vbrLanes:    s2VbrLanes.map((l) => ({ ...l })),
            cloudLanes:  step2CloudLanes.map((l) => ({ ...l })),
            vb365Lanes:  step2Vb365Lanes.map((l) => ({ ...l })),
            assignments: { ...workloadAssignments },
            nextLaneId:  s2NextLaneId,
        },
        step2MatrixState: JSON.parse(JSON.stringify(step2MatrixState)),
        upgradeScopePerVbr: JSON.parse(JSON.stringify(upgradeScope.perVbr)),
        subItemHourAdjustments: Object.fromEntries(window.subItemHourAdjustments),
        categoryHourAdjustments: Object.fromEntries(window.categoryHourAdjustments),
    };
}

function setToggleState(id, value) {
    const toggle = document.getElementById(id);
    if (!toggle) return;
    toggle.checked = value === 'yes';
    updateToggleLabel(toggle);
}

function applyEstimatorState(rawState) {
    const state = sanitizeImportedState(rawState);

    // Restore hour adjustments — clear first then repopulate from saved state.
    // Falls back to empty maps if the export pre-dates adjustment persistence.
    window.subItemHourAdjustments.clear();
    window.categoryHourAdjustments.clear();
    if (rawState.subItemHourAdjustments && typeof rawState.subItemHourAdjustments === 'object') {
        for (const [k, v] of Object.entries(rawState.subItemHourAdjustments)) {
            if (typeof k === 'string' && typeof v === 'number') {
                window.subItemHourAdjustments.set(k, v);
            }
        }
    }
    if (rawState.categoryHourAdjustments && typeof rawState.categoryHourAdjustments === 'object') {
        for (const [k, v] of Object.entries(rawState.categoryHourAdjustments)) {
            if (typeof k === 'string' && typeof v === 'number') {
                window.categoryHourAdjustments.set(k, v);
            }
        }
    }

    document.getElementById('project-name').value = state.projectName;
    setBackupVerificationValue(state.backupVerificationRequired);
    setSureBackupValue(state.sureBackupRequired);
    setSureReplicaValue(state.sureReplicaRequired);
    document.getElementById('tape-connectivity-type').value = state.tapeConnectivityType;

    syncEngagementTypeBodyAttribute();
    setImplementationMode(state.implementationMode);
    setToggleState('upgrade-health-check-review-required', state.upgradeHealthCheckReviewRequired);
    setVeeamOneRequiredValue(state.veeamOneRequired, { explicitChoice: true });
    setToggleState('backup-copy-required', state.backupCopyRequired);
    setToggleState('replication-required', state.replicationRequired);
    setToggleState('cdp-replication-required', state.cdpReplicationRequired);
    setToggleState('tape-integration-required', state.tapeIntegrationRequired);
    setToggleState('siem-forwarding-required', state.siemForwardingRequired);
    const _implStyle = state.implDeliveryStyle ?? 'white-glove';
    document.querySelectorAll('input[name="impl-delivery-style"]').forEach((r) => {
        r.checked = r.value === _implStyle;
    });
    setToggleState('advisory-support-required', state.advisorySupportRequired);
    syncAdvisorySupportRowVisibility();
    setToggleState('enablement-required', state.enablementRequired);
    setToggleState('uat-required', state.uatRequired);
    setToggleState('as-built-required', state.asBuiltRequired);
    setToggleState('dr-runbook-required', state.drRunbookRequired);
    setToggleState('sop-required', state.sopRequired ?? 'no');
    setToggleState('assumption-bandwidth-adequate', state.assumptionBandwidthAdequate);
    setToggleState('assumption-customer-resource-available', state.assumptionCustomerResourceAvailable);
    setToggleState('assumption-remote-delivery-accepted', state.assumptionRemoteDeliveryAccepted);
    setToggleState('assumption-admin-access-provided', state.assumptionAdminAccessProvided);
    setToggleState('assumption-licence-in-place', state.assumptionLicenceInPlace);
    setToggleState('assumption-change-control', state.assumptionChangeControl ?? 'yes');
    const _customRisksEl = document.getElementById('custom-risks-notes');
    if (_customRisksEl) _customRisksEl.value = state.customRisksNotes ?? '';
    updateAssumptionsRiskNotice();

    Object.keys(veeamOneOptionLabels).forEach((option) => {
        setToggleState(`veeam-one-${option}`, state.veeamOneOptions.includes(option) ? 'yes' : 'no');
    });

    // Capture restored scopes before resetSites (which clears all scope arrays)
    const _restoredVb365Scopes = Array.isArray(state.vb365RepoMigrationScopes) ? state.vb365RepoMigrationScopes : [];
    const _restoredVbrScopes   = Array.isArray(state.vbrRepoMigrationScopes)   ? state.vbrRepoMigrationScopes   : [];
    const _restoredHvmScopes   = Array.isArray(state.hypervisorMigrationScopes) ? state.hypervisorMigrationScopes : [];
    resetSites(state.sites);
    if (_restoredVb365Scopes.length > 0) {
        vb365RepoMigrationScopes.push(..._restoredVb365Scopes);
        const maxId = _restoredVb365Scopes.reduce((m, s) => Math.max(m, s.id || 0), 0);
        if (maxId >= AppState.nextVb365RepoMigrationId) AppState.nextVb365RepoMigrationId = maxId + 1;
    }
    if (_restoredVbrScopes.length > 0) {
        vbrRepoMigrationScopes.push(..._restoredVbrScopes);
        const maxId = _restoredVbrScopes.reduce((m, s) => Math.max(m, s.id || 0), 0);
        if (maxId >= AppState.nextVbrRepoMigrationId) AppState.nextVbrRepoMigrationId = maxId + 1;
    }
    if (_restoredHvmScopes.length > 0) {
        hypervisorMigrationScopes.push(..._restoredHvmScopes.map((s) => ({ ...s })));
        const maxId = _restoredHvmScopes.reduce((m, s) => Math.max(m, s.id || 0), 0);
        if (maxId >= AppState.nextHypervisorMigrationId) AppState.nextHypervisorMigrationId = maxId + 1;
    }
    // resetSites always sets hvmEnabled = true; restore the saved value
    AppState.hvmEnabled = state.hvmEnabled;
    resetUpgradeScope();
    // Restore per-VBR HC/upgrade toggle state (not in architectureState).
    if (rawState.upgradeScopePerVbr && typeof rawState.upgradeScopePerVbr === 'object') {
        Object.entries(rawState.upgradeScopePerVbr).forEach(([id, v]) => {
            if (v && typeof v === 'object') upgradeScope.perVbr[id] = { ...v };
        });
    }
    applyArchitectureState(state.architectureState, state.sites.length);
    resetStep2CollapseState();
    renderSiteList();

    // Restore Step 2 lane assignments. applyStep2CanvasState resets then repopulates
    // the module-level let variables. autoAddLinkedVbrLanes (called on Step 2 entry)
    // guards against duplicates via sourceInstanceId, so restoring here is safe.
    if (state.step2CanvasState && typeof state.step2CanvasState === 'object') {
        applyStep2CanvasState(state.step2CanvasState);
    }

    // Restore Step 2 scope matrix state before syncDesignOptionFields triggers
    // renderScopeMatrix — initRowState only fires for missing keys, so pre-populating
    // here prevents the defaults (replication=true, verification=false) from overwriting
    // the saved selections.
    if (state.step2MatrixState && typeof state.step2MatrixState === 'object') {
        ['managed', 'unmanaged', 'components', 'migrationTargets', 'serverManaged'].forEach((group) => {
            if (state.step2MatrixState[group] && typeof state.step2MatrixState[group] === 'object') {
                Object.assign(step2MatrixState[group], JSON.parse(JSON.stringify(state.step2MatrixState[group])));
            }
        });
    }

    syncDesignOptionFields();
    updateTotalInstances();

    // Always return to Step 1 after import so the user can review the
    // loaded state before advancing — avoids stale estimate figures.
    if (hasSelectedWorkloads()) {
        if (hasCompleteSiteWorkloads()) {
            setCurrentStep(1);
            return;
        }

        setCurrentStep(1);
        renderOutputMessage(getSiteWorkloadValidationMessage() || getIncompleteSiteScopeValidationMessage());
        return;
    }

    setCurrentStep(1);
    renderOutputMessage(getEmptyScopeValidationMessage());
}




// §STEP3-WIRING
/**
 * Per-category hour overrides set by the user in Step 3.
 * Map<categoryId, number> — persists across renderEstimate calls.
 */
const categoryHourAdjustments = new Map();
window.categoryHourAdjustments = categoryHourAdjustments;
const phaseHourAdjustments    = new Map();
window.phaseHourAdjustments = phaseHourAdjustments;
const subItemHourAdjustments  = new Map();
window.subItemHourAdjustments = subItemHourAdjustments;
const expandedPhaseIds = new Set();
window.expandedPhaseIds = expandedPhaseIds;
window.pmExcluded          = true;   // excluded by default
window.contingencyExcluded = false;
categoryHourAdjustments.set('project-management', 0); // reflect default PM exclusion


// ─────────────────────────────────────────────────────────────────────────────
// Statement of Work generator
// Called from renderEstimate() after all effort variables are computed.
// Receives a data bundle (d) and returns the SOW HTML string.
// Shown when step3ViewMode === 'sow'; otherwise estimate cards are shown instead.
// ─────────────────────────────────────────────────────────────────────────────




function commitSiteName(siteId, input) {
    const siteIndex = getSiteIndexById(siteId);
    if (siteIndex === -1) {
        return;
    }

    const site = sites[siteIndex];

    if (!validateSiteNameControl(input, siteId)) {
        input.reportValidity();
        input.setCustomValidity('');
        site.renameDraft = site.name;
        input.value = getSiteRenameDraft(site, siteIndex);
        return;
    }

    site.name = getStoredSiteName(input.value, siteIndex);
    site.renameDraft = site.name;
    input.value = getSiteRenameDraft(site, siteIndex);
}

function updateSiteNameDraft(siteId, value) {
    const site = getSiteById(siteId);
    if (site) {
        site.renameDraft = value;
    }
}

function updateSiteWorkloadValue(siteId, workloadIdentifier, nextValue) {
    const site = getSiteById(siteId);
    const workload = getSiteWorkloadByIdentifier(site, workloadIdentifier);
    if (!site || !workload || !hasSelectedWorkloadValue(nextValue) || isInDevelopmentWorkloadValue(nextValue)) {
        return false;
    }

    const workloadRowId = getWorkloadRowId(workload);
    const currentValue = workload.value;
    const isPendingSelection = !hasSelectedWorkloadValue(currentValue);

    if (currentValue === nextValue) {
        return true;
    }

    if (hasSelectedWorkloadValue(nextValue) && site.workloads.some((item) => item !== workload && item.value === nextValue)) {
        renderSiteCard(siteId, getSiteWorkloadPickerTriggerSelector(siteId, workloadRowId));
        return false;
    }

    const nextEntry = isPendingSelection
        ? buildDefaultSelectedWorkloadEntry(nextValue, workload.customLabel || '', workloadRowId)
        : isUnstructuredDataWorkload(nextValue)
            ? buildWorkloadEntry(
                nextValue,
                0,
                isUnstructuredDataWorkload(currentValue)
                    ? workload.protectedTb || 0
                    : Math.max(0, (parseInt(workload.count, 10) || 0) / 2),
                workload.customLabel || '',
                workloadRowId
            )
            : buildWorkloadEntry(
                nextValue,
                isUnstructuredDataWorkload(currentValue)
                    ? calculateUnstructuredDataInstances(workload.protectedTb || 0)
                    : workload.count,
                null,
                workload.customLabel || '',
                workloadRowId
            );

    const workloadIndex = site.workloads.indexOf(workload);
    site.workloads.splice(workloadIndex, 1, nextEntry);
    resetWorkloadPickerState(siteId, workloadRowId);
    renderSiteCard(
        siteId,
        `[data-site-id="${siteId}"] [data-site-workload-input="${workloadRowId}"]`
    );
    return true;
}

function updateSiteWorkloadCount(siteId, workloadIdentifier, rawValue, shouldFormatInput = false) {
    const site = getSiteById(siteId);
    const workload = getSiteWorkloadByIdentifier(site, workloadIdentifier);
    if (!workload || !hasSelectedWorkloadValue(workload.value) || isInDevelopmentWorkloadValue(workload.value)) {
        return null;
    }

    workload.count = Math.max(0, parseInt(rawValue, 10) || 0);
    if (isUnstructuredDataWorkload(workload.value)) {
        // Instance count is derived from protected TB (2 instances per TB), so the
        // inverse formula recovers protectedTb when count is set directly (e.g. via import).
        // The primary editing path goes through updateSiteProtectedTb instead.
        workload.protectedTb = workload.count / 2;
        updateUnstructuredProtectedTbPreview(siteId, getWorkloadRowId(workload), workload.protectedTb);
    }
    updateTotalInstances();
    syncSiteWorkloadStepperState(siteId, workloadIdentifier);

    return shouldFormatInput ? String(workload.count) : null;
}

function updateSiteWorkloadCustomLabel(siteId, workloadIdentifier, rawValue, shouldFormatInput = false) {
    const site = getSiteById(siteId);
    const workload = getSiteWorkloadByIdentifier(site, workloadIdentifier);
    if (!workload || !hasSelectedWorkloadValue(workload.value) || isInDevelopmentWorkloadValue(workload.value)) {
        return null;
    }

    const nextValue = shouldFormatInput ? normalizeWorkloadCustomLabel(rawValue) : String(rawValue);
    if (normalizeWorkloadCustomLabel(nextValue)) {
        workload.customLabel = nextValue;
    } else {
        delete workload.customLabel;
    }

    return shouldFormatInput ? normalizeWorkloadCustomLabel(nextValue) : null;
}

function updateSiteProtectedTb(siteId, workloadIdentifier, rawValue, shouldFormatInput = false) {
    const site = getSiteById(siteId);
    const workload = getSiteWorkloadByIdentifier(site, workloadIdentifier);
    if (!workload || !hasSelectedWorkloadValue(workload.value) || isInDevelopmentWorkloadValue(workload.value)) {
        return null;
    }

    const normalizedProtectedTb = shouldFormatInput
        ? normalizeProtectedTb(rawValue)
        : (Number.isFinite(parseFloat(rawValue)) ? Math.max(0, parseFloat(rawValue)) : 0);

    workload.protectedTb = normalizedProtectedTb;
    workload.count = calculateUnstructuredDataInstances(workload.protectedTb);
    updateDerivedInstancePreview(siteId, getWorkloadRowId(workload), workload.count);
    updateTotalInstances();
    syncSiteWorkloadStepperState(siteId, workloadIdentifier);

    return shouldFormatInput ? formatProtectedTbValue(workload.protectedTb) : null;
}

function getSiteWorkloadStepperValue(workload) {
    if (!workload || !hasSelectedWorkloadValue(workload.value)) {
        return 0;
    }

    if (isUnstructuredDataWorkload(workload.value)) {
        return normalizeProtectedTb(workload.protectedTb ?? 0);
    }

    return Math.max(0, parseInt(workload.count, 10) || 0);
}

function syncSiteWorkloadStepperState(siteId, workloadIdentifier) {
    const site = getSiteById(siteId);
    const workload = getSiteWorkloadByIdentifier(site, workloadIdentifier);
    const row = siteList.querySelector(
        `[data-site-id="${siteId}"][data-site-workload-row="${workloadIdentifier}"]`
    );

    if (!row) {
        return;
    }

    const isEditable = Boolean(
        workload
        && hasSelectedWorkloadValue(workload.value)
        && !isInDevelopmentWorkloadValue(workload.value)
    );
    const currentValue = getSiteWorkloadStepperValue(workload);

    row.querySelectorAll('[data-site-workload-stepper-direction]').forEach((button) => {
        if (!(button instanceof HTMLButtonElement)) {
            return;
        }

        const direction = Number.parseInt(button.dataset.siteWorkloadStepperDirection, 10);
        button.disabled = !isEditable || (direction < 0 && currentValue <= 0);
    });
}

function nudgeSiteWorkloadStepper(siteId, workloadIdentifier, direction) {
    const site = getSiteById(siteId);
    const workload = getSiteWorkloadByIdentifier(site, workloadIdentifier);

    if (!workload || !hasSelectedWorkloadValue(workload.value) || isInDevelopmentWorkloadValue(workload.value)) {
        return;
    }

    const input = siteList.querySelector(
        `[data-site-id="${siteId}"] [data-site-workload-input="${workloadIdentifier}"]`
    );
    const delta = isUnstructuredDataWorkload(workload.value) ? 0.5 : 1;
    const currentValue = getSiteWorkloadStepperValue(workload);
    const nextValue = Math.max(0, normalizeProtectedTb(currentValue + (direction * delta)));
    const formattedValue = isUnstructuredDataWorkload(workload.value)
        ? updateSiteProtectedTb(siteId, workloadIdentifier, String(nextValue), true)
        : updateSiteWorkloadCount(siteId, workloadIdentifier, String(nextValue), true);

    if (input instanceof HTMLInputElement && formattedValue !== null) {
        input.value = formattedValue;
        input.focus({ preventScroll: true });
        input.select();
    }
}

function setRepoMigrationData(siteId, workloadIdentifier, rawValue, shouldFormatInput = false) {
    const site = getSiteById(siteId);
    if (!site) {
        return null;
    }

    const normalizedProtectedTb = shouldFormatInput
        ? normalizeProtectedTb(rawValue)
        : (Number.isFinite(parseFloat(rawValue)) ? Math.max(0, parseFloat(rawValue)) : 0);
    const workload = getSiteWorkloadByIdentifier(site, workloadIdentifier);

    if (!workload || !isRepoMigrationWorkload(workload.value)) {
        return null;
    }

    workload.protectedTb = normalizedProtectedTb;
    workload.count = calculateUnstructuredDataInstances(normalizedProtectedTb);

    updateTotalInstances();
    updateNonGfNameBarCount();
    syncRepoMigrationStepperState(siteId, workloadIdentifier);
    return shouldFormatInput ? formatProtectedTbValue(normalizedProtectedTb) : null;
}

function updateSiteExistingEnvironmentField(siteId, field, input, shouldFormatInput = false) {
    const site = getSiteById(siteId);
    if (!site || !field || !Object.hasOwn(existingEnvironmentFieldLabels, field)) {
        return null;
    }

    if (input instanceof HTMLInputElement && input.type === 'checkbox') {
        if (toggleValue(input) === 'yes') {
            site.existingEnvironment[field] = 'yes';
        } else {
            delete site.existingEnvironment[field];
            clearExistingEnvironmentDependentFields(site.existingEnvironment, field);
        }

        if (field === 'vbrServers') {
            applyDefaultVbrChildRows(site.existingEnvironment);
        }

        site.existingEnvironment = pruneExistingEnvironmentState(site.existingEnvironment);

        if (shouldFormatInput) {
            updateToggleLabel(input);
        }
        return null;
    }

    const nextValue = normalizeEnvironmentCount(input.value);
    if (nextValue > 0) {
        site.existingEnvironment[field] = nextValue;
    } else {
        delete site.existingEnvironment[field];
    }

    site.existingEnvironment = pruneExistingEnvironmentState(site.existingEnvironment);
    site.existingEnvironmentCustomLabels = pruneExistingEnvironmentCustomLabels(
        site.existingEnvironmentCustomLabels,
        site.existingEnvironment
    );
    syncExistingEnvironmentStepperState(siteId, field);
    return shouldFormatInput ? String(nextValue) : null;
}

function updateSiteExistingEnvironmentCustomLabel(siteId, field, rawValue, shouldFormatInput = false) {
    const site = getSiteById(siteId);
    if (!site || !field || !Object.hasOwn(existingEnvironmentFieldLabels, field)) {
        return null;
    }

    const nextValue = shouldFormatInput ? normalizeExistingEnvironmentCustomLabel(rawValue) : String(rawValue);
    const normalizedCustomLabels = normalizeExistingEnvironmentCustomLabels(site.existingEnvironmentCustomLabels);

    if (normalizeExistingEnvironmentCustomLabel(nextValue)) {
        normalizedCustomLabels[field] = nextValue;
    } else {
        delete normalizedCustomLabels[field];
    }

    site.existingEnvironmentCustomLabels = pruneExistingEnvironmentCustomLabels(
        normalizedCustomLabels,
        site.existingEnvironment
    );

    return shouldFormatInput ? normalizeExistingEnvironmentCustomLabel(nextValue) : null;
}

function syncExistingEnvironmentStepperState(siteId, field) {
    const site = getSiteById(siteId);
    const currentValue = normalizeEnvironmentCount(site?.existingEnvironment?.[field]);

    siteList.querySelectorAll(
        `[data-site-id="${siteId}"][data-site-existing-environment-stepper="${field}"]`
    ).forEach((button) => {
        if (!(button instanceof HTMLButtonElement)) {
            return;
        }

        const direction = Number.parseInt(button.dataset.siteExistingEnvironmentStepperDirection, 10);
        button.disabled = direction < 0 && currentValue <= 0;
    });
}

function syncRepoMigrationStepperState(siteId, workloadIdentifier) {
    const site = getSiteById(siteId);
    const workload = getSiteWorkloadByIdentifier(site, workloadIdentifier);
    const currentValue = getRepoMigrationWorkloadProtectedTb(workload);

    siteList.querySelectorAll(
        `[data-site-id="${siteId}"][data-site-repo-migration-stepper="${workloadIdentifier}"]`
    ).forEach((button) => {
        if (!(button instanceof HTMLButtonElement)) {
            return;
        }

        const direction = Number.parseInt(button.dataset.siteRepoMigrationStepperDirection, 10);
        button.disabled = direction < 0 && currentValue <= 0;
    });
}

function nudgeExistingEnvironmentStepper(siteId, field, direction) {
    const input = siteList.querySelector(
        `[data-site-existing-environment="${field}"][data-site-id="${siteId}"]`
    );

    if (!(input instanceof HTMLInputElement)) {
        return;
    }

    input.value = String(Math.max(0, normalizeEnvironmentCount(input.value) + direction));
    const formattedValue = updateSiteExistingEnvironmentField(siteId, field, input, true);

    if (formattedValue !== null) {
        input.value = formattedValue;
        input.focus({ preventScroll: true });
        input.select();
    }
}

function nudgeRepoMigrationStepper(siteId, workloadIdentifier, direction) {
    const input = siteList.querySelector(
        `[data-site-repo-migration-tb="${workloadIdentifier}"][data-site-id="${siteId}"]`
    );

    if (!(input instanceof HTMLInputElement)) {
        return;
    }

    const nextValue = Math.max(0, normalizeProtectedTb(input.value) + (direction * 0.5));
    const formattedValue = setRepoMigrationData(siteId, workloadIdentifier, String(nextValue), true);

    if (formattedValue !== null) {
        input.value = formattedValue;
        input.focus({ preventScroll: true });
        input.select();
    }
}

function handleWorkloadPickerClick(event) {
    if (!(event.target instanceof Element)) {
        return false;
    }

    const workloadPickerOptionButton = event.target.closest('[data-site-workload-picker-next-value]');
    if (workloadPickerOptionButton) {
        if (workloadPickerOptionButton.hasAttribute('disabled') || workloadPickerOptionButton.classList.contains('workload-disabled')) {
            return true;
        }

        const siteId = parseInt(workloadPickerOptionButton.dataset.siteId, 10);
        const workloadRowId = parseInt(workloadPickerOptionButton.dataset.siteWorkloadPickerRow, 10);
        const nextValue = workloadPickerOptionButton.dataset.siteWorkloadPickerNextValue;

        if (!siteId || !workloadRowId || nextValue === undefined) {
            return true;
        }

        const site = getSiteById(siteId);
        const workload = getSiteWorkloadByRowId(site, workloadRowId);
        const currentValue = workload?.value || '';

        if (currentValue === nextValue) {
            closeWorkloadPicker(siteId, workloadRowId);
            siteList.querySelector(getSiteWorkloadPickerTriggerSelector(siteId, workloadRowId))?.focus();
            return true;
        }

        updateSiteWorkloadValue(siteId, workloadRowId, nextValue);
        return true;
    }

    const workloadPickerCategoryButton = event.target.closest('[data-site-workload-picker-category-row]');
    if (workloadPickerCategoryButton) {
        const siteId = parseInt(workloadPickerCategoryButton.dataset.siteId, 10);
        const workloadRowId = parseInt(workloadPickerCategoryButton.dataset.siteWorkloadPickerCategoryRow, 10);
        const groupLabel = workloadPickerCategoryButton.dataset.workloadPickerCategoryLabel;

        if (!siteId || !workloadRowId || !groupLabel) {
            return true;
        }

        const site = getSiteById(siteId);
        const workload = getSiteWorkloadByRowId(site, workloadRowId);
        if (!workload) {
            return true;
        }

        toggleWorkloadPickerCategoryExpansion(siteId, workloadRowId, workload.value, groupLabel);
        syncWorkloadPickerPanelState(workloadPickerPortalHost, siteId, workloadRowId);
        scheduleOpenWorkloadPickerPanelPosition();
        return true;
    }

    const workloadPickerTriggerButton = event.target.closest('[data-site-workload-picker-trigger]');
    if (workloadPickerTriggerButton) {
        const siteId = parseInt(workloadPickerTriggerButton.dataset.siteId, 10);
        const workloadRowId = parseInt(workloadPickerTriggerButton.dataset.siteWorkloadPickerTrigger, 10);

        if (!siteId || !workloadRowId) {
            return true;
        }

        if (isWorkloadPickerOpen(siteId, workloadRowId)) {
            closeWorkloadPicker(siteId, workloadRowId);
            workloadPickerTriggerButton.focus();
            return true;
        }

        openWorkloadPicker(siteId, workloadRowId);
        return true;
    }

    return false;
}

function handleWorkloadPickerKeydown(event) {
    const target = event.target;
    if (!(target instanceof HTMLElement)) {
        return false;
    }

    const pickerElement = target.closest('[data-workload-picker-key]');
    if (pickerElement && event.key === 'Escape') {
        const pickerKey = pickerElement.dataset.workloadPickerKey;
        const parsedKey = parseWorkloadPickerKey(pickerKey);

        if (parsedKey) {
            event.preventDefault();
            closeWorkloadPicker(parsedKey.siteId, parsedKey.workloadRowId);
            siteList.querySelector(getSiteWorkloadPickerTriggerSelector(parsedKey.siteId, parsedKey.workloadRowId))?.focus();
        }
        return true;
    }

    if (target.matches('[data-site-workload-picker-search]') && event.key === 'Enter') {
        event.preventDefault();
        return true;
    }

    return false;
}

function handleWorkloadPickerInput(event) {
    const target = event.target;
    if (!(target instanceof HTMLElement) || !target.matches('[data-site-workload-picker-search]')) {
        return false;
    }

    const input = target;
    const siteId = parseInt(input.dataset.siteId, 10);
    const workloadRowId = parseInt(input.dataset.siteWorkloadPickerSearch, 10);

    if (!siteId || !workloadRowId) {
        return true;
    }

    setWorkloadPickerSearchQuery(siteId, workloadRowId, input.value);
    syncWorkloadPickerPanelState(workloadPickerPortalHost, siteId, workloadRowId);
    scheduleOpenWorkloadPickerPanelPosition();
    return true;
}

function handleWorkloadPickerFocusOut(event) {
    const target = event.target;

    if (!(target instanceof HTMLElement)) {
        return;
    }

    const pickerElement = target.closest('[data-workload-picker-key]');
    if (!pickerElement) {
        return;
    }

    const pickerKey = pickerElement.dataset.workloadPickerKey;
    window.setTimeout(() => {
        if (!pickerKey || workloadPickerUiState.openKey !== pickerKey) {
            return;
        }

        if (!isActiveElementWithinWorkloadPicker(pickerKey)) {
            closeWorkloadPicker();
        }
    }, 0);
}

siteList.addEventListener('click', (event) => {
    const existingEnvironmentStepperButton = event.target.closest('[data-site-existing-environment-stepper-direction]');
    if (existingEnvironmentStepperButton) {
        clearStepValidationMessage();
        const siteId = parseInt(existingEnvironmentStepperButton.dataset.siteId, 10);
        const field = existingEnvironmentStepperButton.dataset.siteExistingEnvironmentStepper;
        const direction = parseInt(existingEnvironmentStepperButton.dataset.siteExistingEnvironmentStepperDirection, 10);
        nudgeExistingEnvironmentStepper(siteId, field, direction);
        return;
    }

    const repoMigrationStepperButton = event.target.closest('[data-site-repo-migration-stepper-direction]');
    if (repoMigrationStepperButton) {
        clearStepValidationMessage();
        const siteId = parseInt(repoMigrationStepperButton.dataset.siteId, 10);
        const workloadIdentifier = repoMigrationStepperButton.dataset.siteRepoMigrationStepper;
        const direction = parseInt(repoMigrationStepperButton.dataset.siteRepoMigrationStepperDirection, 10);
        nudgeRepoMigrationStepper(siteId, workloadIdentifier, direction);
        return;
    }

    const workloadStepperButton = event.target.closest('[data-site-workload-stepper-direction]');
    if (workloadStepperButton) {
        clearStepValidationMessage();
        const siteId = parseInt(workloadStepperButton.dataset.siteId, 10);
        const workloadIdentifier = workloadStepperButton.dataset.siteWorkloadStepper;
        const direction = parseInt(workloadStepperButton.dataset.siteWorkloadStepperDirection, 10);
        nudgeSiteWorkloadStepper(siteId, workloadIdentifier, direction);
        return;
    }

    const removeWorkloadButton = event.target.closest('[data-site-remove-workload]');
    if (removeWorkloadButton) {
        const siteId = parseInt(removeWorkloadButton.dataset.siteId, 10);
        removeWorkloadFromSite(siteId, removeWorkloadButton.dataset.siteRemoveWorkload);
        return;
    }

    if (handleWorkloadPickerClick(event)) {
        return;
    }

    if (handleSiteScopePickerClick(event)) {
        return;
    }

    const removeExistingEnvironmentButton = event.target.closest('[data-site-remove-existing-environment]');
    if (removeExistingEnvironmentButton) {
        const siteId = parseInt(removeExistingEnvironmentButton.dataset.siteId, 10);
        removeExistingEnvironmentFieldFromSite(siteId, removeExistingEnvironmentButton.dataset.siteRemoveExistingEnvironment);
        return;
    }

    const decrementExistingEnvironmentButton = event.target.closest('[data-site-decrement-existing-environment]');
    if (decrementExistingEnvironmentButton) {
        const siteId = parseInt(decrementExistingEnvironmentButton.dataset.siteId, 10);
        decrementExistingEnvironmentFieldOnSite(siteId, decrementExistingEnvironmentButton.dataset.siteDecrementExistingEnvironment);
        return;
    }

    const actionButton = event.target.closest('[data-site-action]');
    if (!actionButton) {
        return;
    }

    if (actionButton.dataset.siteAction === 'add-site-inline') {
        addSiteFromInlineControl();
        return;
    }

    const siteId = parseInt(actionButton.dataset.siteId, 10);

    if (actionButton.dataset.siteAction === 'open-site-drawer') {
        const mode = actionButton.dataset.drawerMode || 'greenfield';
        openGfDrawer(siteId, mode);
        return;
    }

    if (actionButton.dataset.siteAction === 'add-inline-workload') {
        addInlineWorkloadToSite(siteId);
        return;
    }

    if (actionButton.dataset.siteAction === 'add-inline-repo-migration') {
        addInlineRepoMigrationToSite(siteId);
        return;
    }

    if (actionButton.dataset.siteAction === 'add-inline-existing-environment') {
        addInlineExistingEnvironmentToSite(siteId);
        return;
    }

    if (actionButton.dataset.siteAction === 'remove-site') {
        removeSite(siteId);
        return;
    }

    if (actionButton.dataset.siteAction === 'clone-site') {
        triggerCloneSheepAnimation(siteId);
        cloneSite(siteId);
        return;
    }

    if (actionButton.dataset.siteAction === 'add-workload') {
        const select = siteList.querySelector(`[data-site-workload-select="${siteId}"]`);
        addWorkloadToSite(siteId, select?.value || '');
    }
});

siteList.addEventListener('keydown', (event) => {
    const target = event.target;

    if (handleWorkloadPickerKeydown(event)) {
        return;
    }

    if (handleSiteScopePickerKeydown(event)) {
        return;
    }

    if (!(target instanceof HTMLElement)) {
        return;
    }

    // Handle contenteditable site-name spans in table-based engagement types
    if (target.matches('[data-gf-site-name]')) {
        const siteId = parseInt(target.dataset.gfSiteName, 10);
        if (event.key === 'Enter') {
            event.preventDefault();
            target.blur();
        } else if (event.key === 'Escape') {
            const siteIndex = getSiteIndexById(siteId);
            if (siteIndex !== -1) {
                const site = sites[siteIndex];
                target.textContent = getSiteDisplayName(site, siteIndex);
            }
            target.blur();
        }
        return;
    }

    // Enter/Escape for EE and Vault inline chip label editing
    if (target.matches('[data-ee-chip-inline-label]') || target.matches('[data-vault-chip-inline-label]')) {
        if (event.key === 'Enter') {
            event.preventDefault();
            target.blur();
        } else if (event.key === 'Escape') {
            target.textContent = target.dataset.chipPreEditValue || target.dataset.chipDefaultLabel || '';
            target.blur();
        }
        return;
    }

    if (!(target instanceof HTMLInputElement) || !target.matches('[data-site-name]')) {
        return;
    }

    const siteId = parseInt(target.dataset.siteName, 10);
    if (event.key === 'Enter') {
        event.preventDefault();
        target.blur();
        return;
    }

    if (event.key === 'Escape') {
        event.preventDefault();
        const siteIndex = getSiteIndexById(siteId);
        if (siteIndex !== -1) {
            const site = sites[siteIndex];
            site.renameDraft = site.name;
            target.value = getSiteRenameDraft(site, siteIndex);
        }
        target.blur();
    }
});

siteList.addEventListener('change', (event) => {
    const target = event.target;

    if (!(target instanceof HTMLElement)) {
        return;
    }

    clearStepValidationMessage();

    if (target.matches('[data-site-workload-select]')) {
        updateSiteActionStates();
        return;
    }

    if (target.matches('[data-site-existing-environment-picker]')) {
        updateSiteExistingEnvironmentValue(
            parseInt(target.dataset.siteId, 10),
            target.dataset.siteExistingEnvironmentPicker,
            target.value
        );
        return;
    }

    if (target.matches('[data-site-name]')) {
        const input = target;
        validateSiteNameControl(input, parseInt(input.dataset.siteName, 10));
        commitSiteName(parseInt(input.dataset.siteName, 10), input);
        return;
    }

    if (target.matches('[data-site-workload-count]')) {
        const input = target;
        const formattedValue = updateSiteWorkloadCount(
            parseInt(input.dataset.siteId, 10),
            input.dataset.siteWorkloadCount,
            input.value,
            true
        );
        if (formattedValue !== null) {
            input.value = formattedValue;
        }
        return;
    }

    if (target.matches('[data-site-workload-custom-label]')) {
        const input = target;
        const formattedValue = updateSiteWorkloadCustomLabel(
            parseInt(input.dataset.siteId, 10),
            input.dataset.siteWorkloadCustomLabel,
            input.value,
            true
        );
        if (formattedValue !== null) {
            input.value = formattedValue;
        }
        return;
    }

    if (target.matches('[data-site-existing-environment-custom-label]')) {
        const input = target;
        const formattedValue = updateSiteExistingEnvironmentCustomLabel(
            parseInt(input.dataset.siteId, 10),
            input.dataset.siteExistingEnvironmentCustomLabel,
            input.value,
            true
        );
        if (formattedValue !== null) {
            input.value = formattedValue;
        }
        return;
    }

    if (target.matches('[data-site-workload-protected-tb]')) {
        const input = target;
        const formattedValue = updateSiteProtectedTb(
            parseInt(input.dataset.siteId, 10),
            input.dataset.siteWorkloadProtectedTb,
            input.value,
            true
        );
        if (formattedValue !== null) {
            input.value = formattedValue;
        }
        return;
    }

    if (target.matches('[data-site-repo-migration-tb]')) {
        const input = target;
        const siteId = parseInt(input.dataset.siteId, 10);
        input.value = setRepoMigrationData(siteId, input.dataset.siteRepoMigrationTb, input.value, true) || '0';
        return;
    }

    if (target.matches('[data-site-vdc-vault-source-storage-type]')) {
        const input = target;
        const siteId = parseInt(input.dataset.siteId, 10);
        const site = getSiteById(siteId);
        const workload = getSiteWorkloadByIdentifier(site, input.dataset.siteVdcVaultSourceStorageType);
        if (workload) {
            workload.vdcVaultSourceStorageType = input.value;
        }
        return;
    }

    if (target.matches('[data-site-vdc-vault-repository-type]')) {
        const input = target;
        const siteId = parseInt(input.dataset.siteId, 10);
        const site = getSiteById(siteId);
        const workload = getSiteWorkloadByIdentifier(site, input.dataset.siteVdcVaultRepositoryType);
        if (workload) {
            workload.vdcVaultRepositoryType = input.value;
        }
        return;
    }

    if (target.matches('[data-site-vdc-vault-target-vault]')) {
        const input = target;
        const siteId = parseInt(input.dataset.siteId, 10);
        const site = getSiteById(siteId);
        const workload = getSiteWorkloadByIdentifier(site, input.dataset.siteVdcVaultTargetVault);
        if (workload) {
            workload.vdcVaultTargetVault = input.value;
        }
        return;
    }

    if (target.matches('[data-ee-chip-platform]')) {
        const siteId = parseInt(target.dataset.siteId, 10);
        const field  = target.dataset.eeChipPlatform;
        const value  = target.value;
        const site   = getSiteById(siteId);
        if (site && (value === 'windows' || value === 'linux') && field in site) {
            site[field] = value;
            scheduleRenderEstimate();
        }
        return;
    }


    if (target.matches('[data-site-existing-environment]')) {
        const input = target;
        const siteId = parseInt(input.dataset.siteId, 10);
        const field = input.dataset.siteExistingEnvironment;
        const formattedValue = updateSiteExistingEnvironmentField(
            siteId,
            field,
            input,
            true
        );
        if (field === 'vbrServers') {
            renderSiteCard(siteId, `[data-site-existing-environment="${field}"]`);
            return;
        }
        if (formattedValue !== null) {
            input.value = formattedValue;
        }
    }
});

siteList.addEventListener('input', (event) => {
    const target = event.target;

    if (!(target instanceof HTMLElement)) {
        return;
    }

    clearStepValidationMessage();

    if (handleWorkloadPickerInput(event)) {
        return;
    }

    if (handleSiteScopePickerInput(event)) {
        return;
    }

    if (target.matches('[data-gf-site-name]')) {
        updateSiteNameDraft(parseInt(target.dataset.gfSiteName, 10), target.textContent.trim());
        return;
    }

    if (target.matches('[data-site-name]')) {
        const input = target;
        validateSiteNameControl(input, parseInt(input.dataset.siteName, 10));
        updateSiteNameDraft(parseInt(input.dataset.siteName, 10), input.value);
        return;
    }

    if (target.matches('[data-site-workload-count]')) {
        const input = target;
        updateSiteWorkloadCount(parseInt(input.dataset.siteId, 10), input.dataset.siteWorkloadCount, input.value);
        return;
    }

    if (target.matches('[data-site-workload-custom-label]')) {
        const input = target;
        updateSiteWorkloadCustomLabel(
            parseInt(input.dataset.siteId, 10),
            input.dataset.siteWorkloadCustomLabel,
            input.value
        );
        return;
    }

    if (target.matches('[data-site-existing-environment-custom-label]')) {
        const input = target;
        updateSiteExistingEnvironmentCustomLabel(
            parseInt(input.dataset.siteId, 10),
            input.dataset.siteExistingEnvironmentCustomLabel,
            input.value
        );
        return;
    }

    if (target.matches('[data-site-workload-protected-tb]')) {
        const input = target;
        updateSiteProtectedTb(parseInt(input.dataset.siteId, 10), input.dataset.siteWorkloadProtectedTb, input.value);
        return;
    }

    if (target.matches('[data-site-repo-migration-tb]')) {
        const input = target;
        const siteId = parseInt(input.dataset.siteId, 10);
        setRepoMigrationData(siteId, input.dataset.siteRepoMigrationTb, input.value, false);
        input.style.width = Math.max(2, input.value.length || 2) + 'ch';
        return;
    }

    if (target.matches('[data-site-existing-environment]')) {
        const input = target;
        const field = input.dataset.siteExistingEnvironment;
        updateSiteExistingEnvironmentField(parseInt(input.dataset.siteId, 10), field, input);
        input.style.width = Math.max(2, input.value.length || 2) + 'ch';
        return;
    }
});

siteList.addEventListener('focusin', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    if (target.matches('[data-ee-chip-inline-label]') || target.matches('[data-vault-chip-inline-label]')) {
        target.dataset.chipPreEditValue = target.textContent.trim();
    }
});

siteList.addEventListener('focusout', (event) => {
    handleWorkloadPickerFocusOut(event);
    handleSiteScopePickerFocusOut(event);

    const target = event.target;
    if (!(target instanceof HTMLElement)) return;

    // Commit site name edits from contenteditable spans in table-based engagement types
    if (target.matches('[data-gf-site-name]')) {
        const siteId = parseInt(target.dataset.gfSiteName, 10);
        const site = getSiteById(siteId);
        if (!site) return;
        const newName = target.textContent.trim();
        if (newName !== site.name) {
            site.name = newName;
            site.renameDraft = newName;
            updateTotalInstances();
            updateWorkloadValidationState();
        }
        return;
    }

    // Commit EE chip inline label edits
    if (target.matches('[data-ee-chip-inline-label]')) {
        const siteId = parseInt(target.dataset.siteId, 10);
        const key = target.dataset.eeChipInlineLabel;
        const defaultLabel = target.dataset.chipDefaultLabel || '';
        const trimmed = target.textContent.trim();
        if (!trimmed) target.textContent = defaultLabel;
        updateSiteExistingEnvironmentCustomLabel(siteId, key, trimmed === defaultLabel ? '' : trimmed);
        return;
    }

    // Commit Vault chip inline label edits
    if (target.matches('[data-vault-chip-inline-label]')) {
        const siteId = parseInt(target.dataset.siteId, 10);
        const rowId = parseInt(target.dataset.vaultChipInlineLabel, 10);
        const defaultLabel = target.dataset.chipDefaultLabel || '';
        const trimmed = target.textContent.trim();
        if (!trimmed) target.textContent = defaultLabel;
        updateVaultWorkloadCustomLabel(siteId, rowId, trimmed === defaultLabel ? '' : trimmed);
        return;
    }
});

workloadPickerPortalHost.addEventListener('click', (event) => {
    handleWorkloadPickerClick(event);
});

workloadPickerPortalHost.addEventListener('keydown', (event) => {
    handleWorkloadPickerKeydown(event);
});

workloadPickerPortalHost.addEventListener('input', (event) => {
    handleWorkloadPickerInput(event);
});

workloadPickerPortalHost.addEventListener('focusout', (event) => {
    handleWorkloadPickerFocusOut(event);
});

window.addEventListener('resize', () => {
    scheduleOpenWorkloadPickerPanelPosition();
    scheduleOpenSiteScopePickerPanelPosition();
}, { passive: true });

window.addEventListener('scroll', () => {
    scheduleOpenWorkloadPickerPanelPosition();
    scheduleOpenSiteScopePickerPanelPosition();
}, { passive: true });

siteList.addEventListener('scroll', () => {
    scheduleOpenWorkloadPickerPanelPosition();
    scheduleOpenSiteScopePickerPanelPosition();
}, { passive: true });

// §JOB-SERVER-PICKER
document.addEventListener('click', (event) => {
    if (!workloadPickerUiState.openKey || !(event.target instanceof Element)) {
        return;
    }

    if (event.target.closest('[data-site-workload-picker-root]') || event.target.closest('.workload-picker-portal-host')) {
        return;
    }

    closeWorkloadPicker();
});

document.addEventListener('click', (event) => {
    if (!siteScopePickerUiState.openKey || !(event.target instanceof Element)) {
        return;
    }

    if (event.target.closest('[data-site-scope-picker-root]') || event.target.closest('.workload-picker-portal-host')) {
        return;
    }

    closeSiteScopePicker();
});

// ── Job server-link picker — document-level events ────────────────────────────

// Server option selected inside the picker portal
document.addEventListener('click', (e) => {
    const optBtn = e.target.closest('[data-gf-job-server-select]');
    if (!optBtn) return;
    const rawId  = optBtn.dataset.gfJobServerSelect;
    const jobId  = parseInt(optBtn.dataset.gfJobServerSelectJob,  10);
    const siteId = parseInt(optBtn.dataset.gfJobServerSelectSite, 10);
    closeJobServerPicker();
    setJobManagedByInstance(siteId, jobId, rawId === 'null' ? null : rawId);
});

// Cancel / close button inside the picker portal
document.addEventListener('click', (e) => {
    if (e.target.closest('[data-gf-job-server-picker-close]')) {
        closeJobServerPicker();
    }
});

// Outside-click: close picker if user clicks away from both portal and trigger chip
document.addEventListener('click', (e) => {
    if (!getJobServerPickerState()) return;
    const portal = document.getElementById('gf-job-server-picker-portal');
    if (!portal || portal.hidden) return;
    if (portal.contains(e.target)) return;
    if (getJobServerPickerState()?.anchorEl?.contains(e.target)) return;
    // also keep open if clicking the parent server-tag span (linked state)
    if (e.target.closest('[data-gf-job-server-tag]')) return;
    closeJobServerPicker();
});

// Escape key: close picker
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && getJobServerPickerState()) closeJobServerPicker();
});

exportJsonBtn.addEventListener('click', () => {
    const estimatorState = getEstimatorState();
    downloadJsonFile(JSON.stringify(estimatorState, null, 2), buildExportFilename(estimatorState.projectName));
});

importJsonBtn.addEventListener('click', () => {
    importJsonFile.click();
});

importJsonFile.addEventListener('change', async (event) => {
    const [file] = event.target.files || [];
    if (!file) return;

    try {
        const contents = await file.text();
        applyEstimatorState(JSON.parse(contents));
        if (localScenarioNameInput && !normalizeLocalScenarioName(localScenarioNameInput.value)) {
            localScenarioNameInput.value = normalizeLocalScenarioName(projectNameInput.value);
        }
        setLocalScenarioStatus('Imported JSON loaded. Save it locally if you want to keep it on this workstation.');
    } catch (error) {
        window.alert(error instanceof Error ? error.message : 'Unable to import estimator JSON.');
    } finally {
        importJsonFile.value = '';
    }
});

themeToggle.addEventListener('click', () => {
    const currentTheme = document.body.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    applyTheme(currentTheme === 'dark' ? 'light' : 'dark');
});

projectNameInput.addEventListener('input', () => {
    projectNameInput.setCustomValidity('');
});

localScenarioSelect?.addEventListener('change', () => {
    const selectedName = normalizeLocalScenarioName(localScenarioSelect.value);
    if (localScenarioNameInput && selectedName) {
        localScenarioNameInput.value = selectedName;
    }
});

// Save/Load/Delete are handled via the scenario-nav-popover confirm button below.

applyBuildInfo();

// --- Dev mode toggle (triple-click version string in footer) ---
(function initDevModeToggle() {
    const versionEl = document.getElementById('app-version');
    const devOutput = document.getElementById('dev-mode-output');
    if (!versionEl) return;

    let clickCount = 0;
    let clickTimer = null;
    versionEl.addEventListener('click', () => {
        clickCount++;
        clearTimeout(clickTimer);
        clickTimer = setTimeout(() => { clickCount = 0; }, 800);
        if (clickCount >= 3) {
            clickCount = 0;
            clearTimeout(clickTimer);
            AppState.devModeEnabled = !AppState.devModeEnabled;
            document.body.classList.toggle('dev-mode-active', AppState.devModeEnabled);
            if (devOutput) {
                if (AppState.devModeEnabled) {
                    devOutput.innerHTML = `
                        <section class="formula-debug-panel">
                            <details open>
                                <summary class="fdbg-header">
                                    <span class="fdbg-badge">⚙ DEV</span>
                                    <span class="fdbg-title">Formula Debug</span>
                                    <span class="fdbg-meta"><em>triple-click version to hide</em></span>
                                    <span class="fdbg-collapse-hint"></span>
                                </summary>
                                <div class="fdbg-body">
                                    <input type="radio" id="fdbg-e1" name="fdbg-early-tabs" class="fdbg-radio" checked>
                                    <input type="radio" id="fdbg-e2" name="fdbg-early-tabs" class="fdbg-radio">
                                    <div class="fdbg-tab-bar">
                                        <label class="fdbg-tab-label" for="fdbg-e1">Block Tables</label>
                                        <label class="fdbg-tab-label" for="fdbg-e2">Live Calculator</label>
                                    </div>
                                    <div class="fdbg-panel fdbg-panel--blocks">${buildBlockTablesMarkup()}</div>
                                    <div class="fdbg-panel fdbg-panel--calc">${buildLiveCalculatorMarkup()}</div>
                                </div>
                            </details>
                        </section>`;
                } else {
                    devOutput.innerHTML = '';
                }
            }
            if (isStep3Ready()) {
                scheduleRenderEstimate();
            }
        }
    });
}());
// --- End dev mode toggle ---

prevStepBtn.addEventListener('click', () => {
    if (AppState.currentStep > 1) {
        setCurrentStep(AppState.currentStep - 1);
    }
});

wizardProgressButtons.forEach((button) => {
    button.addEventListener('click', () => {
        const targetStep = parseInt(button.dataset.stepTarget, 10);
        if (!Number.isNaN(targetStep) && canNavigateToStep(targetStep)) {
            requestStepNavigation(targetStep);
        }
    });
});

if (step3WarningDialog instanceof HTMLDialogElement) {
    step3WarningDialog.addEventListener('cancel', () => {
        AppState.pendingStepNavigation = null;
    });
}

step3WarningCancelBtn?.addEventListener('click', () => {
    dismissStep3WarningDialog();
});

step3WarningCloseBtn?.addEventListener('click', () => {
    dismissStep3WarningDialog();
});

step3WarningContinueBtn?.addEventListener('click', () => {
    confirmPendingStepNavigation();
});

resetBtn.addEventListener('click', () => {
    resetStep2CollapseState();
    form.reset();
    setVeeamOneRequiredValue('no');
    projectNameInput.setCustomValidity('');
    setBackupVerificationValue('yes_limited');
    setSureBackupValue('no');
    setSureReplicaValue('no');
    resetSites([{}]);
    resetStep2Canvas();
    resetUpgradeScope();
    applyArchitectureState({}, 1);
    renderSiteList();
    renderEmptyOutput();
    initializeBinaryToggles();
    initializeImplementationModeControl();
    syncCanvasStateDefaults();
    setCurrentStep(1);
    setLocalScenarioStatus('Form reset. Local scenarios remain available until you clear them.');
});

form.addEventListener('submit', function (event) {
    event.preventDefault();

    if (AppState.currentStep < totalSteps) {
        if (!validateStep(AppState.currentStep)) {
            return;
        }

        requestStepNavigation(AppState.currentStep + 1);
        return;
    }

    if (!hasSelectedWorkloads()) {
        reportMissingWorkloads();
        return;
    }

    if (!hasCompleteSiteWorkloads()) {
        reportIncompleteSites();
        return;
    }

    updateWorkloadValidationState();
    renderEstimate();
});

// --- Scenario nav popover (Save / Load / Delete) ---
(function initScenarioNavPopover() {
    const popover = document.getElementById('scenario-nav-popover');
    const confirmBtn = document.getElementById('scenario-popover-confirm-btn');
    const cancelBtn = document.getElementById('scenario-popover-cancel-btn');
    const nameInput = document.getElementById('local-scenario-name');
    const selectInput = document.getElementById('local-scenario-select');
    if (!popover) return;

    let activeMode = null; // 'save' | 'load' | 'delete'

    function openPopover(mode, anchorBtn) {
        activeMode = mode;
        // Position popover vertically aligned to the anchor button
        const rect = anchorBtn.getBoundingClientRect();
        const popoverHeight = 160; // approximate; real height calculated after show
        let top = rect.top;
        // Clamp so popover doesn't go off-screen bottom
        if (top + popoverHeight > window.innerHeight - 16) {
            top = window.innerHeight - popoverHeight - 16;
        }
        popover.style.top = `${Math.max(8, top)}px`;
        popover.hidden = false;

        // Show correct input
        if (nameInput) nameInput.style.display = (mode === 'save') ? '' : 'none';
        if (selectInput) selectInput.style.display = (mode === 'load' || mode === 'delete') ? '' : 'none';

        // Label the confirm button
        if (confirmBtn) {
            confirmBtn.textContent = mode === 'save' ? 'Save' : mode === 'load' ? 'Load' : 'Delete';
        }

        // Clear status
        setLocalScenarioStatus('');

        // Focus the relevant input
        requestAnimationFrame(() => {
            if (mode === 'save') nameInput?.focus();
            else selectInput?.focus();
        });
    }

    function closePopover() {
        popover.hidden = true;
        activeMode = null;
    }

    function togglePopover(mode, anchorBtn) {
        if (!popover.hidden && activeMode === mode) {
            closePopover();
        } else {
            openPopover(mode, anchorBtn);
        }
    }

    // Nav button click handlers
    saveLocalScenarioBtn?.addEventListener('click', (e) => {
        e.stopPropagation();
        togglePopover('save', saveLocalScenarioBtn);
    });

    loadLocalScenarioBtn?.addEventListener('click', (e) => {
        e.stopPropagation();
        togglePopover('load', loadLocalScenarioBtn);
    });

    clearLocalScenarioBtn?.addEventListener('click', (e) => {
        e.stopPropagation();
        togglePopover('delete', clearLocalScenarioBtn);
    });

    // Confirm button
    confirmBtn?.addEventListener('click', () => {
        if (activeMode === 'save') {
            saveLocalScenario();
            // Keep popover open so user can see status; close on success
            const status = document.getElementById('local-scenario-status');
            if (status && status.textContent && !status.textContent.startsWith('Enter') && !status.textContent.startsWith('Unable')) {
                setTimeout(closePopover, 900);
            }
        } else if (activeMode === 'load') {
            loadLocalScenario();
            closePopover();
        } else if (activeMode === 'delete') {
            clearLocalScenario();
            // Keep open to show status / let user delete another
        }
    });

    // Cancel button
    cancelBtn?.addEventListener('click', closePopover);

    // Enter key in name input triggers confirm
    nameInput?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') { e.preventDefault(); confirmBtn?.click(); }
    });

    // Sync name input when select changes (for Load/Delete)
    selectInput?.addEventListener('change', () => {
        const selectedName = normalizeLocalScenarioName(selectInput.value);
        if (nameInput && selectedName) nameInput.value = selectedName;
    });

    // Close on outside click
    document.addEventListener('click', (e) => {
        if (popover.hidden) return;
        const nav = document.getElementById('scenario-nav');
        if (!popover.contains(e.target) && !nav?.contains(e.target)) {
            closePopover();
        }
    }, true);

    // Close on Escape
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !popover.hidden) closePopover();
    });
}());
// --- End scenario nav popover ---

output.addEventListener('input', handleCategoryAdjustInput);
output.addEventListener('click', (event) => {
    const header = event.target.closest('[data-expand-phase]');
    if (!header) return;
    const phaseId = header.dataset.expandPhase;
    if (expandedPhaseIds.has(phaseId)) expandedPhaseIds.delete(phaseId);
    else expandedPhaseIds.add(phaseId);
    scheduleRenderEstimate();
});
output.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const header = event.target.closest('[data-expand-phase]');
    if (!header) return;
    event.preventDefault();
    header.click();
});
// Sub-item hour adjustment — ± button steppers, inline DOM update + full re-render
output.addEventListener('click', (event) => {
    const btn = event.target.closest('button[data-sub-step]');
    if (!btn) return;
    const subId = btn.dataset.subItemId;
    const rec   = parseInt(btn.dataset.subItemRec, 10) || 0;
    const step  = parseInt(btn.dataset.subStep, 10);
    const current = subItemHourAdjustments.has(subId) ? subItemHourAdjustments.get(subId) : rec;
    const val   = Math.max(0, current + step);
    if (val === rec) subItemHourAdjustments.delete(subId);
    else             subItemHourAdjustments.set(subId, val);

    // 1. Update the value display
    const adjEl = btn.closest('.phase-card__sub-adj');
    const valEl = adjEl && adjEl.querySelector(`[data-sub-val-id="${subId}"]`);
    if (valEl) valEl.textContent = val;

    // 2. Disable the − button at zero
    const decBtn = adjEl && adjEl.querySelector('[data-sub-step="-1"]');
    if (decBtn) decBtn.disabled = val <= 0;

    // 3. Toggle modified state — amber value + struck-out original, no DOM insertion so buttons never shift
    const delta = val - rec;
    const li = btn.closest('.phase-card__sub-item');
    if (li) li.classList.toggle('phase-card__sub-item--modified', delta !== 0);

    // 4. Recompute this phase card's adjusted total and update its metric
    const article = btn.closest('article.phase-card');
    if (article) {
        let phaseAdj = 0, phaseRec = 0;
        article.querySelectorAll('button[data-sub-step="1"]').forEach(b => {
            const id  = b.dataset.subItemId;
            const r   = parseInt(b.dataset.subItemRec, 10) || 0;
            const adj = subItemHourAdjustments.has(id) ? subItemHourAdjustments.get(id) : r;
            phaseAdj += adj;
            phaseRec += r;
        });
        const hrsEl  = article.querySelector('.phase-card__metric .phase-card__hrs');
        const daysEl = article.querySelector('.phase-card__metric .phase-card__days');
        if (hrsEl)  hrsEl.textContent  = phaseAdj;
        if (daysEl) daysEl.textContent = phaseAdj > 0 ? `${Math.ceil(phaseAdj / 8)} days` : '0 days';
        const metricEl = article.querySelector('.phase-card__metric');
        if (metricEl) {
            let pb = metricEl.querySelector('.phase-card__adj-tag');
            const pd = phaseAdj - phaseRec;
            if (pd !== 0) {
                if (!pb) { pb = document.createElement('span'); metricEl.appendChild(pb); }
                pb.className = `phase-card__adj-tag phase-card__adj-tag--${pd > 0 ? 'increase' : 'decrease'}`;
                pb.textContent = `${pd > 0 ? '+' : ''}${pd} hrs`;
            } else if (pb) { pb.remove(); }
        }
    }

    // 5. Recompute grand total across all phase cards and update summary
    let grandAdj = window.lastPmOverheadHours || 0;
    output.querySelectorAll('article.phase-card[data-phase-id]').forEach(card => {
        card.querySelectorAll('button[data-sub-step="1"]').forEach(b => {
            const id  = b.dataset.subItemId;
            const r   = parseInt(b.dataset.subItemRec, 10) || 0;
            grandAdj += subItemHourAdjustments.has(id) ? subItemHourAdjustments.get(id) : r;
        });
    });
    const rec_total = window.lastTotalRecommendedHours || 0;
    const grandDelta = grandAdj - rec_total;
    const effortEl = document.getElementById('summary-effort-value');
    const metaEl   = document.getElementById('summary-effort-meta');
    if (effortEl) effortEl.textContent = `${grandAdj} hours`;
    if (metaEl) {
        const days = Math.ceil(grandAdj / 8);
        const badgeHtml = grandDelta !== 0
            ? ` · <span class="results-metric-card__adj-tag results-metric-card__adj-tag--${grandDelta > 0 ? 'increase' : 'decrease'}">${grandDelta > 0 ? '+' : ''}${grandDelta} hrs adjusted</span>`
            : '';
        metaEl.innerHTML = `${days} delivery days${badgeHtml}`;
    }
    scheduleRenderEstimate();
});
output.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-item-exclude]');
    if (!btn) return;
    const item = btn.dataset.itemExclude;
    if (item === 'pm') {
        window.pmExcluded = !window.pmExcluded;
        if (window.pmExcluded) categoryHourAdjustments.set('project-management', 0);
        else categoryHourAdjustments.delete('project-management');
    }
    if (item === 'contingency') {
        window.contingencyExcluded = !window.contingencyExcluded;
        if (window.contingencyExcluded) categoryHourAdjustments.set('contingency', 0);
        else categoryHourAdjustments.delete('contingency');
    }
    scheduleRenderEstimate();
});

// Step 2 canvas functions and state live in step2-canvas.js (imported above).

resetSites([{}]);
renderSiteList({ animate: true });
initSourceWorkloadPane();   // source-workload-pane.js — sets up pane DOM refs + events
initializeTheme();
initializeBinaryToggles();
// Wire template-jobs and impl-delivery-style:
// Wire impl-delivery-style radio → recalc (template design is derived from this, no toggle needed)
document.querySelectorAll('input[name="impl-delivery-style"]').forEach((radio) => {
    radio.addEventListener('change', () => scheduleRenderEstimate());
});
// Wire custom risks/constraints textarea to trigger a recalc on input
(function () {
    const _el = document.getElementById('custom-risks-notes');
    if (_el) {
        _el.addEventListener('input', () => scheduleRenderEstimate());
    }
}());
initializeImplementationModeControl();
initializeBackupVerificationControl();
initializeSureBackupControl();
initializeSureReplicaControl();
initializeProtectionTiles();
syncCanvasStateDefaults();
bindStep2CollapseEvents();
bindGroupToggleEvents();
applyStep2CollapseState();
initializeStep3ViewModeControl();
updateLocalScenarioControls();
updateWorkloadValidationState();
renderEmptyOutput();
setCurrentStep(1);
updateSavePdfVisibility(1);

// ── Category info tooltip — fixed positioning to escape overflow:hidden ───────
// Uses event delegation so tooltips work on dynamically rendered chip groups.
(function () {
    let activeIcon = null;

    function showTip(icon) {
        const tip = icon.querySelector('.gf-group-info__tip');
        if (!tip) return;
        const rect = icon.getBoundingClientRect();
        // Position below the icon, left-aligned to it but clamped to viewport
        const left = Math.min(rect.left, window.innerWidth - 246);
        tip.style.top  = (rect.bottom + 7) + 'px';
        tip.style.left = left + 'px';
        tip.classList.add('is-visible');
        activeIcon = icon;
    }

    function hideTip(icon) {
        const tip = icon && icon.querySelector('.gf-group-info__tip');
        if (tip) tip.classList.remove('is-visible');
        if (activeIcon === icon) activeIcon = null;
    }

    // Mouse
    document.addEventListener('mouseover', (e) => {
        const icon = e.target.closest('.gf-group-info');
        if (icon) { showTip(icon); return; }
        if (activeIcon && !activeIcon.contains(e.target)) hideTip(activeIcon);
    }, true);

    document.addEventListener('mouseout', (e) => {
        const icon = e.target.closest('.gf-group-info');
        if (icon && !icon.contains(e.relatedTarget)) hideTip(icon);
    }, true);

    // Keyboard
    document.addEventListener('focusin', (e) => {
        const icon = e.target.closest('.gf-group-info');
        if (icon) showTip(icon);
    }, true);

    document.addEventListener('focusout', (e) => {
        const icon = e.target.closest('.gf-group-info');
        if (icon) hideTip(icon);
    }, true);

    // Reposition on scroll/resize
    window.addEventListener('scroll', () => { if (activeIcon) showTip(activeIcon); }, true);
    window.addEventListener('resize', () => { if (activeIcon) showTip(activeIcon); });

})();

// ── VSA HA Chip Pair Highlighting ─────────────────────────────────────────────
// Delegated mouseover/mouseout on the document: when the pointer enters a chip
// that belongs to an HA pair (data-gf-ha-pair-id), highlight all chips sharing
// the same pair ID across all sites — regardless of which site they live in.
(function initHaChipPairHighlight() {
    function getHaChip(target) {
        return target.closest('[data-gf-ha-pair-id]');
    }
    function applyHighlight(pairId, on) {
        document.querySelectorAll(`[data-gf-ha-pair-id="${CSS.escape(pairId)}"]`).forEach((el) => {
            el.classList.toggle('gf-chip--ha-highlight', on);
        });
    }
    // Suppress highlight while any SortableJS drag is in progress.
    // forceFallback mode keeps the original element in the DOM with .gf-chip-ghost applied,
    // and the body gets .is-comp-dragging for comp drags — either check is sufficient.
    function isDragging() {
        return document.body.classList.contains('is-comp-dragging') ||
               !!document.querySelector('.gf-chip-ghost');
    }
    document.addEventListener('mouseover', (e) => {
        if (isDragging()) return;
        const chip = getHaChip(e.target);
        if (!chip) return;
        const pairId = chip.dataset.gfHaPairId;
        if (pairId) applyHighlight(pairId, true);
    }, true);
    document.addEventListener('mouseout', (e) => {
        if (isDragging()) return;
        const chip = getHaChip(e.target);
        if (!chip) return;
        if (e.relatedTarget && chip.contains(e.relatedTarget)) return;
        const pairId = chip.dataset.gfHaPairId;
        if (pairId) applyHighlight(pairId, false);
    }, true);
})();